/*! modernizr 3.3.1 (Custom Build) | MIT *
 * https://modernizr.com/download/?-csstransforms-csstransforms3d-flexbox-placeholder-svg-touchevents-domprefixes-prefixes-setclasses-testallprops-testprop-teststyles !*/
! function(t, e, n) {
    function i(t, e) {
        return typeof t === e
    }

    function o() {
        var t, e, n, o, s, r, a;
        for (var l in b)
            if (b.hasOwnProperty(l)) {
                if (t = [], e = b[l], e.name && (t.push(e.name.toLowerCase()), e.options && e.options.aliases && e.options.aliases.length))
                    for (n = 0; n < e.options.aliases.length; n++) t.push(e.options.aliases[n].toLowerCase());
                for (o = i(e.fn, "function") ? e.fn() : e.fn, s = 0; s < t.length; s++) r = t[s], a = r.split("."), 1 === a.length ? w[a[0]] = o : (!w[a[0]] || w[a[0]] instanceof Boolean || (w[a[0]] = new Boolean(w[a[0]])), w[a[0]][a[1]] = o), y.push((o ? "" : "no-") + a.join("-"))
            }
    }

    function s(t) {
        var e = _.className,
            n = w._config.classPrefix || "";
        if (T && (e = e.baseVal), w._config.enableJSClass) {
            var i = new RegExp("(^|\\s)" + n + "no-js(\\s|$)");
            e = e.replace(i, "$1" + n + "js$2")
        }
        w._config.enableClasses && (e += " " + n + t.join(" " + n), T ? _.className.baseVal = e : _.className = e)
    }

    function r() {
        return "function" != typeof e.createElement ? e.createElement(arguments[0]) : T ? e.createElementNS.call(e, "http://www.w3.org/2000/svg", arguments[0]) : e.createElement.apply(e, arguments)
    }

    function a(t, e) {
        return !!~("" + t).indexOf(e)
    }

    function l(t) {
        return t.replace(/([a-z])-([a-z])/g, function(t, e, n) {
            return e + n.toUpperCase()
        }).replace(/^-/, "")
    }

    function c() {
        var t = e.body;
        return t || (t = r(T ? "svg" : "body"), t.fake = !0), t
    }

    function u(t, n, i, o) {
        var s, a, l, u, h = "modernizr",
            d = r("div"),
            p = c();
        if (parseInt(i, 10))
            for (; i--;) l = r("div"), l.id = o ? o[i] : h + (i + 1), d.appendChild(l);
        return s = r("style"), s.type = "text/css", s.id = "s" + h, (p.fake ? p : d).appendChild(s), p.appendChild(d), s.styleSheet ? s.styleSheet.cssText = t : s.appendChild(e.createTextNode(t)), d.id = h, p.fake && (p.style.background = "", p.style.overflow = "hidden", u = _.style.overflow, _.style.overflow = "hidden", _.appendChild(p)), a = n(d, t), p.fake ? (p.parentNode.removeChild(p), _.style.overflow = u, _.offsetHeight) : d.parentNode.removeChild(d), !!a
    }

    function h(t, e) {
        return function() {
            return t.apply(e, arguments)
        }
    }

    function d(t, e, n) {
        var o;
        for (var s in t)
            if (t[s] in e) return n === !1 ? t[s] : (o = e[t[s]], i(o, "function") ? h(o, n || e) : o);
        return !1
    }

    function p(t) {
        return t.replace(/([A-Z])/g, function(t, e) {
            return "-" + e.toLowerCase()
        }).replace(/^ms-/, "-ms-")
    }

    function f(e, i) {
        var o = e.length;
        if ("CSS" in t && "supports" in t.CSS) {
            for (; o--;)
                if (t.CSS.supports(p(e[o]), i)) return !0;
            return !1
        }
        if ("CSSSupportsRule" in t) {
            for (var s = []; o--;) s.push("(" + p(e[o]) + ":" + i + ")");
            return s = s.join(" or "), u("@supports (" + s + ") { #modernizr { position: absolute; } }", function(t) {
                return "absolute" == getComputedStyle(t, null).position
            })
        }
        return n
    }

    function g(t, e, o, s) {
        function c() {
            h && (delete D.style, delete D.modElem)
        }
        if (s = !i(s, "undefined") && s, !i(o, "undefined")) {
            var u = f(t, o);
            if (!i(u, "undefined")) return u
        }
        for (var h, d, p, g, m, v = ["modernizr", "tspan", "samp"]; !D.style && v.length;) h = !0, D.modElem = r(v.shift()), D.style = D.modElem.style;
        for (p = t.length, d = 0; p > d; d++)
            if (g = t[d], m = D.style[g], a(g, "-") && (g = l(g)), D.style[g] !== n) {
                if (s || i(o, "undefined")) return c(), "pfx" != e || g;
                try {
                    D.style[g] = o
                } catch (t) {}
                if (D.style[g] != m) return c(), "pfx" != e || g
            }
        return c(), !1
    }

    function m(t, e, n, o, s) {
        var r = t.charAt(0).toUpperCase() + t.slice(1),
            a = (t + " " + A.join(r + " ") + r).split(" ");
        return i(e, "string") || i(e, "undefined") ? g(a, e, o, s) : (a = (t + " " + $.join(r + " ") + r).split(" "), d(a, e, n))
    }

    function v(t, e, i) {
        return m(t, n, n, e, i)
    }
    var y = [],
        b = [],
        x = {
            _version: "3.3.1",
            _config: {
                classPrefix: "",
                enableClasses: !0,
                enableJSClass: !0,
                usePrefixes: !0
            },
            _q: [],
            on: function(t, e) {
                var n = this;
                setTimeout(function() {
                    e(n[t])
                }, 0)
            },
            addTest: function(t, e, n) {
                b.push({
                    name: t,
                    fn: e,
                    options: n
                })
            },
            addAsyncTest: function(t) {
                b.push({
                    name: null,
                    fn: t
                })
            }
        },
        w = function() {};
    w.prototype = x, w = new w, w.addTest("svg", !!e.createElementNS && !!e.createElementNS("http://www.w3.org/2000/svg", "svg").createSVGRect);
    var C = x._config.usePrefixes ? " -webkit- -moz- -o- -ms- ".split(" ") : ["", ""];
    x._prefixes = C;
    var _ = e.documentElement,
        T = "svg" === _.nodeName.toLowerCase(),
        S = "Moz O ms Webkit",
        $ = x._config.usePrefixes ? S.toLowerCase().split(" ") : [];
    x._domPrefixes = $;
    var E = "CSS" in t && "supports" in t.CSS,
        P = "supportsCSS" in t;
    w.addTest("supports", E || P), w.addTest("placeholder", "placeholder" in r("input") && "placeholder" in r("textarea"));
    var A = x._config.usePrefixes ? S.split(" ") : [];
    x._cssomPrefixes = A;
    var k = x.testStyles = u;
    w.addTest("touchevents", function() {
        var n;
        if ("ontouchstart" in t || t.DocumentTouch && e instanceof DocumentTouch) n = !0;
        else {
            var i = ["@media (", C.join("touch-enabled),("), "heartz", ")", "{#modernizr{top:9px;position:absolute}}"].join("");
            k(i, function(t) {
                n = 9 === t.offsetTop
            })
        }
        return n
    });
    var z = {
        elem: r("modernizr")
    };
    w._q.push(function() {
        delete z.elem
    });
    var D = {
        style: z.elem.style
    };
    w._q.unshift(function() {
        delete D.style
    }), x.testProp = function(t, e, i) {
        return g([t], n, e, i)
    }, x.testAllProps = m, x.testAllProps = v, w.addTest("csstransforms", function() {
        return -1 === navigator.userAgent.indexOf("Android 2.") && v("transform", "scale(1)", !0)
    }), w.addTest("csstransforms3d", function() {
        var t = !!v("perspective", "1px", !0),
            e = w._config.usePrefixes;
        if (t && (!e || "webkitPerspective" in _.style)) {
            var n, i = "#modernizr{width:0;height:0}";
            w.supports ? n = "@supports (perspective: 1px)" : (n = "@media (transform-3d)", e && (n += ",(-webkit-transform-3d)")), n += "{#modernizr{width:7px;height:18px;margin:0;padding:0;border:0}}", k(i + n, function(e) {
                t = 7 === e.offsetWidth && 18 === e.offsetHeight
            })
        }
        return t
    }), w.addTest("flexbox", v("flexBasis", "1px", !0)), o(), s(y), delete x.addTest, delete x.addAsyncTest;
    for (var L = 0; L < w._q.length; L++) w._q[L]();
    t.Modernizr = w
}(window, document), /*! jQuery v2.2.3 | (c) jQuery Foundation | jquery.org/license */
! function(t, e) {
    "object" == typeof module && "object" == typeof module.exports ? module.exports = t.document ? e(t, !0) : function(t) {
        if (!t.document) throw new Error("jQuery requires a window with a document");
        return e(t)
    } : e(t)
}("undefined" != typeof window ? window : this, function(t, e) {
    function n(t) {
        var e = !!t && "length" in t && t.length,
            n = st.type(t);
        return "function" !== n && !st.isWindow(t) && ("array" === n || 0 === e || "number" == typeof e && e > 0 && e - 1 in t)
    }

    function i(t, e, n) {
        if (st.isFunction(e)) return st.grep(t, function(t, i) {
            return !!e.call(t, i, t) !== n
        });
        if (e.nodeType) return st.grep(t, function(t) {
            return t === e !== n
        });
        if ("string" == typeof e) {
            if (gt.test(e)) return st.filter(e, t, n);
            e = st.filter(e, t)
        }
        return st.grep(t, function(t) {
            return J.call(e, t) > -1 !== n
        })
    }

    function o(t, e) {
        for (;
            (t = t[e]) && 1 !== t.nodeType;);
        return t
    }

    function s(t) {
        var e = {};
        return st.each(t.match(wt) || [], function(t, n) {
            e[n] = !0
        }), e
    }

    function r() {
        Q.removeEventListener("DOMContentLoaded", r), t.removeEventListener("load", r), st.ready()
    }

    function a() {
        this.expando = st.expando + a.uid++
    }

    function l(t, e, n) {
        var i;
        if (void 0 === n && 1 === t.nodeType)
            if (i = "data-" + e.replace(Pt, "-$&").toLowerCase(), n = t.getAttribute(i), "string" == typeof n) {
                try {
                    n = "true" === n || "false" !== n && ("null" === n ? null : +n + "" === n ? +n : Et.test(n) ? st.parseJSON(n) : n)
                } catch (t) {}
                $t.set(t, e, n)
            } else n = void 0;
        return n
    }

    function c(t, e, n, i) {
        var o, s = 1,
            r = 20,
            a = i ? function() {
                return i.cur()
            } : function() {
                return st.css(t, e, "")
            },
            l = a(),
            c = n && n[3] || (st.cssNumber[e] ? "" : "px"),
            u = (st.cssNumber[e] || "px" !== c && +l) && kt.exec(st.css(t, e));
        if (u && u[3] !== c) {
            c = c || u[3], n = n || [], u = +l || 1;
            do s = s || ".5", u /= s, st.style(t, e, u + c); while (s !== (s = a() / l) && 1 !== s && --r)
        }
        return n && (u = +u || +l || 0, o = n[1] ? u + (n[1] + 1) * n[2] : +n[2], i && (i.unit = c, i.start = u, i.end = o)), o
    }

    function u(t, e) {
        var n = "undefined" != typeof t.getElementsByTagName ? t.getElementsByTagName(e || "*") : "undefined" != typeof t.querySelectorAll ? t.querySelectorAll(e || "*") : [];
        return void 0 === e || e && st.nodeName(t, e) ? st.merge([t], n) : n
    }

    function h(t, e) {
        for (var n = 0, i = t.length; i > n; n++) St.set(t[n], "globalEval", !e || St.get(e[n], "globalEval"))
    }

    function d(t, e, n, i, o) {
        for (var s, r, a, l, c, d, p = e.createDocumentFragment(), f = [], g = 0, m = t.length; m > g; g++)
            if (s = t[g], s || 0 === s)
                if ("object" === st.type(s)) st.merge(f, s.nodeType ? [s] : s);
                else if (Mt.test(s)) {
            for (r = r || p.appendChild(e.createElement("div")), a = (jt.exec(s) || ["", ""])[1].toLowerCase(), l = Ft[a] || Ft._default, r.innerHTML = l[1] + st.htmlPrefilter(s) + l[2], d = l[0]; d--;) r = r.lastChild;
            st.merge(f, r.childNodes), r = p.firstChild, r.textContent = ""
        } else f.push(e.createTextNode(s));
        for (p.textContent = "", g = 0; s = f[g++];)
            if (i && st.inArray(s, i) > -1) o && o.push(s);
            else if (c = st.contains(s.ownerDocument, s), r = u(p.appendChild(s), "script"), c && h(r), n)
            for (d = 0; s = r[d++];) Nt.test(s.type || "") && n.push(s);
        return p
    }

    function p() {
        return !0
    }

    function f() {
        return !1
    }

    function g() {
        try {
            return Q.activeElement
        } catch (t) {}
    }

    function m(t, e, n, i, o, s) {
        var r, a;
        if ("object" == typeof e) {
            "string" != typeof n && (i = i || n, n = void 0);
            for (a in e) m(t, a, n, i, e[a], s);
            return t
        }
        if (null == i && null == o ? (o = n, i = n = void 0) : null == o && ("string" == typeof n ? (o = i, i = void 0) : (o = i, i = n, n = void 0)), o === !1) o = f;
        else if (!o) return t;
        return 1 === s && (r = o, o = function(t) {
            return st().off(t), r.apply(this, arguments)
        }, o.guid = r.guid || (r.guid = st.guid++)), t.each(function() {
            st.event.add(this, e, o, i, n)
        })
    }

    function v(t, e) {
        return st.nodeName(t, "table") && st.nodeName(11 !== e.nodeType ? e : e.firstChild, "tr") ? t.getElementsByTagName("tbody")[0] || t.appendChild(t.ownerDocument.createElement("tbody")) : t
    }

    function y(t) {
        return t.type = (null !== t.getAttribute("type")) + "/" + t.type, t
    }

    function b(t) {
        var e = Bt.exec(t.type);
        return e ? t.type = e[1] : t.removeAttribute("type"), t
    }

    function x(t, e) {
        var n, i, o, s, r, a, l, c;
        if (1 === e.nodeType) {
            if (St.hasData(t) && (s = St.access(t), r = St.set(e, s), c = s.events)) {
                delete r.handle, r.events = {};
                for (o in c)
                    for (n = 0, i = c[o].length; i > n; n++) st.event.add(e, o, c[o][n])
            }
            $t.hasData(t) && (a = $t.access(t), l = st.extend({}, a), $t.set(e, l))
        }
    }

    function w(t, e) {
        var n = e.nodeName.toLowerCase();
        "input" === n && Lt.test(t.type) ? e.checked = t.checked : "input" !== n && "textarea" !== n || (e.defaultValue = t.defaultValue)
    }

    function C(t, e, n, i) {
        e = G.apply([], e);
        var o, s, r, a, l, c, h = 0,
            p = t.length,
            f = p - 1,
            g = e[0],
            m = st.isFunction(g);
        if (m || p > 1 && "string" == typeof g && !it.checkClone && Wt.test(g)) return t.each(function(o) {
            var s = t.eq(o);
            m && (e[0] = g.call(this, o, s.html())), C(s, e, n, i)
        });
        if (p && (o = d(e, t[0].ownerDocument, !1, t, i), s = o.firstChild, 1 === o.childNodes.length && (o = s), s || i)) {
            for (r = st.map(u(o, "script"), y), a = r.length; p > h; h++) l = o, h !== f && (l = st.clone(l, !0, !0), a && st.merge(r, u(l, "script"))), n.call(t[h], l, h);
            if (a)
                for (c = r[r.length - 1].ownerDocument, st.map(r, b), h = 0; a > h; h++) l = r[h], Nt.test(l.type || "") && !St.access(l, "globalEval") && st.contains(c, l) && (l.src ? st._evalUrl && st._evalUrl(l.src) : st.globalEval(l.textContent.replace(Xt, "")))
        }
        return t
    }

    function _(t, e, n) {
        for (var i, o = e ? st.filter(e, t) : t, s = 0; null != (i = o[s]); s++) n || 1 !== i.nodeType || st.cleanData(u(i)), i.parentNode && (n && st.contains(i.ownerDocument, i) && h(u(i, "script")), i.parentNode.removeChild(i));
        return t
    }

    function T(t, e) {
        var n = st(e.createElement(t)).appendTo(e.body),
            i = st.css(n[0], "display");
        return n.detach(), i
    }

    function S(t) {
        var e = Q,
            n = Ut[t];
        return n || (n = T(t, e), "none" !== n && n || (Yt = (Yt || st("<iframe frameborder='0' width='0' height='0'/>")).appendTo(e.documentElement), e = Yt[0].contentDocument, e.write(), e.close(), n = T(t, e), Yt.detach()), Ut[t] = n), n
    }

    function $(t, e, n) {
        var i, o, s, r, a = t.style;
        return n = n || Zt(t), r = n ? n.getPropertyValue(e) || n[e] : void 0, "" !== r && void 0 !== r || st.contains(t.ownerDocument, t) || (r = st.style(t, e)), n && !it.pixelMarginRight() && Qt.test(r) && Vt.test(e) && (i = a.width, o = a.minWidth, s = a.maxWidth, a.minWidth = a.maxWidth = a.width = r, r = n.width, a.width = i, a.minWidth = o, a.maxWidth = s), void 0 !== r ? r + "" : r
    }

    function E(t, e) {
        return {
            get: function() {
                return t() ? void delete this.get : (this.get = e).apply(this, arguments)
            }
        }
    }

    function P(t) {
        if (t in ie) return t;
        for (var e = t[0].toUpperCase() + t.slice(1), n = ne.length; n--;)
            if (t = ne[n] + e, t in ie) return t
    }

    function A(t, e, n) {
        var i = kt.exec(e);
        return i ? Math.max(0, i[2] - (n || 0)) + (i[3] || "px") : e
    }

    function k(t, e, n, i, o) {
        for (var s = n === (i ? "border" : "content") ? 4 : "width" === e ? 1 : 0, r = 0; 4 > s; s += 2) "margin" === n && (r += st.css(t, n + zt[s], !0, o)), i ? ("content" === n && (r -= st.css(t, "padding" + zt[s], !0, o)), "margin" !== n && (r -= st.css(t, "border" + zt[s] + "Width", !0, o))) : (r += st.css(t, "padding" + zt[s], !0, o), "padding" !== n && (r += st.css(t, "border" + zt[s] + "Width", !0, o)));
        return r
    }

    function z(e, n, i) {
        var o = !0,
            s = "width" === n ? e.offsetWidth : e.offsetHeight,
            r = Zt(e),
            a = "border-box" === st.css(e, "boxSizing", !1, r);
        if (Q.msFullscreenElement && t.top !== t && e.getClientRects().length && (s = Math.round(100 * e.getBoundingClientRect()[n])), 0 >= s || null == s) {
            if (s = $(e, n, r), (0 > s || null == s) && (s = e.style[n]), Qt.test(s)) return s;
            o = a && (it.boxSizingReliable() || s === e.style[n]), s = parseFloat(s) || 0
        }
        return s + k(e, n, i || (a ? "border" : "content"), o, r) + "px"
    }

    function D(t, e) {
        for (var n, i, o, s = [], r = 0, a = t.length; a > r; r++) i = t[r], i.style && (s[r] = St.get(i, "olddisplay"), n = i.style.display, e ? (s[r] || "none" !== n || (i.style.display = ""), "" === i.style.display && Dt(i) && (s[r] = St.access(i, "olddisplay", S(i.nodeName)))) : (o = Dt(i), "none" === n && o || St.set(i, "olddisplay", o ? n : st.css(i, "display"))));
        for (r = 0; a > r; r++) i = t[r], i.style && (e && "none" !== i.style.display && "" !== i.style.display || (i.style.display = e ? s[r] || "" : "none"));
        return t
    }

    function L(t, e, n, i, o) {
        return new L.prototype.init(t, e, n, i, o)
    }

    function j() {
        return t.setTimeout(function() {
            oe = void 0
        }), oe = st.now()
    }

    function N(t, e) {
        var n, i = 0,
            o = {
                height: t
            };
        for (e = e ? 1 : 0; 4 > i; i += 2 - e) n = zt[i], o["margin" + n] = o["padding" + n] = t;
        return e && (o.opacity = o.width = t), o
    }

    function F(t, e, n) {
        for (var i, o = (I.tweeners[e] || []).concat(I.tweeners["*"]), s = 0, r = o.length; r > s; s++)
            if (i = o[s].call(n, e, t)) return i
    }

    function M(t, e, n) {
        var i, o, s, r, a, l, c, u, h = this,
            d = {},
            p = t.style,
            f = t.nodeType && Dt(t),
            g = St.get(t, "fxshow");
        n.queue || (a = st._queueHooks(t, "fx"), null == a.unqueued && (a.unqueued = 0, l = a.empty.fire, a.empty.fire = function() {
            a.unqueued || l()
        }), a.unqueued++, h.always(function() {
            h.always(function() {
                a.unqueued--, st.queue(t, "fx").length || a.empty.fire()
            })
        })), 1 === t.nodeType && ("height" in e || "width" in e) && (n.overflow = [p.overflow, p.overflowX, p.overflowY], c = st.css(t, "display"), u = "none" === c ? St.get(t, "olddisplay") || S(t.nodeName) : c, "inline" === u && "none" === st.css(t, "float") && (p.display = "inline-block")), n.overflow && (p.overflow = "hidden", h.always(function() {
            p.overflow = n.overflow[0], p.overflowX = n.overflow[1], p.overflowY = n.overflow[2]
        }));
        for (i in e)
            if (o = e[i], re.exec(o)) {
                if (delete e[i], s = s || "toggle" === o, o === (f ? "hide" : "show")) {
                    if ("show" !== o || !g || void 0 === g[i]) continue;
                    f = !0
                }
                d[i] = g && g[i] || st.style(t, i)
            } else c = void 0;
        if (st.isEmptyObject(d)) "inline" === ("none" === c ? S(t.nodeName) : c) && (p.display = c);
        else {
            g ? "hidden" in g && (f = g.hidden) : g = St.access(t, "fxshow", {}), s && (g.hidden = !f), f ? st(t).show() : h.done(function() {
                st(t).hide()
            }), h.done(function() {
                var e;
                St.remove(t, "fxshow");
                for (e in d) st.style(t, e, d[e])
            });
            for (i in d) r = F(f ? g[i] : 0, i, h), i in g || (g[i] = r.start, f && (r.end = r.start, r.start = "width" === i || "height" === i ? 1 : 0))
        }
    }

    function q(t, e) {
        var n, i, o, s, r;
        for (n in t)
            if (i = st.camelCase(n), o = e[i], s = t[n], st.isArray(s) && (o = s[1], s = t[n] = s[0]), n !== i && (t[i] = s, delete t[n]), r = st.cssHooks[i], r && "expand" in r) {
                s = r.expand(s), delete t[i];
                for (n in s) n in t || (t[n] = s[n], e[n] = o)
            } else e[i] = o
    }

    function I(t, e, n) {
        var i, o, s = 0,
            r = I.prefilters.length,
            a = st.Deferred().always(function() {
                delete l.elem
            }),
            l = function() {
                if (o) return !1;
                for (var e = oe || j(), n = Math.max(0, c.startTime + c.duration - e), i = n / c.duration || 0, s = 1 - i, r = 0, l = c.tweens.length; l > r; r++) c.tweens[r].run(s);
                return a.notifyWith(t, [c, s, n]), 1 > s && l ? n : (a.resolveWith(t, [c]), !1)
            },
            c = a.promise({
                elem: t,
                props: st.extend({}, e),
                opts: st.extend(!0, {
                    specialEasing: {},
                    easing: st.easing._default
                }, n),
                originalProperties: e,
                originalOptions: n,
                startTime: oe || j(),
                duration: n.duration,
                tweens: [],
                createTween: function(e, n) {
                    var i = st.Tween(t, c.opts, e, n, c.opts.specialEasing[e] || c.opts.easing);
                    return c.tweens.push(i), i
                },
                stop: function(e) {
                    var n = 0,
                        i = e ? c.tweens.length : 0;
                    if (o) return this;
                    for (o = !0; i > n; n++) c.tweens[n].run(1);
                    return e ? (a.notifyWith(t, [c, 1, 0]), a.resolveWith(t, [c, e])) : a.rejectWith(t, [c, e]), this
                }
            }),
            u = c.props;
        for (q(u, c.opts.specialEasing); r > s; s++)
            if (i = I.prefilters[s].call(c, t, u, c.opts)) return st.isFunction(i.stop) && (st._queueHooks(c.elem, c.opts.queue).stop = st.proxy(i.stop, i)), i;
        return st.map(u, F, c), st.isFunction(c.opts.start) && c.opts.start.call(t, c), st.fx.timer(st.extend(l, {
            elem: t,
            anim: c,
            queue: c.opts.queue
        })), c.progress(c.opts.progress).done(c.opts.done, c.opts.complete).fail(c.opts.fail).always(c.opts.always)
    }

    function R(t) {
        return t.getAttribute && t.getAttribute("class") || ""
    }

    function O(t) {
        return function(e, n) {
            "string" != typeof e && (n = e, e = "*");
            var i, o = 0,
                s = e.toLowerCase().match(wt) || [];
            if (st.isFunction(n))
                for (; i = s[o++];) "+" === i[0] ? (i = i.slice(1) || "*", (t[i] = t[i] || []).unshift(n)) : (t[i] = t[i] || []).push(n)
        }
    }

    function H(t, e, n, i) {
        function o(a) {
            var l;
            return s[a] = !0, st.each(t[a] || [], function(t, a) {
                var c = a(e, n, i);
                return "string" != typeof c || r || s[c] ? r ? !(l = c) : void 0 : (e.dataTypes.unshift(c), o(c), !1)
            }), l
        }
        var s = {},
            r = t === $e;
        return o(e.dataTypes[0]) || !s["*"] && o("*")
    }

    function W(t, e) {
        var n, i, o = st.ajaxSettings.flatOptions || {};
        for (n in e) void 0 !== e[n] && ((o[n] ? t : i || (i = {}))[n] = e[n]);
        return i && st.extend(!0, t, i), t
    }

    function B(t, e, n) {
        for (var i, o, s, r, a = t.contents, l = t.dataTypes;
            "*" === l[0];) l.shift(), void 0 === i && (i = t.mimeType || e.getResponseHeader("Content-Type"));
        if (i)
            for (o in a)
                if (a[o] && a[o].test(i)) {
                    l.unshift(o);
                    break
                }
        if (l[0] in n) s = l[0];
        else {
            for (o in n) {
                if (!l[0] || t.converters[o + " " + l[0]]) {
                    s = o;
                    break
                }
                r || (r = o)
            }
            s = s || r
        }
        return s ? (s !== l[0] && l.unshift(s), n[s]) : void 0
    }

    function X(t, e, n, i) {
        var o, s, r, a, l, c = {},
            u = t.dataTypes.slice();
        if (u[1])
            for (r in t.converters) c[r.toLowerCase()] = t.converters[r];
        for (s = u.shift(); s;)
            if (t.responseFields[s] && (n[t.responseFields[s]] = e), !l && i && t.dataFilter && (e = t.dataFilter(e, t.dataType)), l = s, s = u.shift())
                if ("*" === s) s = l;
                else if ("*" !== l && l !== s) {
            if (r = c[l + " " + s] || c["* " + s], !r)
                for (o in c)
                    if (a = o.split(" "), a[1] === s && (r = c[l + " " + a[0]] || c["* " + a[0]])) {
                        r === !0 ? r = c[o] : c[o] !== !0 && (s = a[0], u.unshift(a[1]));
                        break
                    }
            if (r !== !0)
                if (r && t.throws) e = r(e);
                else try {
                    e = r(e)
                } catch (t) {
                    return {
                        state: "parsererror",
                        error: r ? t : "No conversion from " + l + " to " + s
                    }
                }
        }
        return {
            state: "success",
            data: e
        }
    }

    function Y(t, e, n, i) {
        var o;
        if (st.isArray(e)) st.each(e, function(e, o) {
            n || ke.test(t) ? i(t, o) : Y(t + "[" + ("object" == typeof o && null != o ? e : "") + "]", o, n, i)
        });
        else if (n || "object" !== st.type(e)) i(t, e);
        else
            for (o in e) Y(t + "[" + o + "]", e[o], n, i)
    }

    function U(t) {
        return st.isWindow(t) ? t : 9 === t.nodeType && t.defaultView
    }
    var V = [],
        Q = t.document,
        Z = V.slice,
        G = V.concat,
        K = V.push,
        J = V.indexOf,
        tt = {},
        et = tt.toString,
        nt = tt.hasOwnProperty,
        it = {},
        ot = "2.2.3",
        st = function(t, e) {
            return new st.fn.init(t, e)
        },
        rt = /^[\s\uFEFF\xA0]+|[\s\uFEFF\xA0]+$/g,
        at = /^-ms-/,
        lt = /-([\da-z])/gi,
        ct = function(t, e) {
            return e.toUpperCase()
        };
    st.fn = st.prototype = {
        jquery: ot,
        constructor: st,
        selector: "",
        length: 0,
        toArray: function() {
            return Z.call(this)
        },
        get: function(t) {
            return null != t ? 0 > t ? this[t + this.length] : this[t] : Z.call(this)
        },
        pushStack: function(t) {
            var e = st.merge(this.constructor(), t);
            return e.prevObject = this, e.context = this.context, e
        },
        each: function(t) {
            return st.each(this, t)
        },
        map: function(t) {
            return this.pushStack(st.map(this, function(e, n) {
                return t.call(e, n, e)
            }))
        },
        slice: function() {
            return this.pushStack(Z.apply(this, arguments))
        },
        first: function() {
            return this.eq(0)
        },
        last: function() {
            return this.eq(-1)
        },
        eq: function(t) {
            var e = this.length,
                n = +t + (0 > t ? e : 0);
            return this.pushStack(n >= 0 && e > n ? [this[n]] : [])
        },
        end: function() {
            return this.prevObject || this.constructor()
        },
        push: K,
        sort: V.sort,
        splice: V.splice
    }, st.extend = st.fn.extend = function() {
        var t, e, n, i, o, s, r = arguments[0] || {},
            a = 1,
            l = arguments.length,
            c = !1;
        for ("boolean" == typeof r && (c = r, r = arguments[a] || {}, a++), "object" == typeof r || st.isFunction(r) || (r = {}), a === l && (r = this, a--); l > a; a++)
            if (null != (t = arguments[a]))
                for (e in t) n = r[e], i = t[e], r !== i && (c && i && (st.isPlainObject(i) || (o = st.isArray(i))) ? (o ? (o = !1, s = n && st.isArray(n) ? n : []) : s = n && st.isPlainObject(n) ? n : {}, r[e] = st.extend(c, s, i)) : void 0 !== i && (r[e] = i));
        return r
    }, st.extend({
        expando: "jQuery" + (ot + Math.random()).replace(/\D/g, ""),
        isReady: !0,
        error: function(t) {
            throw new Error(t)
        },
        noop: function() {},
        isFunction: function(t) {
            return "function" === st.type(t)
        },
        isArray: Array.isArray,
        isWindow: function(t) {
            return null != t && t === t.window
        },
        isNumeric: function(t) {
            var e = t && t.toString();
            return !st.isArray(t) && e - parseFloat(e) + 1 >= 0
        },
        isPlainObject: function(t) {
            var e;
            if ("object" !== st.type(t) || t.nodeType || st.isWindow(t)) return !1;
            if (t.constructor && !nt.call(t, "constructor") && !nt.call(t.constructor.prototype || {}, "isPrototypeOf")) return !1;
            for (e in t);
            return void 0 === e || nt.call(t, e)
        },
        isEmptyObject: function(t) {
            var e;
            for (e in t) return !1;
            return !0
        },
        type: function(t) {
            return null == t ? t + "" : "object" == typeof t || "function" == typeof t ? tt[et.call(t)] || "object" : typeof t
        },
        globalEval: function(t) {
            var e, n = eval;
            t = st.trim(t), t && (1 === t.indexOf("use strict") ? (e = Q.createElement("script"), e.text = t, Q.head.appendChild(e).parentNode.removeChild(e)) : n(t))
        },
        camelCase: function(t) {
            return t.replace(at, "ms-").replace(lt, ct)
        },
        nodeName: function(t, e) {
            return t.nodeName && t.nodeName.toLowerCase() === e.toLowerCase()
        },
        each: function(t, e) {
            var i, o = 0;
            if (n(t))
                for (i = t.length; i > o && e.call(t[o], o, t[o]) !== !1; o++);
            else
                for (o in t)
                    if (e.call(t[o], o, t[o]) === !1) break;
            return t
        },
        trim: function(t) {
            return null == t ? "" : (t + "").replace(rt, "")
        },
        makeArray: function(t, e) {
            var i = e || [];
            return null != t && (n(Object(t)) ? st.merge(i, "string" == typeof t ? [t] : t) : K.call(i, t)), i
        },
        inArray: function(t, e, n) {
            return null == e ? -1 : J.call(e, t, n)
        },
        merge: function(t, e) {
            for (var n = +e.length, i = 0, o = t.length; n > i; i++) t[o++] = e[i];
            return t.length = o, t
        },
        grep: function(t, e, n) {
            for (var i, o = [], s = 0, r = t.length, a = !n; r > s; s++) i = !e(t[s], s), i !== a && o.push(t[s]);
            return o
        },
        map: function(t, e, i) {
            var o, s, r = 0,
                a = [];
            if (n(t))
                for (o = t.length; o > r; r++) s = e(t[r], r, i), null != s && a.push(s);
            else
                for (r in t) s = e(t[r], r, i), null != s && a.push(s);
            return G.apply([], a)
        },
        guid: 1,
        proxy: function(t, e) {
            var n, i, o;
            return "string" == typeof e && (n = t[e], e = t, t = n), st.isFunction(t) ? (i = Z.call(arguments, 2), o = function() {
                return t.apply(e || this, i.concat(Z.call(arguments)))
            }, o.guid = t.guid = t.guid || st.guid++, o) : void 0
        },
        now: Date.now,
        support: it
    }), "function" == typeof Symbol && (st.fn[Symbol.iterator] = V[Symbol.iterator]), st.each("Boolean Number String Function Array Date RegExp Object Error Symbol".split(" "), function(t, e) {
        tt["[object " + e + "]"] = e.toLowerCase()
    });
    var ut = function(t) {
        function e(t, e, n, i) {
            var o, s, r, a, l, c, h, p, f = e && e.ownerDocument,
                g = e ? e.nodeType : 9;
            if (n = n || [], "string" != typeof t || !t || 1 !== g && 9 !== g && 11 !== g) return n;
            if (!i && ((e ? e.ownerDocument || e : R) !== D && z(e), e = e || D, j)) {
                if (11 !== g && (c = vt.exec(t)))
                    if (o = c[1]) {
                        if (9 === g) {
                            if (!(r = e.getElementById(o))) return n;
                            if (r.id === o) return n.push(r), n
                        } else if (f && (r = f.getElementById(o)) && q(e, r) && r.id === o) return n.push(r), n
                    } else {
                        if (c[2]) return K.apply(n, e.getElementsByTagName(t)), n;
                        if ((o = c[3]) && w.getElementsByClassName && e.getElementsByClassName) return K.apply(n, e.getElementsByClassName(o)), n
                    }
                if (w.qsa && !X[t + " "] && (!N || !N.test(t))) {
                    if (1 !== g) f = e, p = t;
                    else if ("object" !== e.nodeName.toLowerCase()) {
                        for ((a = e.getAttribute("id")) ? a = a.replace(bt, "\\$&") : e.setAttribute("id", a = I), h = S(t), s = h.length, l = dt.test(a) ? "#" + a : "[id='" + a + "']"; s--;) h[s] = l + " " + d(h[s]);
                        p = h.join(","), f = yt.test(t) && u(e.parentNode) || e
                    }
                    if (p) try {
                        return K.apply(n, f.querySelectorAll(p)), n
                    } catch (t) {} finally {
                        a === I && e.removeAttribute("id")
                    }
                }
            }
            return E(t.replace(at, "$1"), e, n, i)
        }

        function n() {
            function t(n, i) {
                return e.push(n + " ") > C.cacheLength && delete t[e.shift()], t[n + " "] = i
            }
            var e = [];
            return t
        }

        function i(t) {
            return t[I] = !0, t
        }

        function o(t) {
            var e = D.createElement("div");
            try {
                return !!t(e)
            } catch (t) {
                return !1
            } finally {
                e.parentNode && e.parentNode.removeChild(e), e = null
            }
        }

        function s(t, e) {
            for (var n = t.split("|"), i = n.length; i--;) C.attrHandle[n[i]] = e
        }

        function r(t, e) {
            var n = e && t,
                i = n && 1 === t.nodeType && 1 === e.nodeType && (~e.sourceIndex || U) - (~t.sourceIndex || U);
            if (i) return i;
            if (n)
                for (; n = n.nextSibling;)
                    if (n === e) return -1;
            return t ? 1 : -1
        }

        function a(t) {
            return function(e) {
                var n = e.nodeName.toLowerCase();
                return "input" === n && e.type === t
            }
        }

        function l(t) {
            return function(e) {
                var n = e.nodeName.toLowerCase();
                return ("input" === n || "button" === n) && e.type === t
            }
        }

        function c(t) {
            return i(function(e) {
                return e = +e, i(function(n, i) {
                    for (var o, s = t([], n.length, e), r = s.length; r--;) n[o = s[r]] && (n[o] = !(i[o] = n[o]))
                })
            })
        }

        function u(t) {
            return t && "undefined" != typeof t.getElementsByTagName && t
        }

        function h() {}

        function d(t) {
            for (var e = 0, n = t.length, i = ""; n > e; e++) i += t[e].value;
            return i
        }

        function p(t, e, n) {
            var i = e.dir,
                o = n && "parentNode" === i,
                s = H++;
            return e.first ? function(e, n, s) {
                for (; e = e[i];)
                    if (1 === e.nodeType || o) return t(e, n, s)
            } : function(e, n, r) {
                var a, l, c, u = [O, s];
                if (r) {
                    for (; e = e[i];)
                        if ((1 === e.nodeType || o) && t(e, n, r)) return !0
                } else
                    for (; e = e[i];)
                        if (1 === e.nodeType || o) {
                            if (c = e[I] || (e[I] = {}), l = c[e.uniqueID] || (c[e.uniqueID] = {}), (a = l[i]) && a[0] === O && a[1] === s) return u[2] = a[2];
                            if (l[i] = u, u[2] = t(e, n, r)) return !0
                        }
            }
        }

        function f(t) {
            return t.length > 1 ? function(e, n, i) {
                for (var o = t.length; o--;)
                    if (!t[o](e, n, i)) return !1;
                return !0
            } : t[0]
        }

        function g(t, n, i) {
            for (var o = 0, s = n.length; s > o; o++) e(t, n[o], i);
            return i
        }

        function m(t, e, n, i, o) {
            for (var s, r = [], a = 0, l = t.length, c = null != e; l > a; a++)(s = t[a]) && (n && !n(s, i, o) || (r.push(s), c && e.push(a)));
            return r
        }

        function v(t, e, n, o, s, r) {
            return o && !o[I] && (o = v(o)), s && !s[I] && (s = v(s, r)), i(function(i, r, a, l) {
                var c, u, h, d = [],
                    p = [],
                    f = r.length,
                    v = i || g(e || "*", a.nodeType ? [a] : a, []),
                    y = !t || !i && e ? v : m(v, d, t, a, l),
                    b = n ? s || (i ? t : f || o) ? [] : r : y;
                if (n && n(y, b, a, l), o)
                    for (c = m(b, p), o(c, [], a, l), u = c.length; u--;)(h = c[u]) && (b[p[u]] = !(y[p[u]] = h));
                if (i) {
                    if (s || t) {
                        if (s) {
                            for (c = [], u = b.length; u--;)(h = b[u]) && c.push(y[u] = h);
                            s(null, b = [], c, l)
                        }
                        for (u = b.length; u--;)(h = b[u]) && (c = s ? tt(i, h) : d[u]) > -1 && (i[c] = !(r[c] = h))
                    }
                } else b = m(b === r ? b.splice(f, b.length) : b), s ? s(null, r, b, l) : K.apply(r, b)
            })
        }

        function y(t) {
            for (var e, n, i, o = t.length, s = C.relative[t[0].type], r = s || C.relative[" "], a = s ? 1 : 0, l = p(function(t) {
                    return t === e
                }, r, !0), c = p(function(t) {
                    return tt(e, t) > -1
                }, r, !0), u = [function(t, n, i) {
                    var o = !s && (i || n !== P) || ((e = n).nodeType ? l(t, n, i) : c(t, n, i));
                    return e = null, o
                }]; o > a; a++)
                if (n = C.relative[t[a].type]) u = [p(f(u), n)];
                else {
                    if (n = C.filter[t[a].type].apply(null, t[a].matches), n[I]) {
                        for (i = ++a; o > i && !C.relative[t[i].type]; i++);
                        return v(a > 1 && f(u), a > 1 && d(t.slice(0, a - 1).concat({
                            value: " " === t[a - 2].type ? "*" : ""
                        })).replace(at, "$1"), n, i > a && y(t.slice(a, i)), o > i && y(t = t.slice(i)), o > i && d(t))
                    }
                    u.push(n)
                }
            return f(u)
        }

        function b(t, n) {
            var o = n.length > 0,
                s = t.length > 0,
                r = function(i, r, a, l, c) {
                    var u, h, d, p = 0,
                        f = "0",
                        g = i && [],
                        v = [],
                        y = P,
                        b = i || s && C.find.TAG("*", c),
                        x = O += null == y ? 1 : Math.random() || .1,
                        w = b.length;
                    for (c && (P = r === D || r || c); f !== w && null != (u = b[f]); f++) {
                        if (s && u) {
                            for (h = 0, r || u.ownerDocument === D || (z(u), a = !j); d = t[h++];)
                                if (d(u, r || D, a)) {
                                    l.push(u);
                                    break
                                }
                            c && (O = x)
                        }
                        o && ((u = !d && u) && p--, i && g.push(u))
                    }
                    if (p += f, o && f !== p) {
                        for (h = 0; d = n[h++];) d(g, v, r, a);
                        if (i) {
                            if (p > 0)
                                for (; f--;) g[f] || v[f] || (v[f] = Z.call(l));
                            v = m(v)
                        }
                        K.apply(l, v), c && !i && v.length > 0 && p + n.length > 1 && e.uniqueSort(l)
                    }
                    return c && (O = x, P = y), g
                };
            return o ? i(r) : r
        }
        var x, w, C, _, T, S, $, E, P, A, k, z, D, L, j, N, F, M, q, I = "sizzle" + 1 * new Date,
            R = t.document,
            O = 0,
            H = 0,
            W = n(),
            B = n(),
            X = n(),
            Y = function(t, e) {
                return t === e && (k = !0), 0
            },
            U = 1 << 31,
            V = {}.hasOwnProperty,
            Q = [],
            Z = Q.pop,
            G = Q.push,
            K = Q.push,
            J = Q.slice,
            tt = function(t, e) {
                for (var n = 0, i = t.length; i > n; n++)
                    if (t[n] === e) return n;
                return -1
            },
            et = "checked|selected|async|autofocus|autoplay|controls|defer|disabled|hidden|ismap|loop|multiple|open|readonly|required|scoped",
            nt = "[\\x20\\t\\r\\n\\f]",
            it = "(?:\\\\.|[\\w-]|[^\\x00-\\xa0])+",
            ot = "\\[" + nt + "*(" + it + ")(?:" + nt + "*([*^$|!~]?=)" + nt + "*(?:'((?:\\\\.|[^\\\\'])*)'|\"((?:\\\\.|[^\\\\\"])*)\"|(" + it + "))|)" + nt + "*\\]",
            st = ":(" + it + ")(?:\\((('((?:\\\\.|[^\\\\'])*)'|\"((?:\\\\.|[^\\\\\"])*)\")|((?:\\\\.|[^\\\\()[\\]]|" + ot + ")*)|.*)\\)|)",
            rt = new RegExp(nt + "+", "g"),
            at = new RegExp("^" + nt + "+|((?:^|[^\\\\])(?:\\\\.)*)" + nt + "+$", "g"),
            lt = new RegExp("^" + nt + "*," + nt + "*"),
            ct = new RegExp("^" + nt + "*([>+~]|" + nt + ")" + nt + "*"),
            ut = new RegExp("=" + nt + "*([^\\]'\"]*?)" + nt + "*\\]", "g"),
            ht = new RegExp(st),
            dt = new RegExp("^" + it + "$"),
            pt = {
                ID: new RegExp("^#(" + it + ")"),
                CLASS: new RegExp("^\\.(" + it + ")"),
                TAG: new RegExp("^(" + it + "|[*])"),
                ATTR: new RegExp("^" + ot),
                PSEUDO: new RegExp("^" + st),
                CHILD: new RegExp("^:(only|first|last|nth|nth-last)-(child|of-type)(?:\\(" + nt + "*(even|odd|(([+-]|)(\\d*)n|)" + nt + "*(?:([+-]|)" + nt + "*(\\d+)|))" + nt + "*\\)|)", "i"),
                bool: new RegExp("^(?:" + et + ")$", "i"),
                needsContext: new RegExp("^" + nt + "*[>+~]|:(even|odd|eq|gt|lt|nth|first|last)(?:\\(" + nt + "*((?:-\\d)?\\d*)" + nt + "*\\)|)(?=[^-]|$)", "i")
            },
            ft = /^(?:input|select|textarea|button)$/i,
            gt = /^h\d$/i,
            mt = /^[^{]+\{\s*\[native \w/,
            vt = /^(?:#([\w-]+)|(\w+)|\.([\w-]+))$/,
            yt = /[+~]/,
            bt = /'|\\/g,
            xt = new RegExp("\\\\([\\da-f]{1,6}" + nt + "?|(" + nt + ")|.)", "ig"),
            wt = function(t, e, n) {
                var i = "0x" + e - 65536;
                return i !== i || n ? e : 0 > i ? String.fromCharCode(i + 65536) : String.fromCharCode(i >> 10 | 55296, 1023 & i | 56320)
            },
            Ct = function() {
                z()
            };
        try {
            K.apply(Q = J.call(R.childNodes), R.childNodes), Q[R.childNodes.length].nodeType
        } catch (t) {
            K = {
                apply: Q.length ? function(t, e) {
                    G.apply(t, J.call(e))
                } : function(t, e) {
                    for (var n = t.length, i = 0; t[n++] = e[i++];);
                    t.length = n - 1
                }
            }
        }
        w = e.support = {}, T = e.isXML = function(t) {
            var e = t && (t.ownerDocument || t).documentElement;
            return !!e && "HTML" !== e.nodeName
        }, z = e.setDocument = function(t) {
            var e, n, i = t ? t.ownerDocument || t : R;
            return i !== D && 9 === i.nodeType && i.documentElement ? (D = i, L = D.documentElement, j = !T(D), (n = D.defaultView) && n.top !== n && (n.addEventListener ? n.addEventListener("unload", Ct, !1) : n.attachEvent && n.attachEvent("onunload", Ct)), w.attributes = o(function(t) {
                return t.className = "i", !t.getAttribute("className")
            }), w.getElementsByTagName = o(function(t) {
                return t.appendChild(D.createComment("")), !t.getElementsByTagName("*").length
            }), w.getElementsByClassName = mt.test(D.getElementsByClassName), w.getById = o(function(t) {
                return L.appendChild(t).id = I, !D.getElementsByName || !D.getElementsByName(I).length
            }), w.getById ? (C.find.ID = function(t, e) {
                if ("undefined" != typeof e.getElementById && j) {
                    var n = e.getElementById(t);
                    return n ? [n] : []
                }
            }, C.filter.ID = function(t) {
                var e = t.replace(xt, wt);
                return function(t) {
                    return t.getAttribute("id") === e
                }
            }) : (delete C.find.ID, C.filter.ID = function(t) {
                var e = t.replace(xt, wt);
                return function(t) {
                    var n = "undefined" != typeof t.getAttributeNode && t.getAttributeNode("id");
                    return n && n.value === e
                }
            }), C.find.TAG = w.getElementsByTagName ? function(t, e) {
                return "undefined" != typeof e.getElementsByTagName ? e.getElementsByTagName(t) : w.qsa ? e.querySelectorAll(t) : void 0
            } : function(t, e) {
                var n, i = [],
                    o = 0,
                    s = e.getElementsByTagName(t);
                if ("*" === t) {
                    for (; n = s[o++];) 1 === n.nodeType && i.push(n);
                    return i
                }
                return s
            }, C.find.CLASS = w.getElementsByClassName && function(t, e) {
                return "undefined" != typeof e.getElementsByClassName && j ? e.getElementsByClassName(t) : void 0
            }, F = [], N = [], (w.qsa = mt.test(D.querySelectorAll)) && (o(function(t) {
                L.appendChild(t).innerHTML = "<a id='" + I + "'></a><select id='" + I + "-\r\\' msallowcapture=''><option selected=''></option></select>", t.querySelectorAll("[msallowcapture^='']").length && N.push("[*^$]=" + nt + "*(?:''|\"\")"), t.querySelectorAll("[selected]").length || N.push("\\[" + nt + "*(?:value|" + et + ")"), t.querySelectorAll("[id~=" + I + "-]").length || N.push("~="), t.querySelectorAll(":checked").length || N.push(":checked"), t.querySelectorAll("a#" + I + "+*").length || N.push(".#.+[+~]")
            }), o(function(t) {
                var e = D.createElement("input");
                e.setAttribute("type", "hidden"), t.appendChild(e).setAttribute("name", "D"), t.querySelectorAll("[name=d]").length && N.push("name" + nt + "*[*^$|!~]?="), t.querySelectorAll(":enabled").length || N.push(":enabled", ":disabled"), t.querySelectorAll("*,:x"), N.push(",.*:")
            })), (w.matchesSelector = mt.test(M = L.matches || L.webkitMatchesSelector || L.mozMatchesSelector || L.oMatchesSelector || L.msMatchesSelector)) && o(function(t) {
                w.disconnectedMatch = M.call(t, "div"), M.call(t, "[s!='']:x"), F.push("!=", st)
            }), N = N.length && new RegExp(N.join("|")), F = F.length && new RegExp(F.join("|")), e = mt.test(L.compareDocumentPosition), q = e || mt.test(L.contains) ? function(t, e) {
                var n = 9 === t.nodeType ? t.documentElement : t,
                    i = e && e.parentNode;
                return t === i || !(!i || 1 !== i.nodeType || !(n.contains ? n.contains(i) : t.compareDocumentPosition && 16 & t.compareDocumentPosition(i)))
            } : function(t, e) {
                if (e)
                    for (; e = e.parentNode;)
                        if (e === t) return !0;
                return !1
            }, Y = e ? function(t, e) {
                if (t === e) return k = !0, 0;
                var n = !t.compareDocumentPosition - !e.compareDocumentPosition;
                return n ? n : (n = (t.ownerDocument || t) === (e.ownerDocument || e) ? t.compareDocumentPosition(e) : 1, 1 & n || !w.sortDetached && e.compareDocumentPosition(t) === n ? t === D || t.ownerDocument === R && q(R, t) ? -1 : e === D || e.ownerDocument === R && q(R, e) ? 1 : A ? tt(A, t) - tt(A, e) : 0 : 4 & n ? -1 : 1)
            } : function(t, e) {
                if (t === e) return k = !0, 0;
                var n, i = 0,
                    o = t.parentNode,
                    s = e.parentNode,
                    a = [t],
                    l = [e];
                if (!o || !s) return t === D ? -1 : e === D ? 1 : o ? -1 : s ? 1 : A ? tt(A, t) - tt(A, e) : 0;
                if (o === s) return r(t, e);
                for (n = t; n = n.parentNode;) a.unshift(n);
                for (n = e; n = n.parentNode;) l.unshift(n);
                for (; a[i] === l[i];) i++;
                return i ? r(a[i], l[i]) : a[i] === R ? -1 : l[i] === R ? 1 : 0
            }, D) : D
        }, e.matches = function(t, n) {
            return e(t, null, null, n)
        }, e.matchesSelector = function(t, n) {
            if ((t.ownerDocument || t) !== D && z(t), n = n.replace(ut, "='$1']"), w.matchesSelector && j && !X[n + " "] && (!F || !F.test(n)) && (!N || !N.test(n))) try {
                var i = M.call(t, n);
                if (i || w.disconnectedMatch || t.document && 11 !== t.document.nodeType) return i
            } catch (t) {}
            return e(n, D, null, [t]).length > 0
        }, e.contains = function(t, e) {
            return (t.ownerDocument || t) !== D && z(t), q(t, e)
        }, e.attr = function(t, e) {
            (t.ownerDocument || t) !== D && z(t);
            var n = C.attrHandle[e.toLowerCase()],
                i = n && V.call(C.attrHandle, e.toLowerCase()) ? n(t, e, !j) : void 0;
            return void 0 !== i ? i : w.attributes || !j ? t.getAttribute(e) : (i = t.getAttributeNode(e)) && i.specified ? i.value : null
        }, e.error = function(t) {
            throw new Error("Syntax error, unrecognized expression: " + t)
        }, e.uniqueSort = function(t) {
            var e, n = [],
                i = 0,
                o = 0;
            if (k = !w.detectDuplicates, A = !w.sortStable && t.slice(0), t.sort(Y), k) {
                for (; e = t[o++];) e === t[o] && (i = n.push(o));
                for (; i--;) t.splice(n[i], 1)
            }
            return A = null, t
        }, _ = e.getText = function(t) {
            var e, n = "",
                i = 0,
                o = t.nodeType;
            if (o) {
                if (1 === o || 9 === o || 11 === o) {
                    if ("string" == typeof t.textContent) return t.textContent;
                    for (t = t.firstChild; t; t = t.nextSibling) n += _(t)
                } else if (3 === o || 4 === o) return t.nodeValue
            } else
                for (; e = t[i++];) n += _(e);
            return n
        }, C = e.selectors = {
            cacheLength: 50,
            createPseudo: i,
            match: pt,
            attrHandle: {},
            find: {},
            relative: {
                ">": {
                    dir: "parentNode",
                    first: !0
                },
                " ": {
                    dir: "parentNode"
                },
                "+": {
                    dir: "previousSibling",
                    first: !0
                },
                "~": {
                    dir: "previousSibling"
                }
            },
            preFilter: {
                ATTR: function(t) {
                    return t[1] = t[1].replace(xt, wt), t[3] = (t[3] || t[4] || t[5] || "").replace(xt, wt), "~=" === t[2] && (t[3] = " " + t[3] + " "), t.slice(0, 4)
                },
                CHILD: function(t) {
                    return t[1] = t[1].toLowerCase(), "nth" === t[1].slice(0, 3) ? (t[3] || e.error(t[0]), t[4] = +(t[4] ? t[5] + (t[6] || 1) : 2 * ("even" === t[3] || "odd" === t[3])), t[5] = +(t[7] + t[8] || "odd" === t[3])) : t[3] && e.error(t[0]), t
                },
                PSEUDO: function(t) {
                    var e, n = !t[6] && t[2];
                    return pt.CHILD.test(t[0]) ? null : (t[3] ? t[2] = t[4] || t[5] || "" : n && ht.test(n) && (e = S(n, !0)) && (e = n.indexOf(")", n.length - e) - n.length) && (t[0] = t[0].slice(0, e), t[2] = n.slice(0, e)), t.slice(0, 3))
                }
            },
            filter: {
                TAG: function(t) {
                    var e = t.replace(xt, wt).toLowerCase();
                    return "*" === t ? function() {
                        return !0
                    } : function(t) {
                        return t.nodeName && t.nodeName.toLowerCase() === e
                    }
                },
                CLASS: function(t) {
                    var e = W[t + " "];
                    return e || (e = new RegExp("(^|" + nt + ")" + t + "(" + nt + "|$)")) && W(t, function(t) {
                        return e.test("string" == typeof t.className && t.className || "undefined" != typeof t.getAttribute && t.getAttribute("class") || "")
                    })
                },
                ATTR: function(t, n, i) {
                    return function(o) {
                        var s = e.attr(o, t);
                        return null == s ? "!=" === n : !n || (s += "", "=" === n ? s === i : "!=" === n ? s !== i : "^=" === n ? i && 0 === s.indexOf(i) : "*=" === n ? i && s.indexOf(i) > -1 : "$=" === n ? i && s.slice(-i.length) === i : "~=" === n ? (" " + s.replace(rt, " ") + " ").indexOf(i) > -1 : "|=" === n && (s === i || s.slice(0, i.length + 1) === i + "-"))
                    }
                },
                CHILD: function(t, e, n, i, o) {
                    var s = "nth" !== t.slice(0, 3),
                        r = "last" !== t.slice(-4),
                        a = "of-type" === e;
                    return 1 === i && 0 === o ? function(t) {
                        return !!t.parentNode
                    } : function(e, n, l) {
                        var c, u, h, d, p, f, g = s !== r ? "nextSibling" : "previousSibling",
                            m = e.parentNode,
                            v = a && e.nodeName.toLowerCase(),
                            y = !l && !a,
                            b = !1;
                        if (m) {
                            if (s) {
                                for (; g;) {
                                    for (d = e; d = d[g];)
                                        if (a ? d.nodeName.toLowerCase() === v : 1 === d.nodeType) return !1;
                                    f = g = "only" === t && !f && "nextSibling"
                                }
                                return !0
                            }
                            if (f = [r ? m.firstChild : m.lastChild], r && y) {
                                for (d = m, h = d[I] || (d[I] = {}), u = h[d.uniqueID] || (h[d.uniqueID] = {}), c = u[t] || [], p = c[0] === O && c[1], b = p && c[2], d = p && m.childNodes[p]; d = ++p && d && d[g] || (b = p = 0) || f.pop();)
                                    if (1 === d.nodeType && ++b && d === e) {
                                        u[t] = [O, p, b];
                                        break
                                    }
                            } else if (y && (d = e, h = d[I] || (d[I] = {}), u = h[d.uniqueID] || (h[d.uniqueID] = {}), c = u[t] || [], p = c[0] === O && c[1], b = p), b === !1)
                                for (;
                                    (d = ++p && d && d[g] || (b = p = 0) || f.pop()) && ((a ? d.nodeName.toLowerCase() !== v : 1 !== d.nodeType) || !++b || (y && (h = d[I] || (d[I] = {}), u = h[d.uniqueID] || (h[d.uniqueID] = {}), u[t] = [O, b]), d !== e)););
                            return b -= o, b === i || b % i === 0 && b / i >= 0
                        }
                    }
                },
                PSEUDO: function(t, n) {
                    var o, s = C.pseudos[t] || C.setFilters[t.toLowerCase()] || e.error("unsupported pseudo: " + t);
                    return s[I] ? s(n) : s.length > 1 ? (o = [t, t, "", n], C.setFilters.hasOwnProperty(t.toLowerCase()) ? i(function(t, e) {
                        for (var i, o = s(t, n), r = o.length; r--;) i = tt(t, o[r]), t[i] = !(e[i] = o[r])
                    }) : function(t) {
                        return s(t, 0, o)
                    }) : s
                }
            },
            pseudos: {
                not: i(function(t) {
                    var e = [],
                        n = [],
                        o = $(t.replace(at, "$1"));
                    return o[I] ? i(function(t, e, n, i) {
                        for (var s, r = o(t, null, i, []), a = t.length; a--;)(s = r[a]) && (t[a] = !(e[a] = s))
                    }) : function(t, i, s) {
                        return e[0] = t, o(e, null, s, n), e[0] = null, !n.pop()
                    }
                }),
                has: i(function(t) {
                    return function(n) {
                        return e(t, n).length > 0
                    }
                }),
                contains: i(function(t) {
                    return t = t.replace(xt, wt),
                        function(e) {
                            return (e.textContent || e.innerText || _(e)).indexOf(t) > -1
                        }
                }),
                lang: i(function(t) {
                    return dt.test(t || "") || e.error("unsupported lang: " + t), t = t.replace(xt, wt).toLowerCase(),
                        function(e) {
                            var n;
                            do
                                if (n = j ? e.lang : e.getAttribute("xml:lang") || e.getAttribute("lang")) return n = n.toLowerCase(), n === t || 0 === n.indexOf(t + "-"); while ((e = e.parentNode) && 1 === e.nodeType);
                            return !1
                        }
                }),
                target: function(e) {
                    var n = t.location && t.location.hash;
                    return n && n.slice(1) === e.id
                },
                root: function(t) {
                    return t === L
                },
                focus: function(t) {
                    return t === D.activeElement && (!D.hasFocus || D.hasFocus()) && !!(t.type || t.href || ~t.tabIndex)
                },
                enabled: function(t) {
                    return t.disabled === !1
                },
                disabled: function(t) {
                    return t.disabled === !0
                },
                checked: function(t) {
                    var e = t.nodeName.toLowerCase();
                    return "input" === e && !!t.checked || "option" === e && !!t.selected
                },
                selected: function(t) {
                    return t.parentNode && t.parentNode.selectedIndex, t.selected === !0
                },
                empty: function(t) {
                    for (t = t.firstChild; t; t = t.nextSibling)
                        if (t.nodeType < 6) return !1;
                    return !0
                },
                parent: function(t) {
                    return !C.pseudos.empty(t)
                },
                header: function(t) {
                    return gt.test(t.nodeName)
                },
                input: function(t) {
                    return ft.test(t.nodeName)
                },
                button: function(t) {
                    var e = t.nodeName.toLowerCase();
                    return "input" === e && "button" === t.type || "button" === e
                },
                text: function(t) {
                    var e;
                    return "input" === t.nodeName.toLowerCase() && "text" === t.type && (null == (e = t.getAttribute("type")) || "text" === e.toLowerCase())
                },
                first: c(function() {
                    return [0]
                }),
                last: c(function(t, e) {
                    return [e - 1]
                }),
                eq: c(function(t, e, n) {
                    return [0 > n ? n + e : n]
                }),
                even: c(function(t, e) {
                    for (var n = 0; e > n; n += 2) t.push(n);
                    return t
                }),
                odd: c(function(t, e) {
                    for (var n = 1; e > n; n += 2) t.push(n);
                    return t
                }),
                lt: c(function(t, e, n) {
                    for (var i = 0 > n ? n + e : n; --i >= 0;) t.push(i);
                    return t
                }),
                gt: c(function(t, e, n) {
                    for (var i = 0 > n ? n + e : n; ++i < e;) t.push(i);
                    return t
                })
            }
        }, C.pseudos.nth = C.pseudos.eq;
        for (x in {
                radio: !0,
                checkbox: !0,
                file: !0,
                password: !0,
                image: !0
            }) C.pseudos[x] = a(x);
        for (x in {
                submit: !0,
                reset: !0
            }) C.pseudos[x] = l(x);
        return h.prototype = C.filters = C.pseudos, C.setFilters = new h, S = e.tokenize = function(t, n) {
            var i, o, s, r, a, l, c, u = B[t + " "];
            if (u) return n ? 0 : u.slice(0);
            for (a = t, l = [], c = C.preFilter; a;) {
                i && !(o = lt.exec(a)) || (o && (a = a.slice(o[0].length) || a), l.push(s = [])), i = !1, (o = ct.exec(a)) && (i = o.shift(), s.push({
                    value: i,
                    type: o[0].replace(at, " ")
                }), a = a.slice(i.length));
                for (r in C.filter) !(o = pt[r].exec(a)) || c[r] && !(o = c[r](o)) || (i = o.shift(), s.push({
                    value: i,
                    type: r,
                    matches: o
                }), a = a.slice(i.length));
                if (!i) break
            }
            return n ? a.length : a ? e.error(t) : B(t, l).slice(0)
        }, $ = e.compile = function(t, e) {
            var n, i = [],
                o = [],
                s = X[t + " "];
            if (!s) {
                for (e || (e = S(t)), n = e.length; n--;) s = y(e[n]), s[I] ? i.push(s) : o.push(s);
                s = X(t, b(o, i)), s.selector = t
            }
            return s
        }, E = e.select = function(t, e, n, i) {
            var o, s, r, a, l, c = "function" == typeof t && t,
                h = !i && S(t = c.selector || t);
            if (n = n || [], 1 === h.length) {
                if (s = h[0] = h[0].slice(0), s.length > 2 && "ID" === (r = s[0]).type && w.getById && 9 === e.nodeType && j && C.relative[s[1].type]) {
                    if (e = (C.find.ID(r.matches[0].replace(xt, wt), e) || [])[0], !e) return n;
                    c && (e = e.parentNode), t = t.slice(s.shift().value.length)
                }
                for (o = pt.needsContext.test(t) ? 0 : s.length; o-- && (r = s[o], !C.relative[a = r.type]);)
                    if ((l = C.find[a]) && (i = l(r.matches[0].replace(xt, wt), yt.test(s[0].type) && u(e.parentNode) || e))) {
                        if (s.splice(o, 1), t = i.length && d(s), !t) return K.apply(n, i), n;
                        break
                    }
            }
            return (c || $(t, h))(i, e, !j, n, !e || yt.test(t) && u(e.parentNode) || e), n
        }, w.sortStable = I.split("").sort(Y).join("") === I, w.detectDuplicates = !!k, z(), w.sortDetached = o(function(t) {
            return 1 & t.compareDocumentPosition(D.createElement("div"))
        }), o(function(t) {
            return t.innerHTML = "<a href='#'></a>", "#" === t.firstChild.getAttribute("href")
        }) || s("type|href|height|width", function(t, e, n) {
            return n ? void 0 : t.getAttribute(e, "type" === e.toLowerCase() ? 1 : 2)
        }), w.attributes && o(function(t) {
            return t.innerHTML = "<input/>", t.firstChild.setAttribute("value", ""), "" === t.firstChild.getAttribute("value")
        }) || s("value", function(t, e, n) {
            return n || "input" !== t.nodeName.toLowerCase() ? void 0 : t.defaultValue
        }), o(function(t) {
            return null == t.getAttribute("disabled")
        }) || s(et, function(t, e, n) {
            var i;
            return n ? void 0 : t[e] === !0 ? e.toLowerCase() : (i = t.getAttributeNode(e)) && i.specified ? i.value : null
        }), e
    }(t);
    st.find = ut, st.expr = ut.selectors, st.expr[":"] = st.expr.pseudos, st.uniqueSort = st.unique = ut.uniqueSort, st.text = ut.getText, st.isXMLDoc = ut.isXML, st.contains = ut.contains;
    var ht = function(t, e, n) {
            for (var i = [], o = void 0 !== n;
                (t = t[e]) && 9 !== t.nodeType;)
                if (1 === t.nodeType) {
                    if (o && st(t).is(n)) break;
                    i.push(t)
                }
            return i
        },
        dt = function(t, e) {
            for (var n = []; t; t = t.nextSibling) 1 === t.nodeType && t !== e && n.push(t);
            return n
        },
        pt = st.expr.match.needsContext,
        ft = /^<([\w-]+)\s*\/?>(?:<\/\1>|)$/,
        gt = /^.[^:#\[\.,]*$/;
    st.filter = function(t, e, n) {
        var i = e[0];
        return n && (t = ":not(" + t + ")"), 1 === e.length && 1 === i.nodeType ? st.find.matchesSelector(i, t) ? [i] : [] : st.find.matches(t, st.grep(e, function(t) {
            return 1 === t.nodeType
        }))
    }, st.fn.extend({
        find: function(t) {
            var e, n = this.length,
                i = [],
                o = this;
            if ("string" != typeof t) return this.pushStack(st(t).filter(function() {
                for (e = 0; n > e; e++)
                    if (st.contains(o[e], this)) return !0
            }));
            for (e = 0; n > e; e++) st.find(t, o[e], i);
            return i = this.pushStack(n > 1 ? st.unique(i) : i), i.selector = this.selector ? this.selector + " " + t : t, i
        },
        filter: function(t) {
            return this.pushStack(i(this, t || [], !1))
        },
        not: function(t) {
            return this.pushStack(i(this, t || [], !0))
        },
        is: function(t) {
            return !!i(this, "string" == typeof t && pt.test(t) ? st(t) : t || [], !1).length
        }
    });
    var mt, vt = /^(?:\s*(<[\w\W]+>)[^>]*|#([\w-]*))$/,
        yt = st.fn.init = function(t, e, n) {
            var i, o;
            if (!t) return this;
            if (n = n || mt, "string" == typeof t) {
                if (i = "<" === t[0] && ">" === t[t.length - 1] && t.length >= 3 ? [null, t, null] : vt.exec(t), !i || !i[1] && e) return !e || e.jquery ? (e || n).find(t) : this.constructor(e).find(t);
                if (i[1]) {
                    if (e = e instanceof st ? e[0] : e, st.merge(this, st.parseHTML(i[1], e && e.nodeType ? e.ownerDocument || e : Q, !0)), ft.test(i[1]) && st.isPlainObject(e))
                        for (i in e) st.isFunction(this[i]) ? this[i](e[i]) : this.attr(i, e[i]);
                    return this
                }
                return o = Q.getElementById(i[2]), o && o.parentNode && (this.length = 1, this[0] = o), this.context = Q, this.selector = t, this
            }
            return t.nodeType ? (this.context = this[0] = t, this.length = 1, this) : st.isFunction(t) ? void 0 !== n.ready ? n.ready(t) : t(st) : (void 0 !== t.selector && (this.selector = t.selector, this.context = t.context), st.makeArray(t, this))
        };
    yt.prototype = st.fn, mt = st(Q);
    var bt = /^(?:parents|prev(?:Until|All))/,
        xt = {
            children: !0,
            contents: !0,
            next: !0,
            prev: !0
        };
    st.fn.extend({
        has: function(t) {
            var e = st(t, this),
                n = e.length;
            return this.filter(function() {
                for (var t = 0; n > t; t++)
                    if (st.contains(this, e[t])) return !0
            })
        },
        closest: function(t, e) {
            for (var n, i = 0, o = this.length, s = [], r = pt.test(t) || "string" != typeof t ? st(t, e || this.context) : 0; o > i; i++)
                for (n = this[i]; n && n !== e; n = n.parentNode)
                    if (n.nodeType < 11 && (r ? r.index(n) > -1 : 1 === n.nodeType && st.find.matchesSelector(n, t))) {
                        s.push(n);
                        break
                    }
            return this.pushStack(s.length > 1 ? st.uniqueSort(s) : s)
        },
        index: function(t) {
            return t ? "string" == typeof t ? J.call(st(t), this[0]) : J.call(this, t.jquery ? t[0] : t) : this[0] && this[0].parentNode ? this.first().prevAll().length : -1
        },
        add: function(t, e) {
            return this.pushStack(st.uniqueSort(st.merge(this.get(), st(t, e))))
        },
        addBack: function(t) {
            return this.add(null == t ? this.prevObject : this.prevObject.filter(t))
        }
    }), st.each({
        parent: function(t) {
            var e = t.parentNode;
            return e && 11 !== e.nodeType ? e : null
        },
        parents: function(t) {
            return ht(t, "parentNode")
        },
        parentsUntil: function(t, e, n) {
            return ht(t, "parentNode", n)
        },
        next: function(t) {
            return o(t, "nextSibling")
        },
        prev: function(t) {
            return o(t, "previousSibling")
        },
        nextAll: function(t) {
            return ht(t, "nextSibling")
        },
        prevAll: function(t) {
            return ht(t, "previousSibling")
        },
        nextUntil: function(t, e, n) {
            return ht(t, "nextSibling", n)
        },
        prevUntil: function(t, e, n) {
            return ht(t, "previousSibling", n)
        },
        siblings: function(t) {
            return dt((t.parentNode || {}).firstChild, t)
        },
        children: function(t) {
            return dt(t.firstChild)
        },
        contents: function(t) {
            return t.contentDocument || st.merge([], t.childNodes)
        }
    }, function(t, e) {
        st.fn[t] = function(n, i) {
            var o = st.map(this, e, n);
            return "Until" !== t.slice(-5) && (i = n), i && "string" == typeof i && (o = st.filter(i, o)), this.length > 1 && (xt[t] || st.uniqueSort(o), bt.test(t) && o.reverse()), this.pushStack(o)
        }
    });
    var wt = /\S+/g;
    st.Callbacks = function(t) {
        t = "string" == typeof t ? s(t) : st.extend({}, t);
        var e, n, i, o, r = [],
            a = [],
            l = -1,
            c = function() {
                for (o = t.once, i = e = !0; a.length; l = -1)
                    for (n = a.shift(); ++l < r.length;) r[l].apply(n[0], n[1]) === !1 && t.stopOnFalse && (l = r.length, n = !1);
                t.memory || (n = !1), e = !1, o && (r = n ? [] : "")
            },
            u = {
                add: function() {
                    return r && (n && !e && (l = r.length - 1, a.push(n)), function e(n) {
                        st.each(n, function(n, i) {
                            st.isFunction(i) ? t.unique && u.has(i) || r.push(i) : i && i.length && "string" !== st.type(i) && e(i)
                        })
                    }(arguments), n && !e && c()), this
                },
                remove: function() {
                    return st.each(arguments, function(t, e) {
                        for (var n;
                            (n = st.inArray(e, r, n)) > -1;) r.splice(n, 1), l >= n && l--
                    }), this
                },
                has: function(t) {
                    return t ? st.inArray(t, r) > -1 : r.length > 0
                },
                empty: function() {
                    return r && (r = []), this
                },
                disable: function() {
                    return o = a = [], r = n = "", this
                },
                disabled: function() {
                    return !r
                },
                lock: function() {
                    return o = a = [], n || (r = n = ""), this
                },
                locked: function() {
                    return !!o
                },
                fireWith: function(t, n) {
                    return o || (n = n || [], n = [t, n.slice ? n.slice() : n], a.push(n), e || c()), this
                },
                fire: function() {
                    return u.fireWith(this, arguments), this
                },
                fired: function() {
                    return !!i
                }
            };
        return u
    }, st.extend({
        Deferred: function(t) {
            var e = [
                    ["resolve", "done", st.Callbacks("once memory"), "resolved"],
                    ["reject", "fail", st.Callbacks("once memory"), "rejected"],
                    ["notify", "progress", st.Callbacks("memory")]
                ],
                n = "pending",
                i = {
                    state: function() {
                        return n
                    },
                    always: function() {
                        return o.done(arguments).fail(arguments), this
                    },
                    then: function() {
                        var t = arguments;
                        return st.Deferred(function(n) {
                            st.each(e, function(e, s) {
                                var r = st.isFunction(t[e]) && t[e];
                                o[s[1]](function() {
                                    var t = r && r.apply(this, arguments);
                                    t && st.isFunction(t.promise) ? t.promise().progress(n.notify).done(n.resolve).fail(n.reject) : n[s[0] + "With"](this === i ? n.promise() : this, r ? [t] : arguments)
                                })
                            }), t = null
                        }).promise()
                    },
                    promise: function(t) {
                        return null != t ? st.extend(t, i) : i
                    }
                },
                o = {};
            return i.pipe = i.then, st.each(e, function(t, s) {
                var r = s[2],
                    a = s[3];
                i[s[1]] = r.add, a && r.add(function() {
                    n = a
                }, e[1 ^ t][2].disable, e[2][2].lock), o[s[0]] = function() {
                    return o[s[0] + "With"](this === o ? i : this, arguments), this
                }, o[s[0] + "With"] = r.fireWith
            }), i.promise(o), t && t.call(o, o), o
        },
        when: function(t) {
            var e, n, i, o = 0,
                s = Z.call(arguments),
                r = s.length,
                a = 1 !== r || t && st.isFunction(t.promise) ? r : 0,
                l = 1 === a ? t : st.Deferred(),
                c = function(t, n, i) {
                    return function(o) {
                        n[t] = this, i[t] = arguments.length > 1 ? Z.call(arguments) : o, i === e ? l.notifyWith(n, i) : --a || l.resolveWith(n, i)
                    }
                };
            if (r > 1)
                for (e = new Array(r), n = new Array(r), i = new Array(r); r > o; o++) s[o] && st.isFunction(s[o].promise) ? s[o].promise().progress(c(o, n, e)).done(c(o, i, s)).fail(l.reject) : --a;
            return a || l.resolveWith(i, s), l.promise()
        }
    });
    var Ct;
    st.fn.ready = function(t) {
        return st.ready.promise().done(t), this
    }, st.extend({
        isReady: !1,
        readyWait: 1,
        holdReady: function(t) {
            t ? st.readyWait++ : st.ready(!0)
        },
        ready: function(t) {
            (t === !0 ? --st.readyWait : st.isReady) || (st.isReady = !0, t !== !0 && --st.readyWait > 0 || (Ct.resolveWith(Q, [st]), st.fn.triggerHandler && (st(Q).triggerHandler("ready"), st(Q).off("ready"))))
        }
    }), st.ready.promise = function(e) {
        return Ct || (Ct = st.Deferred(), "complete" === Q.readyState || "loading" !== Q.readyState && !Q.documentElement.doScroll ? t.setTimeout(st.ready) : (Q.addEventListener("DOMContentLoaded", r), t.addEventListener("load", r))), Ct.promise(e)
    }, st.ready.promise();
    var _t = function(t, e, n, i, o, s, r) {
            var a = 0,
                l = t.length,
                c = null == n;
            if ("object" === st.type(n)) {
                o = !0;
                for (a in n) _t(t, e, a, n[a], !0, s, r)
            } else if (void 0 !== i && (o = !0, st.isFunction(i) || (r = !0), c && (r ? (e.call(t, i), e = null) : (c = e, e = function(t, e, n) {
                    return c.call(st(t), n)
                })), e))
                for (; l > a; a++) e(t[a], n, r ? i : i.call(t[a], a, e(t[a], n)));
            return o ? t : c ? e.call(t) : l ? e(t[0], n) : s
        },
        Tt = function(t) {
            return 1 === t.nodeType || 9 === t.nodeType || !+t.nodeType
        };
    a.uid = 1, a.prototype = {
        register: function(t, e) {
            var n = e || {};
            return t.nodeType ? t[this.expando] = n : Object.defineProperty(t, this.expando, {
                value: n,
                writable: !0,
                configurable: !0
            }), t[this.expando]
        },
        cache: function(t) {
            if (!Tt(t)) return {};
            var e = t[this.expando];
            return e || (e = {}, Tt(t) && (t.nodeType ? t[this.expando] = e : Object.defineProperty(t, this.expando, {
                value: e,
                configurable: !0
            }))), e
        },
        set: function(t, e, n) {
            var i, o = this.cache(t);
            if ("string" == typeof e) o[e] = n;
            else
                for (i in e) o[i] = e[i];
            return o
        },
        get: function(t, e) {
            return void 0 === e ? this.cache(t) : t[this.expando] && t[this.expando][e]
        },
        access: function(t, e, n) {
            var i;
            return void 0 === e || e && "string" == typeof e && void 0 === n ? (i = this.get(t, e), void 0 !== i ? i : this.get(t, st.camelCase(e))) : (this.set(t, e, n), void 0 !== n ? n : e)
        },
        remove: function(t, e) {
            var n, i, o, s = t[this.expando];
            if (void 0 !== s) {
                if (void 0 === e) this.register(t);
                else {
                    st.isArray(e) ? i = e.concat(e.map(st.camelCase)) : (o = st.camelCase(e), e in s ? i = [e, o] : (i = o, i = i in s ? [i] : i.match(wt) || [])), n = i.length;
                    for (; n--;) delete s[i[n]]
                }(void 0 === e || st.isEmptyObject(s)) && (t.nodeType ? t[this.expando] = void 0 : delete t[this.expando])
            }
        },
        hasData: function(t) {
            var e = t[this.expando];
            return void 0 !== e && !st.isEmptyObject(e)
        }
    };
    var St = new a,
        $t = new a,
        Et = /^(?:\{[\w\W]*\}|\[[\w\W]*\])$/,
        Pt = /[A-Z]/g;
    st.extend({
        hasData: function(t) {
            return $t.hasData(t) || St.hasData(t)
        },
        data: function(t, e, n) {
            return $t.access(t, e, n)
        },
        removeData: function(t, e) {
            $t.remove(t, e)
        },
        _data: function(t, e, n) {
            return St.access(t, e, n)
        },
        _removeData: function(t, e) {
            St.remove(t, e)
        }
    }), st.fn.extend({
        data: function(t, e) {
            var n, i, o, s = this[0],
                r = s && s.attributes;
            if (void 0 === t) {
                if (this.length && (o = $t.get(s), 1 === s.nodeType && !St.get(s, "hasDataAttrs"))) {
                    for (n = r.length; n--;) r[n] && (i = r[n].name, 0 === i.indexOf("data-") && (i = st.camelCase(i.slice(5)), l(s, i, o[i])));
                    St.set(s, "hasDataAttrs", !0)
                }
                return o
            }
            return "object" == typeof t ? this.each(function() {
                $t.set(this, t)
            }) : _t(this, function(e) {
                var n, i;
                if (s && void 0 === e) {
                    if (n = $t.get(s, t) || $t.get(s, t.replace(Pt, "-$&").toLowerCase()), void 0 !== n) return n;
                    if (i = st.camelCase(t), n = $t.get(s, i), void 0 !== n) return n;
                    if (n = l(s, i, void 0), void 0 !== n) return n
                } else i = st.camelCase(t), this.each(function() {
                    var n = $t.get(this, i);
                    $t.set(this, i, e), t.indexOf("-") > -1 && void 0 !== n && $t.set(this, t, e)
                })
            }, null, e, arguments.length > 1, null, !0)
        },
        removeData: function(t) {
            return this.each(function() {
                $t.remove(this, t)
            })
        }
    }), st.extend({
        queue: function(t, e, n) {
            var i;
            return t ? (e = (e || "fx") + "queue", i = St.get(t, e), n && (!i || st.isArray(n) ? i = St.access(t, e, st.makeArray(n)) : i.push(n)), i || []) : void 0
        },
        dequeue: function(t, e) {
            e = e || "fx";
            var n = st.queue(t, e),
                i = n.length,
                o = n.shift(),
                s = st._queueHooks(t, e),
                r = function() {
                    st.dequeue(t, e)
                };
            "inprogress" === o && (o = n.shift(), i--), o && ("fx" === e && n.unshift("inprogress"), delete s.stop, o.call(t, r, s)), !i && s && s.empty.fire()
        },
        _queueHooks: function(t, e) {
            var n = e + "queueHooks";
            return St.get(t, n) || St.access(t, n, {
                empty: st.Callbacks("once memory").add(function() {
                    St.remove(t, [e + "queue", n])
                })
            })
        }
    }), st.fn.extend({
        queue: function(t, e) {
            var n = 2;
            return "string" != typeof t && (e = t, t = "fx", n--), arguments.length < n ? st.queue(this[0], t) : void 0 === e ? this : this.each(function() {
                var n = st.queue(this, t, e);
                st._queueHooks(this, t), "fx" === t && "inprogress" !== n[0] && st.dequeue(this, t)
            })
        },
        dequeue: function(t) {
            return this.each(function() {
                st.dequeue(this, t)
            })
        },
        clearQueue: function(t) {
            return this.queue(t || "fx", [])
        },
        promise: function(t, e) {
            var n, i = 1,
                o = st.Deferred(),
                s = this,
                r = this.length,
                a = function() {
                    --i || o.resolveWith(s, [s])
                };
            for ("string" != typeof t && (e = t, t = void 0), t = t || "fx"; r--;) n = St.get(s[r], t + "queueHooks"), n && n.empty && (i++, n.empty.add(a));
            return a(), o.promise(e)
        }
    });
    var At = /[+-]?(?:\d*\.|)\d+(?:[eE][+-]?\d+|)/.source,
        kt = new RegExp("^(?:([+-])=|)(" + At + ")([a-z%]*)$", "i"),
        zt = ["Top", "Right", "Bottom", "Left"],
        Dt = function(t, e) {
            return t = e || t, "none" === st.css(t, "display") || !st.contains(t.ownerDocument, t)
        },
        Lt = /^(?:checkbox|radio)$/i,
        jt = /<([\w:-]+)/,
        Nt = /^$|\/(?:java|ecma)script/i,
        Ft = {
            option: [1, "<select multiple='multiple'>", "</select>"],
            thead: [1, "<table>", "</table>"],
            col: [2, "<table><colgroup>", "</colgroup></table>"],
            tr: [2, "<table><tbody>", "</tbody></table>"],
            td: [3, "<table><tbody><tr>", "</tr></tbody></table>"],
            _default: [0, "", ""]
        };
    Ft.optgroup = Ft.option, Ft.tbody = Ft.tfoot = Ft.colgroup = Ft.caption = Ft.thead, Ft.th = Ft.td;
    var Mt = /<|&#?\w+;/;
    ! function() {
        var t = Q.createDocumentFragment(),
            e = t.appendChild(Q.createElement("div")),
            n = Q.createElement("input");
        n.setAttribute("type", "radio"), n.setAttribute("checked", "checked"), n.setAttribute("name", "t"), e.appendChild(n), it.checkClone = e.cloneNode(!0).cloneNode(!0).lastChild.checked, e.innerHTML = "<textarea>x</textarea>", it.noCloneChecked = !!e.cloneNode(!0).lastChild.defaultValue
    }();
    var qt = /^key/,
        It = /^(?:mouse|pointer|contextmenu|drag|drop)|click/,
        Rt = /^([^.]*)(?:\.(.+)|)/;
    st.event = {
        global: {},
        add: function(t, e, n, i, o) {
            var s, r, a, l, c, u, h, d, p, f, g, m = St.get(t);
            if (m)
                for (n.handler && (s = n, n = s.handler, o = s.selector), n.guid || (n.guid = st.guid++), (l = m.events) || (l = m.events = {}), (r = m.handle) || (r = m.handle = function(e) {
                        return "undefined" != typeof st && st.event.triggered !== e.type ? st.event.dispatch.apply(t, arguments) : void 0
                    }), e = (e || "").match(wt) || [""], c = e.length; c--;) a = Rt.exec(e[c]) || [], p = g = a[1], f = (a[2] || "").split(".").sort(), p && (h = st.event.special[p] || {}, p = (o ? h.delegateType : h.bindType) || p, h = st.event.special[p] || {}, u = st.extend({
                    type: p,
                    origType: g,
                    data: i,
                    handler: n,
                    guid: n.guid,
                    selector: o,
                    needsContext: o && st.expr.match.needsContext.test(o),
                    namespace: f.join(".")
                }, s), (d = l[p]) || (d = l[p] = [], d.delegateCount = 0, h.setup && h.setup.call(t, i, f, r) !== !1 || t.addEventListener && t.addEventListener(p, r)), h.add && (h.add.call(t, u), u.handler.guid || (u.handler.guid = n.guid)), o ? d.splice(d.delegateCount++, 0, u) : d.push(u), st.event.global[p] = !0)
        },
        remove: function(t, e, n, i, o) {
            var s, r, a, l, c, u, h, d, p, f, g, m = St.hasData(t) && St.get(t);
            if (m && (l = m.events)) {
                for (e = (e || "").match(wt) || [""], c = e.length; c--;)
                    if (a = Rt.exec(e[c]) || [], p = g = a[1], f = (a[2] || "").split(".").sort(), p) {
                        for (h = st.event.special[p] || {}, p = (i ? h.delegateType : h.bindType) || p, d = l[p] || [], a = a[2] && new RegExp("(^|\\.)" + f.join("\\.(?:.*\\.|)") + "(\\.|$)"), r = s = d.length; s--;) u = d[s], !o && g !== u.origType || n && n.guid !== u.guid || a && !a.test(u.namespace) || i && i !== u.selector && ("**" !== i || !u.selector) || (d.splice(s, 1), u.selector && d.delegateCount--, h.remove && h.remove.call(t, u));
                        r && !d.length && (h.teardown && h.teardown.call(t, f, m.handle) !== !1 || st.removeEvent(t, p, m.handle), delete l[p])
                    } else
                        for (p in l) st.event.remove(t, p + e[c], n, i, !0);
                st.isEmptyObject(l) && St.remove(t, "handle events")
            }
        },
        dispatch: function(t) {
            t = st.event.fix(t);
            var e, n, i, o, s, r = [],
                a = Z.call(arguments),
                l = (St.get(this, "events") || {})[t.type] || [],
                c = st.event.special[t.type] || {};
            if (a[0] = t, t.delegateTarget = this, !c.preDispatch || c.preDispatch.call(this, t) !== !1) {
                for (r = st.event.handlers.call(this, t, l), e = 0;
                    (o = r[e++]) && !t.isPropagationStopped();)
                    for (t.currentTarget = o.elem, n = 0;
                        (s = o.handlers[n++]) && !t.isImmediatePropagationStopped();) t.rnamespace && !t.rnamespace.test(s.namespace) || (t.handleObj = s, t.data = s.data, i = ((st.event.special[s.origType] || {}).handle || s.handler).apply(o.elem, a), void 0 !== i && (t.result = i) === !1 && (t.preventDefault(), t.stopPropagation()));
                return c.postDispatch && c.postDispatch.call(this, t), t.result
            }
        },
        handlers: function(t, e) {
            var n, i, o, s, r = [],
                a = e.delegateCount,
                l = t.target;
            if (a && l.nodeType && ("click" !== t.type || isNaN(t.button) || t.button < 1))
                for (; l !== this; l = l.parentNode || this)
                    if (1 === l.nodeType && (l.disabled !== !0 || "click" !== t.type)) {
                        for (i = [], n = 0; a > n; n++) s = e[n], o = s.selector + " ", void 0 === i[o] && (i[o] = s.needsContext ? st(o, this).index(l) > -1 : st.find(o, this, null, [l]).length), i[o] && i.push(s);
                        i.length && r.push({
                            elem: l,
                            handlers: i
                        })
                    }
            return a < e.length && r.push({
                elem: this,
                handlers: e.slice(a)
            }), r
        },
        props: "altKey bubbles cancelable ctrlKey currentTarget detail eventPhase metaKey relatedTarget shiftKey target timeStamp view which".split(" "),
        fixHooks: {},
        keyHooks: {
            props: "char charCode key keyCode".split(" "),
            filter: function(t, e) {
                return null == t.which && (t.which = null != e.charCode ? e.charCode : e.keyCode), t
            }
        },
        mouseHooks: {
            props: "button buttons clientX clientY offsetX offsetY pageX pageY screenX screenY toElement".split(" "),
            filter: function(t, e) {
                var n, i, o, s = e.button;
                return null == t.pageX && null != e.clientX && (n = t.target.ownerDocument || Q, i = n.documentElement, o = n.body, t.pageX = e.clientX + (i && i.scrollLeft || o && o.scrollLeft || 0) - (i && i.clientLeft || o && o.clientLeft || 0), t.pageY = e.clientY + (i && i.scrollTop || o && o.scrollTop || 0) - (i && i.clientTop || o && o.clientTop || 0)), t.which || void 0 === s || (t.which = 1 & s ? 1 : 2 & s ? 3 : 4 & s ? 2 : 0), t
            }
        },
        fix: function(t) {
            if (t[st.expando]) return t;
            var e, n, i, o = t.type,
                s = t,
                r = this.fixHooks[o];
            for (r || (this.fixHooks[o] = r = It.test(o) ? this.mouseHooks : qt.test(o) ? this.keyHooks : {}), i = r.props ? this.props.concat(r.props) : this.props, t = new st.Event(s), e = i.length; e--;) n = i[e], t[n] = s[n];
            return t.target || (t.target = Q), 3 === t.target.nodeType && (t.target = t.target.parentNode), r.filter ? r.filter(t, s) : t
        },
        special: {
            load: {
                noBubble: !0
            },
            focus: {
                trigger: function() {
                    return this !== g() && this.focus ? (this.focus(), !1) : void 0
                },
                delegateType: "focusin"
            },
            blur: {
                trigger: function() {
                    return this === g() && this.blur ? (this.blur(), !1) : void 0
                },
                delegateType: "focusout"
            },
            click: {
                trigger: function() {
                    return "checkbox" === this.type && this.click && st.nodeName(this, "input") ? (this.click(), !1) : void 0
                },
                _default: function(t) {
                    return st.nodeName(t.target, "a")
                }
            },
            beforeunload: {
                postDispatch: function(t) {
                    void 0 !== t.result && t.originalEvent && (t.originalEvent.returnValue = t.result)
                }
            }
        }
    }, st.removeEvent = function(t, e, n) {
        t.removeEventListener && t.removeEventListener(e, n)
    }, st.Event = function(t, e) {
        return this instanceof st.Event ? (t && t.type ? (this.originalEvent = t, this.type = t.type, this.isDefaultPrevented = t.defaultPrevented || void 0 === t.defaultPrevented && t.returnValue === !1 ? p : f) : this.type = t, e && st.extend(this, e), this.timeStamp = t && t.timeStamp || st.now(), void(this[st.expando] = !0)) : new st.Event(t, e)
    }, st.Event.prototype = {
        constructor: st.Event,
        isDefaultPrevented: f,
        isPropagationStopped: f,
        isImmediatePropagationStopped: f,
        preventDefault: function() {
            var t = this.originalEvent;
            this.isDefaultPrevented = p, t && t.preventDefault()
        },
        stopPropagation: function() {
            var t = this.originalEvent;
            this.isPropagationStopped = p, t && t.stopPropagation()
        },
        stopImmediatePropagation: function() {
            var t = this.originalEvent;
            this.isImmediatePropagationStopped = p, t && t.stopImmediatePropagation(), this.stopPropagation()
        }
    }, st.each({
        mouseenter: "mouseover",
        mouseleave: "mouseout",
        pointerenter: "pointerover",
        pointerleave: "pointerout"
    }, function(t, e) {
        st.event.special[t] = {
            delegateType: e,
            bindType: e,
            handle: function(t) {
                var n, i = this,
                    o = t.relatedTarget,
                    s = t.handleObj;
                return o && (o === i || st.contains(i, o)) || (t.type = s.origType, n = s.handler.apply(this, arguments), t.type = e), n
            }
        }
    }), st.fn.extend({
        on: function(t, e, n, i) {
            return m(this, t, e, n, i)
        },
        one: function(t, e, n, i) {
            return m(this, t, e, n, i, 1)
        },
        off: function(t, e, n) {
            var i, o;
            if (t && t.preventDefault && t.handleObj) return i = t.handleObj, st(t.delegateTarget).off(i.namespace ? i.origType + "." + i.namespace : i.origType, i.selector, i.handler), this;
            if ("object" == typeof t) {
                for (o in t) this.off(o, e, t[o]);
                return this
            }
            return e !== !1 && "function" != typeof e || (n = e, e = void 0), n === !1 && (n = f), this.each(function() {
                st.event.remove(this, t, n, e)
            })
        }
    });
    var Ot = /<(?!area|br|col|embed|hr|img|input|link|meta|param)(([\w:-]+)[^>]*)\/>/gi,
        Ht = /<script|<style|<link/i,
        Wt = /checked\s*(?:[^=]|=\s*.checked.)/i,
        Bt = /^true\/(.*)/,
        Xt = /^\s*<!(?:\[CDATA\[|--)|(?:\]\]|--)>\s*$/g;
    st.extend({
        htmlPrefilter: function(t) {
            return t.replace(Ot, "<$1></$2>")
        },
        clone: function(t, e, n) {
            var i, o, s, r, a = t.cloneNode(!0),
                l = st.contains(t.ownerDocument, t);
            if (!(it.noCloneChecked || 1 !== t.nodeType && 11 !== t.nodeType || st.isXMLDoc(t)))
                for (r = u(a), s = u(t), i = 0, o = s.length; o > i; i++) w(s[i], r[i]);
            if (e)
                if (n)
                    for (s = s || u(t), r = r || u(a), i = 0, o = s.length; o > i; i++) x(s[i], r[i]);
                else x(t, a);
            return r = u(a, "script"), r.length > 0 && h(r, !l && u(t, "script")), a
        },
        cleanData: function(t) {
            for (var e, n, i, o = st.event.special, s = 0; void 0 !== (n = t[s]); s++)
                if (Tt(n)) {
                    if (e = n[St.expando]) {
                        if (e.events)
                            for (i in e.events) o[i] ? st.event.remove(n, i) : st.removeEvent(n, i, e.handle);
                        n[St.expando] = void 0
                    }
                    n[$t.expando] && (n[$t.expando] = void 0)
                }
        }
    }), st.fn.extend({
        domManip: C,
        detach: function(t) {
            return _(this, t, !0)
        },
        remove: function(t) {
            return _(this, t)
        },
        text: function(t) {
            return _t(this, function(t) {
                return void 0 === t ? st.text(this) : this.empty().each(function() {
                    1 !== this.nodeType && 11 !== this.nodeType && 9 !== this.nodeType || (this.textContent = t)
                })
            }, null, t, arguments.length)
        },
        append: function() {
            return C(this, arguments, function(t) {
                if (1 === this.nodeType || 11 === this.nodeType || 9 === this.nodeType) {
                    var e = v(this, t);
                    e.appendChild(t)
                }
            })
        },
        prepend: function() {
            return C(this, arguments, function(t) {
                if (1 === this.nodeType || 11 === this.nodeType || 9 === this.nodeType) {
                    var e = v(this, t);
                    e.insertBefore(t, e.firstChild)
                }
            })
        },
        before: function() {
            return C(this, arguments, function(t) {
                this.parentNode && this.parentNode.insertBefore(t, this)
            })
        },
        after: function() {
            return C(this, arguments, function(t) {
                this.parentNode && this.parentNode.insertBefore(t, this.nextSibling)
            })
        },
        empty: function() {
            for (var t, e = 0; null != (t = this[e]); e++) 1 === t.nodeType && (st.cleanData(u(t, !1)), t.textContent = "");
            return this
        },
        clone: function(t, e) {
            return t = null != t && t, e = null == e ? t : e, this.map(function() {
                return st.clone(this, t, e)
            })
        },
        html: function(t) {
            return _t(this, function(t) {
                var e = this[0] || {},
                    n = 0,
                    i = this.length;
                if (void 0 === t && 1 === e.nodeType) return e.innerHTML;
                if ("string" == typeof t && !Ht.test(t) && !Ft[(jt.exec(t) || ["", ""])[1].toLowerCase()]) {
                    t = st.htmlPrefilter(t);
                    try {
                        for (; i > n; n++) e = this[n] || {}, 1 === e.nodeType && (st.cleanData(u(e, !1)), e.innerHTML = t);
                        e = 0
                    } catch (t) {}
                }
                e && this.empty().append(t)
            }, null, t, arguments.length)
        },
        replaceWith: function() {
            var t = [];
            return C(this, arguments, function(e) {
                var n = this.parentNode;
                st.inArray(this, t) < 0 && (st.cleanData(u(this)), n && n.replaceChild(e, this))
            }, t)
        }
    }), st.each({
        appendTo: "append",
        prependTo: "prepend",
        insertBefore: "before",
        insertAfter: "after",
        replaceAll: "replaceWith"
    }, function(t, e) {
        st.fn[t] = function(t) {
            for (var n, i = [], o = st(t), s = o.length - 1, r = 0; s >= r; r++) n = r === s ? this : this.clone(!0), st(o[r])[e](n), K.apply(i, n.get());
            return this.pushStack(i)
        }
    });
    var Yt, Ut = {
            HTML: "block",
            BODY: "block"
        },
        Vt = /^margin/,
        Qt = new RegExp("^(" + At + ")(?!px)[a-z%]+$", "i"),
        Zt = function(e) {
            var n = e.ownerDocument.defaultView;
            return n && n.opener || (n = t), n.getComputedStyle(e)
        },
        Gt = function(t, e, n, i) {
            var o, s, r = {};
            for (s in e) r[s] = t.style[s], t.style[s] = e[s];
            o = n.apply(t, i || []);
            for (s in e) t.style[s] = r[s];
            return o
        },
        Kt = Q.documentElement;
    ! function() {
        function e() {
            a.style.cssText = "-webkit-box-sizing:border-box;-moz-box-sizing:border-box;box-sizing:border-box;position:relative;display:block;margin:auto;border:1px;padding:1px;top:1%;width:50%", a.innerHTML = "", Kt.appendChild(r);
            var e = t.getComputedStyle(a);
            n = "1%" !== e.top, s = "2px" === e.marginLeft, i = "4px" === e.width, a.style.marginRight = "50%", o = "4px" === e.marginRight, Kt.removeChild(r)
        }
        var n, i, o, s, r = Q.createElement("div"),
            a = Q.createElement("div");
        a.style && (a.style.backgroundClip = "content-box", a.cloneNode(!0).style.backgroundClip = "", it.clearCloneStyle = "content-box" === a.style.backgroundClip, r.style.cssText = "border:0;width:8px;height:0;top:0;left:-9999px;padding:0;margin-top:1px;position:absolute", r.appendChild(a), st.extend(it, {
            pixelPosition: function() {
                return e(), n
            },
            boxSizingReliable: function() {
                return null == i && e(), i
            },
            pixelMarginRight: function() {
                return null == i && e(), o
            },
            reliableMarginLeft: function() {
                return null == i && e(), s
            },
            reliableMarginRight: function() {
                var e, n = a.appendChild(Q.createElement("div"));
                return n.style.cssText = a.style.cssText = "-webkit-box-sizing:content-box;box-sizing:content-box;display:block;margin:0;border:0;padding:0", n.style.marginRight = n.style.width = "0", a.style.width = "1px", Kt.appendChild(r), e = !parseFloat(t.getComputedStyle(n).marginRight), Kt.removeChild(r), a.removeChild(n), e
            }
        }))
    }();
    var Jt = /^(none|table(?!-c[ea]).+)/,
        te = {
            position: "absolute",
            visibility: "hidden",
            display: "block"
        },
        ee = {
            letterSpacing: "0",
            fontWeight: "400"
        },
        ne = ["Webkit", "O", "Moz", "ms"],
        ie = Q.createElement("div").style;
    st.extend({
        cssHooks: {
            opacity: {
                get: function(t, e) {
                    if (e) {
                        var n = $(t, "opacity");
                        return "" === n ? "1" : n
                    }
                }
            }
        },
        cssNumber: {
            animationIterationCount: !0,
            columnCount: !0,
            fillOpacity: !0,
            flexGrow: !0,
            flexShrink: !0,
            fontWeight: !0,
            lineHeight: !0,
            opacity: !0,
            order: !0,
            orphans: !0,
            widows: !0,
            zIndex: !0,
            zoom: !0
        },
        cssProps: {
            float: "cssFloat"
        },
        style: function(t, e, n, i) {
            if (t && 3 !== t.nodeType && 8 !== t.nodeType && t.style) {
                var o, s, r, a = st.camelCase(e),
                    l = t.style;
                return e = st.cssProps[a] || (st.cssProps[a] = P(a) || a), r = st.cssHooks[e] || st.cssHooks[a], void 0 === n ? r && "get" in r && void 0 !== (o = r.get(t, !1, i)) ? o : l[e] : (s = typeof n, "string" === s && (o = kt.exec(n)) && o[1] && (n = c(t, e, o), s = "number"), void(null != n && n === n && ("number" === s && (n += o && o[3] || (st.cssNumber[a] ? "" : "px")), it.clearCloneStyle || "" !== n || 0 !== e.indexOf("background") || (l[e] = "inherit"), r && "set" in r && void 0 === (n = r.set(t, n, i)) || (l[e] = n))))
            }
        },
        css: function(t, e, n, i) {
            var o, s, r, a = st.camelCase(e);
            return e = st.cssProps[a] || (st.cssProps[a] = P(a) || a), r = st.cssHooks[e] || st.cssHooks[a], r && "get" in r && (o = r.get(t, !0, n)), void 0 === o && (o = $(t, e, i)), "normal" === o && e in ee && (o = ee[e]), "" === n || n ? (s = parseFloat(o), n === !0 || isFinite(s) ? s || 0 : o) : o
        }
    }), st.each(["height", "width"], function(t, e) {
        st.cssHooks[e] = {
            get: function(t, n, i) {
                return n ? Jt.test(st.css(t, "display")) && 0 === t.offsetWidth ? Gt(t, te, function() {
                    return z(t, e, i)
                }) : z(t, e, i) : void 0
            },
            set: function(t, n, i) {
                var o, s = i && Zt(t),
                    r = i && k(t, e, i, "border-box" === st.css(t, "boxSizing", !1, s), s);
                return r && (o = kt.exec(n)) && "px" !== (o[3] || "px") && (t.style[e] = n, n = st.css(t, e)), A(t, n, r)
            }
        }
    }), st.cssHooks.marginLeft = E(it.reliableMarginLeft, function(t, e) {
        return e ? (parseFloat($(t, "marginLeft")) || t.getBoundingClientRect().left - Gt(t, {
            marginLeft: 0
        }, function() {
            return t.getBoundingClientRect().left
        })) + "px" : void 0
    }), st.cssHooks.marginRight = E(it.reliableMarginRight, function(t, e) {
        return e ? Gt(t, {
            display: "inline-block"
        }, $, [t, "marginRight"]) : void 0
    }), st.each({
        margin: "",
        padding: "",
        border: "Width"
    }, function(t, e) {
        st.cssHooks[t + e] = {
            expand: function(n) {
                for (var i = 0, o = {}, s = "string" == typeof n ? n.split(" ") : [n]; 4 > i; i++) o[t + zt[i] + e] = s[i] || s[i - 2] || s[0];
                return o
            }
        }, Vt.test(t) || (st.cssHooks[t + e].set = A)
    }), st.fn.extend({
        css: function(t, e) {
            return _t(this, function(t, e, n) {
                var i, o, s = {},
                    r = 0;
                if (st.isArray(e)) {
                    for (i = Zt(t), o = e.length; o > r; r++) s[e[r]] = st.css(t, e[r], !1, i);
                    return s
                }
                return void 0 !== n ? st.style(t, e, n) : st.css(t, e)
            }, t, e, arguments.length > 1)
        },
        show: function() {
            return D(this, !0)
        },
        hide: function() {
            return D(this)
        },
        toggle: function(t) {
            return "boolean" == typeof t ? t ? this.show() : this.hide() : this.each(function() {
                Dt(this) ? st(this).show() : st(this).hide()
            })
        }
    }), st.Tween = L, L.prototype = {
        constructor: L,
        init: function(t, e, n, i, o, s) {
            this.elem = t, this.prop = n, this.easing = o || st.easing._default, this.options = e, this.start = this.now = this.cur(), this.end = i, this.unit = s || (st.cssNumber[n] ? "" : "px")
        },
        cur: function() {
            var t = L.propHooks[this.prop];
            return t && t.get ? t.get(this) : L.propHooks._default.get(this)
        },
        run: function(t) {
            var e, n = L.propHooks[this.prop];
            return this.options.duration ? this.pos = e = st.easing[this.easing](t, this.options.duration * t, 0, 1, this.options.duration) : this.pos = e = t, this.now = (this.end - this.start) * e + this.start, this.options.step && this.options.step.call(this.elem, this.now, this), n && n.set ? n.set(this) : L.propHooks._default.set(this), this
        }
    }, L.prototype.init.prototype = L.prototype, L.propHooks = {
        _default: {
            get: function(t) {
                var e;
                return 1 !== t.elem.nodeType || null != t.elem[t.prop] && null == t.elem.style[t.prop] ? t.elem[t.prop] : (e = st.css(t.elem, t.prop, ""), e && "auto" !== e ? e : 0)
            },
            set: function(t) {
                st.fx.step[t.prop] ? st.fx.step[t.prop](t) : 1 !== t.elem.nodeType || null == t.elem.style[st.cssProps[t.prop]] && !st.cssHooks[t.prop] ? t.elem[t.prop] = t.now : st.style(t.elem, t.prop, t.now + t.unit)
            }
        }
    }, L.propHooks.scrollTop = L.propHooks.scrollLeft = {
        set: function(t) {
            t.elem.nodeType && t.elem.parentNode && (t.elem[t.prop] = t.now)
        }
    }, st.easing = {
        linear: function(t) {
            return t
        },
        swing: function(t) {
            return .5 - Math.cos(t * Math.PI) / 2
        },
        _default: "swing"
    }, st.fx = L.prototype.init, st.fx.step = {};
    var oe, se, re = /^(?:toggle|show|hide)$/,
        ae = /queueHooks$/;
    st.Animation = st.extend(I, {
            tweeners: {
                "*": [function(t, e) {
                    var n = this.createTween(t, e);
                    return c(n.elem, t, kt.exec(e), n), n
                }]
            },
            tweener: function(t, e) {
                st.isFunction(t) ? (e = t, t = ["*"]) : t = t.match(wt);
                for (var n, i = 0, o = t.length; o > i; i++) n = t[i], I.tweeners[n] = I.tweeners[n] || [], I.tweeners[n].unshift(e)
            },
            prefilters: [M],
            prefilter: function(t, e) {
                e ? I.prefilters.unshift(t) : I.prefilters.push(t)
            }
        }), st.speed = function(t, e, n) {
            var i = t && "object" == typeof t ? st.extend({}, t) : {
                complete: n || !n && e || st.isFunction(t) && t,
                duration: t,
                easing: n && e || e && !st.isFunction(e) && e
            };
            return i.duration = st.fx.off ? 0 : "number" == typeof i.duration ? i.duration : i.duration in st.fx.speeds ? st.fx.speeds[i.duration] : st.fx.speeds._default, null != i.queue && i.queue !== !0 || (i.queue = "fx"), i.old = i.complete, i.complete = function() {
                st.isFunction(i.old) && i.old.call(this), i.queue && st.dequeue(this, i.queue)
            }, i
        }, st.fn.extend({
            fadeTo: function(t, e, n, i) {
                return this.filter(Dt).css("opacity", 0).show().end().animate({
                    opacity: e
                }, t, n, i)
            },
            animate: function(t, e, n, i) {
                var o = st.isEmptyObject(t),
                    s = st.speed(e, n, i),
                    r = function() {
                        var e = I(this, st.extend({}, t), s);
                        (o || St.get(this, "finish")) && e.stop(!0)
                    };
                return r.finish = r, o || s.queue === !1 ? this.each(r) : this.queue(s.queue, r)
            },
            stop: function(t, e, n) {
                var i = function(t) {
                    var e = t.stop;
                    delete t.stop, e(n)
                };
                return "string" != typeof t && (n = e, e = t, t = void 0), e && t !== !1 && this.queue(t || "fx", []), this.each(function() {
                    var e = !0,
                        o = null != t && t + "queueHooks",
                        s = st.timers,
                        r = St.get(this);
                    if (o) r[o] && r[o].stop && i(r[o]);
                    else
                        for (o in r) r[o] && r[o].stop && ae.test(o) && i(r[o]);
                    for (o = s.length; o--;) s[o].elem !== this || null != t && s[o].queue !== t || (s[o].anim.stop(n), e = !1, s.splice(o, 1));
                    !e && n || st.dequeue(this, t)
                })
            },
            finish: function(t) {
                return t !== !1 && (t = t || "fx"), this.each(function() {
                    var e, n = St.get(this),
                        i = n[t + "queue"],
                        o = n[t + "queueHooks"],
                        s = st.timers,
                        r = i ? i.length : 0;
                    for (n.finish = !0, st.queue(this, t, []), o && o.stop && o.stop.call(this, !0), e = s.length; e--;) s[e].elem === this && s[e].queue === t && (s[e].anim.stop(!0), s.splice(e, 1));
                    for (e = 0; r > e; e++) i[e] && i[e].finish && i[e].finish.call(this);
                    delete n.finish
                })
            }
        }), st.each(["toggle", "show", "hide"], function(t, e) {
            var n = st.fn[e];
            st.fn[e] = function(t, i, o) {
                return null == t || "boolean" == typeof t ? n.apply(this, arguments) : this.animate(N(e, !0), t, i, o)
            }
        }), st.each({
            slideDown: N("show"),
            slideUp: N("hide"),
            slideToggle: N("toggle"),
            fadeIn: {
                opacity: "show"
            },
            fadeOut: {
                opacity: "hide"
            },
            fadeToggle: {
                opacity: "toggle"
            }
        }, function(t, e) {
            st.fn[t] = function(t, n, i) {
                return this.animate(e, t, n, i)
            }
        }), st.timers = [], st.fx.tick = function() {
            var t, e = 0,
                n = st.timers;
            for (oe = st.now(); e < n.length; e++) t = n[e],
                t() || n[e] !== t || n.splice(e--, 1);
            n.length || st.fx.stop(), oe = void 0
        }, st.fx.timer = function(t) {
            st.timers.push(t), t() ? st.fx.start() : st.timers.pop()
        }, st.fx.interval = 13, st.fx.start = function() {
            se || (se = t.setInterval(st.fx.tick, st.fx.interval))
        }, st.fx.stop = function() {
            t.clearInterval(se), se = null
        }, st.fx.speeds = {
            slow: 600,
            fast: 200,
            _default: 400
        }, st.fn.delay = function(e, n) {
            return e = st.fx ? st.fx.speeds[e] || e : e, n = n || "fx", this.queue(n, function(n, i) {
                var o = t.setTimeout(n, e);
                i.stop = function() {
                    t.clearTimeout(o)
                }
            })
        },
        function() {
            var t = Q.createElement("input"),
                e = Q.createElement("select"),
                n = e.appendChild(Q.createElement("option"));
            t.type = "checkbox", it.checkOn = "" !== t.value, it.optSelected = n.selected, e.disabled = !0, it.optDisabled = !n.disabled, t = Q.createElement("input"), t.value = "t", t.type = "radio", it.radioValue = "t" === t.value
        }();
    var le, ce = st.expr.attrHandle;
    st.fn.extend({
        attr: function(t, e) {
            return _t(this, st.attr, t, e, arguments.length > 1)
        },
        removeAttr: function(t) {
            return this.each(function() {
                st.removeAttr(this, t)
            })
        }
    }), st.extend({
        attr: function(t, e, n) {
            var i, o, s = t.nodeType;
            if (3 !== s && 8 !== s && 2 !== s) return "undefined" == typeof t.getAttribute ? st.prop(t, e, n) : (1 === s && st.isXMLDoc(t) || (e = e.toLowerCase(), o = st.attrHooks[e] || (st.expr.match.bool.test(e) ? le : void 0)), void 0 !== n ? null === n ? void st.removeAttr(t, e) : o && "set" in o && void 0 !== (i = o.set(t, n, e)) ? i : (t.setAttribute(e, n + ""), n) : o && "get" in o && null !== (i = o.get(t, e)) ? i : (i = st.find.attr(t, e), null == i ? void 0 : i))
        },
        attrHooks: {
            type: {
                set: function(t, e) {
                    if (!it.radioValue && "radio" === e && st.nodeName(t, "input")) {
                        var n = t.value;
                        return t.setAttribute("type", e), n && (t.value = n), e
                    }
                }
            }
        },
        removeAttr: function(t, e) {
            var n, i, o = 0,
                s = e && e.match(wt);
            if (s && 1 === t.nodeType)
                for (; n = s[o++];) i = st.propFix[n] || n, st.expr.match.bool.test(n) && (t[i] = !1), t.removeAttribute(n)
        }
    }), le = {
        set: function(t, e, n) {
            return e === !1 ? st.removeAttr(t, n) : t.setAttribute(n, n), n
        }
    }, st.each(st.expr.match.bool.source.match(/\w+/g), function(t, e) {
        var n = ce[e] || st.find.attr;
        ce[e] = function(t, e, i) {
            var o, s;
            return i || (s = ce[e], ce[e] = o, o = null != n(t, e, i) ? e.toLowerCase() : null, ce[e] = s), o
        }
    });
    var ue = /^(?:input|select|textarea|button)$/i,
        he = /^(?:a|area)$/i;
    st.fn.extend({
        prop: function(t, e) {
            return _t(this, st.prop, t, e, arguments.length > 1)
        },
        removeProp: function(t) {
            return this.each(function() {
                delete this[st.propFix[t] || t]
            })
        }
    }), st.extend({
        prop: function(t, e, n) {
            var i, o, s = t.nodeType;
            if (3 !== s && 8 !== s && 2 !== s) return 1 === s && st.isXMLDoc(t) || (e = st.propFix[e] || e, o = st.propHooks[e]), void 0 !== n ? o && "set" in o && void 0 !== (i = o.set(t, n, e)) ? i : t[e] = n : o && "get" in o && null !== (i = o.get(t, e)) ? i : t[e]
        },
        propHooks: {
            tabIndex: {
                get: function(t) {
                    var e = st.find.attr(t, "tabindex");
                    return e ? parseInt(e, 10) : ue.test(t.nodeName) || he.test(t.nodeName) && t.href ? 0 : -1
                }
            }
        },
        propFix: {
            for: "htmlFor",
            class: "className"
        }
    }), it.optSelected || (st.propHooks.selected = {
        get: function(t) {
            var e = t.parentNode;
            return e && e.parentNode && e.parentNode.selectedIndex, null
        },
        set: function(t) {
            var e = t.parentNode;
            e && (e.selectedIndex, e.parentNode && e.parentNode.selectedIndex)
        }
    }), st.each(["tabIndex", "readOnly", "maxLength", "cellSpacing", "cellPadding", "rowSpan", "colSpan", "useMap", "frameBorder", "contentEditable"], function() {
        st.propFix[this.toLowerCase()] = this
    });
    var de = /[\t\r\n\f]/g;
    st.fn.extend({
        addClass: function(t) {
            var e, n, i, o, s, r, a, l = 0;
            if (st.isFunction(t)) return this.each(function(e) {
                st(this).addClass(t.call(this, e, R(this)))
            });
            if ("string" == typeof t && t)
                for (e = t.match(wt) || []; n = this[l++];)
                    if (o = R(n), i = 1 === n.nodeType && (" " + o + " ").replace(de, " ")) {
                        for (r = 0; s = e[r++];) i.indexOf(" " + s + " ") < 0 && (i += s + " ");
                        a = st.trim(i), o !== a && n.setAttribute("class", a)
                    }
            return this
        },
        removeClass: function(t) {
            var e, n, i, o, s, r, a, l = 0;
            if (st.isFunction(t)) return this.each(function(e) {
                st(this).removeClass(t.call(this, e, R(this)))
            });
            if (!arguments.length) return this.attr("class", "");
            if ("string" == typeof t && t)
                for (e = t.match(wt) || []; n = this[l++];)
                    if (o = R(n), i = 1 === n.nodeType && (" " + o + " ").replace(de, " ")) {
                        for (r = 0; s = e[r++];)
                            for (; i.indexOf(" " + s + " ") > -1;) i = i.replace(" " + s + " ", " ");
                        a = st.trim(i), o !== a && n.setAttribute("class", a)
                    }
            return this
        },
        toggleClass: function(t, e) {
            var n = typeof t;
            return "boolean" == typeof e && "string" === n ? e ? this.addClass(t) : this.removeClass(t) : st.isFunction(t) ? this.each(function(n) {
                st(this).toggleClass(t.call(this, n, R(this), e), e)
            }) : this.each(function() {
                var e, i, o, s;
                if ("string" === n)
                    for (i = 0, o = st(this), s = t.match(wt) || []; e = s[i++];) o.hasClass(e) ? o.removeClass(e) : o.addClass(e);
                else void 0 !== t && "boolean" !== n || (e = R(this), e && St.set(this, "__className__", e), this.setAttribute && this.setAttribute("class", e || t === !1 ? "" : St.get(this, "__className__") || ""))
            })
        },
        hasClass: function(t) {
            var e, n, i = 0;
            for (e = " " + t + " "; n = this[i++];)
                if (1 === n.nodeType && (" " + R(n) + " ").replace(de, " ").indexOf(e) > -1) return !0;
            return !1
        }
    });
    var pe = /\r/g,
        fe = /[\x20\t\r\n\f]+/g;
    st.fn.extend({
        val: function(t) {
            var e, n, i, o = this[0];
            return arguments.length ? (i = st.isFunction(t), this.each(function(n) {
                var o;
                1 === this.nodeType && (o = i ? t.call(this, n, st(this).val()) : t, null == o ? o = "" : "number" == typeof o ? o += "" : st.isArray(o) && (o = st.map(o, function(t) {
                    return null == t ? "" : t + ""
                })), e = st.valHooks[this.type] || st.valHooks[this.nodeName.toLowerCase()], e && "set" in e && void 0 !== e.set(this, o, "value") || (this.value = o))
            })) : o ? (e = st.valHooks[o.type] || st.valHooks[o.nodeName.toLowerCase()], e && "get" in e && void 0 !== (n = e.get(o, "value")) ? n : (n = o.value, "string" == typeof n ? n.replace(pe, "") : null == n ? "" : n)) : void 0
        }
    }), st.extend({
        valHooks: {
            option: {
                get: function(t) {
                    var e = st.find.attr(t, "value");
                    return null != e ? e : st.trim(st.text(t)).replace(fe, " ")
                }
            },
            select: {
                get: function(t) {
                    for (var e, n, i = t.options, o = t.selectedIndex, s = "select-one" === t.type || 0 > o, r = s ? null : [], a = s ? o + 1 : i.length, l = 0 > o ? a : s ? o : 0; a > l; l++)
                        if (n = i[l], (n.selected || l === o) && (it.optDisabled ? !n.disabled : null === n.getAttribute("disabled")) && (!n.parentNode.disabled || !st.nodeName(n.parentNode, "optgroup"))) {
                            if (e = st(n).val(), s) return e;
                            r.push(e)
                        }
                    return r
                },
                set: function(t, e) {
                    for (var n, i, o = t.options, s = st.makeArray(e), r = o.length; r--;) i = o[r], (i.selected = st.inArray(st.valHooks.option.get(i), s) > -1) && (n = !0);
                    return n || (t.selectedIndex = -1), s
                }
            }
        }
    }), st.each(["radio", "checkbox"], function() {
        st.valHooks[this] = {
            set: function(t, e) {
                return st.isArray(e) ? t.checked = st.inArray(st(t).val(), e) > -1 : void 0
            }
        }, it.checkOn || (st.valHooks[this].get = function(t) {
            return null === t.getAttribute("value") ? "on" : t.value
        })
    });
    var ge = /^(?:focusinfocus|focusoutblur)$/;
    st.extend(st.event, {
        trigger: function(e, n, i, o) {
            var s, r, a, l, c, u, h, d = [i || Q],
                p = nt.call(e, "type") ? e.type : e,
                f = nt.call(e, "namespace") ? e.namespace.split(".") : [];
            if (r = a = i = i || Q, 3 !== i.nodeType && 8 !== i.nodeType && !ge.test(p + st.event.triggered) && (p.indexOf(".") > -1 && (f = p.split("."), p = f.shift(), f.sort()), c = p.indexOf(":") < 0 && "on" + p, e = e[st.expando] ? e : new st.Event(p, "object" == typeof e && e), e.isTrigger = o ? 2 : 3, e.namespace = f.join("."), e.rnamespace = e.namespace ? new RegExp("(^|\\.)" + f.join("\\.(?:.*\\.|)") + "(\\.|$)") : null, e.result = void 0, e.target || (e.target = i), n = null == n ? [e] : st.makeArray(n, [e]), h = st.event.special[p] || {}, o || !h.trigger || h.trigger.apply(i, n) !== !1)) {
                if (!o && !h.noBubble && !st.isWindow(i)) {
                    for (l = h.delegateType || p, ge.test(l + p) || (r = r.parentNode); r; r = r.parentNode) d.push(r), a = r;
                    a === (i.ownerDocument || Q) && d.push(a.defaultView || a.parentWindow || t)
                }
                for (s = 0;
                    (r = d[s++]) && !e.isPropagationStopped();) e.type = s > 1 ? l : h.bindType || p, u = (St.get(r, "events") || {})[e.type] && St.get(r, "handle"), u && u.apply(r, n), u = c && r[c], u && u.apply && Tt(r) && (e.result = u.apply(r, n), e.result === !1 && e.preventDefault());
                return e.type = p, o || e.isDefaultPrevented() || h._default && h._default.apply(d.pop(), n) !== !1 || !Tt(i) || c && st.isFunction(i[p]) && !st.isWindow(i) && (a = i[c], a && (i[c] = null), st.event.triggered = p, i[p](), st.event.triggered = void 0, a && (i[c] = a)), e.result
            }
        },
        simulate: function(t, e, n) {
            var i = st.extend(new st.Event, n, {
                type: t,
                isSimulated: !0
            });
            st.event.trigger(i, null, e), i.isDefaultPrevented() && n.preventDefault()
        }
    }), st.fn.extend({
        trigger: function(t, e) {
            return this.each(function() {
                st.event.trigger(t, e, this)
            })
        },
        triggerHandler: function(t, e) {
            var n = this[0];
            return n ? st.event.trigger(t, e, n, !0) : void 0
        }
    }), st.each("blur focus focusin focusout load resize scroll unload click dblclick mousedown mouseup mousemove mouseover mouseout mouseenter mouseleave change select submit keydown keypress keyup error contextmenu".split(" "), function(t, e) {
        st.fn[e] = function(t, n) {
            return arguments.length > 0 ? this.on(e, null, t, n) : this.trigger(e)
        }
    }), st.fn.extend({
        hover: function(t, e) {
            return this.mouseenter(t).mouseleave(e || t)
        }
    }), it.focusin = "onfocusin" in t, it.focusin || st.each({
        focus: "focusin",
        blur: "focusout"
    }, function(t, e) {
        var n = function(t) {
            st.event.simulate(e, t.target, st.event.fix(t))
        };
        st.event.special[e] = {
            setup: function() {
                var i = this.ownerDocument || this,
                    o = St.access(i, e);
                o || i.addEventListener(t, n, !0), St.access(i, e, (o || 0) + 1)
            },
            teardown: function() {
                var i = this.ownerDocument || this,
                    o = St.access(i, e) - 1;
                o ? St.access(i, e, o) : (i.removeEventListener(t, n, !0), St.remove(i, e))
            }
        }
    });
    var me = t.location,
        ve = st.now(),
        ye = /\?/;
    st.parseJSON = function(t) {
        return JSON.parse(t + "")
    }, st.parseXML = function(e) {
        var n;
        if (!e || "string" != typeof e) return null;
        try {
            n = (new t.DOMParser).parseFromString(e, "text/xml")
        } catch (t) {
            n = void 0
        }
        return n && !n.getElementsByTagName("parsererror").length || st.error("Invalid XML: " + e), n
    };
    var be = /#.*$/,
        xe = /([?&])_=[^&]*/,
        we = /^(.*?):[ \t]*([^\r\n]*)$/gm,
        Ce = /^(?:about|app|app-storage|.+-extension|file|res|widget):$/,
        _e = /^(?:GET|HEAD)$/,
        Te = /^\/\//,
        Se = {},
        $e = {},
        Ee = "*/".concat("*"),
        Pe = Q.createElement("a");
    Pe.href = me.href, st.extend({
        active: 0,
        lastModified: {},
        etag: {},
        ajaxSettings: {
            url: me.href,
            type: "GET",
            isLocal: Ce.test(me.protocol),
            global: !0,
            processData: !0,
            async: !0,
            contentType: "application/x-www-form-urlencoded; charset=UTF-8",
            accepts: {
                "*": Ee,
                text: "text/plain",
                html: "text/html",
                xml: "application/xml, text/xml",
                json: "application/json, text/javascript"
            },
            contents: {
                xml: /\bxml\b/,
                html: /\bhtml/,
                json: /\bjson\b/
            },
            responseFields: {
                xml: "responseXML",
                text: "responseText",
                json: "responseJSON"
            },
            converters: {
                "* text": String,
                "text html": !0,
                "text json": st.parseJSON,
                "text xml": st.parseXML
            },
            flatOptions: {
                url: !0,
                context: !0
            }
        },
        ajaxSetup: function(t, e) {
            return e ? W(W(t, st.ajaxSettings), e) : W(st.ajaxSettings, t)
        },
        ajaxPrefilter: O(Se),
        ajaxTransport: O($e),
        ajax: function(e, n) {
            function i(e, n, i, a) {
                var c, h, y, b, w, _ = n;
                2 !== x && (x = 2, l && t.clearTimeout(l), o = void 0, r = a || "", C.readyState = e > 0 ? 4 : 0, c = e >= 200 && 300 > e || 304 === e, i && (b = B(d, C, i)), b = X(d, b, C, c), c ? (d.ifModified && (w = C.getResponseHeader("Last-Modified"), w && (st.lastModified[s] = w), w = C.getResponseHeader("etag"), w && (st.etag[s] = w)), 204 === e || "HEAD" === d.type ? _ = "nocontent" : 304 === e ? _ = "notmodified" : (_ = b.state, h = b.data, y = b.error, c = !y)) : (y = _, !e && _ || (_ = "error", 0 > e && (e = 0))), C.status = e, C.statusText = (n || _) + "", c ? g.resolveWith(p, [h, _, C]) : g.rejectWith(p, [C, _, y]), C.statusCode(v), v = void 0, u && f.trigger(c ? "ajaxSuccess" : "ajaxError", [C, d, c ? h : y]), m.fireWith(p, [C, _]), u && (f.trigger("ajaxComplete", [C, d]), --st.active || st.event.trigger("ajaxStop")))
            }
            "object" == typeof e && (n = e, e = void 0), n = n || {};
            var o, s, r, a, l, c, u, h, d = st.ajaxSetup({}, n),
                p = d.context || d,
                f = d.context && (p.nodeType || p.jquery) ? st(p) : st.event,
                g = st.Deferred(),
                m = st.Callbacks("once memory"),
                v = d.statusCode || {},
                y = {},
                b = {},
                x = 0,
                w = "canceled",
                C = {
                    readyState: 0,
                    getResponseHeader: function(t) {
                        var e;
                        if (2 === x) {
                            if (!a)
                                for (a = {}; e = we.exec(r);) a[e[1].toLowerCase()] = e[2];
                            e = a[t.toLowerCase()]
                        }
                        return null == e ? null : e
                    },
                    getAllResponseHeaders: function() {
                        return 2 === x ? r : null
                    },
                    setRequestHeader: function(t, e) {
                        var n = t.toLowerCase();
                        return x || (t = b[n] = b[n] || t, y[t] = e), this
                    },
                    overrideMimeType: function(t) {
                        return x || (d.mimeType = t), this
                    },
                    statusCode: function(t) {
                        var e;
                        if (t)
                            if (2 > x)
                                for (e in t) v[e] = [v[e], t[e]];
                            else C.always(t[C.status]);
                        return this
                    },
                    abort: function(t) {
                        var e = t || w;
                        return o && o.abort(e), i(0, e), this
                    }
                };
            if (g.promise(C).complete = m.add, C.success = C.done, C.error = C.fail, d.url = ((e || d.url || me.href) + "").replace(be, "").replace(Te, me.protocol + "//"), d.type = n.method || n.type || d.method || d.type, d.dataTypes = st.trim(d.dataType || "*").toLowerCase().match(wt) || [""], null == d.crossDomain) {
                c = Q.createElement("a");
                try {
                    c.href = d.url, c.href = c.href, d.crossDomain = Pe.protocol + "//" + Pe.host != c.protocol + "//" + c.host
                } catch (t) {
                    d.crossDomain = !0
                }
            }
            if (d.data && d.processData && "string" != typeof d.data && (d.data = st.param(d.data, d.traditional)), H(Se, d, n, C), 2 === x) return C;
            u = st.event && d.global, u && 0 === st.active++ && st.event.trigger("ajaxStart"), d.type = d.type.toUpperCase(), d.hasContent = !_e.test(d.type), s = d.url, d.hasContent || (d.data && (s = d.url += (ye.test(s) ? "&" : "?") + d.data, delete d.data), d.cache === !1 && (d.url = xe.test(s) ? s.replace(xe, "$1_=" + ve++) : s + (ye.test(s) ? "&" : "?") + "_=" + ve++)), d.ifModified && (st.lastModified[s] && C.setRequestHeader("If-Modified-Since", st.lastModified[s]), st.etag[s] && C.setRequestHeader("If-None-Match", st.etag[s])), (d.data && d.hasContent && d.contentType !== !1 || n.contentType) && C.setRequestHeader("Content-Type", d.contentType), C.setRequestHeader("Accept", d.dataTypes[0] && d.accepts[d.dataTypes[0]] ? d.accepts[d.dataTypes[0]] + ("*" !== d.dataTypes[0] ? ", " + Ee + "; q=0.01" : "") : d.accepts["*"]);
            for (h in d.headers) C.setRequestHeader(h, d.headers[h]);
            if (d.beforeSend && (d.beforeSend.call(p, C, d) === !1 || 2 === x)) return C.abort();
            w = "abort";
            for (h in {
                    success: 1,
                    error: 1,
                    complete: 1
                }) C[h](d[h]);
            if (o = H($e, d, n, C)) {
                if (C.readyState = 1, u && f.trigger("ajaxSend", [C, d]), 2 === x) return C;
                d.async && d.timeout > 0 && (l = t.setTimeout(function() {
                    C.abort("timeout")
                }, d.timeout));
                try {
                    x = 1, o.send(y, i)
                } catch (t) {
                    if (!(2 > x)) throw t;
                    i(-1, t)
                }
            } else i(-1, "No Transport");
            return C
        },
        getJSON: function(t, e, n) {
            return st.get(t, e, n, "json")
        },
        getScript: function(t, e) {
            return st.get(t, void 0, e, "script")
        }
    }), st.each(["get", "post"], function(t, e) {
        st[e] = function(t, n, i, o) {
            return st.isFunction(n) && (o = o || i, i = n, n = void 0), st.ajax(st.extend({
                url: t,
                type: e,
                dataType: o,
                data: n,
                success: i
            }, st.isPlainObject(t) && t))
        }
    }), st._evalUrl = function(t) {
        return st.ajax({
            url: t,
            type: "GET",
            dataType: "script",
            async: !1,
            global: !1,
            throws: !0
        })
    }, st.fn.extend({
        wrapAll: function(t) {
            var e;
            return st.isFunction(t) ? this.each(function(e) {
                st(this).wrapAll(t.call(this, e))
            }) : (this[0] && (e = st(t, this[0].ownerDocument).eq(0).clone(!0), this[0].parentNode && e.insertBefore(this[0]), e.map(function() {
                for (var t = this; t.firstElementChild;) t = t.firstElementChild;
                return t
            }).append(this)), this)
        },
        wrapInner: function(t) {
            return st.isFunction(t) ? this.each(function(e) {
                st(this).wrapInner(t.call(this, e))
            }) : this.each(function() {
                var e = st(this),
                    n = e.contents();
                n.length ? n.wrapAll(t) : e.append(t)
            })
        },
        wrap: function(t) {
            var e = st.isFunction(t);
            return this.each(function(n) {
                st(this).wrapAll(e ? t.call(this, n) : t)
            })
        },
        unwrap: function() {
            return this.parent().each(function() {
                st.nodeName(this, "body") || st(this).replaceWith(this.childNodes)
            }).end()
        }
    }), st.expr.filters.hidden = function(t) {
        return !st.expr.filters.visible(t)
    }, st.expr.filters.visible = function(t) {
        return t.offsetWidth > 0 || t.offsetHeight > 0 || t.getClientRects().length > 0
    };
    var Ae = /%20/g,
        ke = /\[\]$/,
        ze = /\r?\n/g,
        De = /^(?:submit|button|image|reset|file)$/i,
        Le = /^(?:input|select|textarea|keygen)/i;
    st.param = function(t, e) {
        var n, i = [],
            o = function(t, e) {
                e = st.isFunction(e) ? e() : null == e ? "" : e, i[i.length] = encodeURIComponent(t) + "=" + encodeURIComponent(e)
            };
        if (void 0 === e && (e = st.ajaxSettings && st.ajaxSettings.traditional), st.isArray(t) || t.jquery && !st.isPlainObject(t)) st.each(t, function() {
            o(this.name, this.value)
        });
        else
            for (n in t) Y(n, t[n], e, o);
        return i.join("&").replace(Ae, "+")
    }, st.fn.extend({
        serialize: function() {
            return st.param(this.serializeArray())
        },
        serializeArray: function() {
            return this.map(function() {
                var t = st.prop(this, "elements");
                return t ? st.makeArray(t) : this
            }).filter(function() {
                var t = this.type;
                return this.name && !st(this).is(":disabled") && Le.test(this.nodeName) && !De.test(t) && (this.checked || !Lt.test(t))
            }).map(function(t, e) {
                var n = st(this).val();
                return null == n ? null : st.isArray(n) ? st.map(n, function(t) {
                    return {
                        name: e.name,
                        value: t.replace(ze, "\r\n")
                    }
                }) : {
                    name: e.name,
                    value: n.replace(ze, "\r\n")
                }
            }).get()
        }
    }), st.ajaxSettings.xhr = function() {
        try {
            return new t.XMLHttpRequest
        } catch (t) {}
    };
    var je = {
            0: 200,
            1223: 204
        },
        Ne = st.ajaxSettings.xhr();
    it.cors = !!Ne && "withCredentials" in Ne, it.ajax = Ne = !!Ne, st.ajaxTransport(function(e) {
        var n, i;
        return it.cors || Ne && !e.crossDomain ? {
            send: function(o, s) {
                var r, a = e.xhr();
                if (a.open(e.type, e.url, e.async, e.username, e.password), e.xhrFields)
                    for (r in e.xhrFields) a[r] = e.xhrFields[r];
                e.mimeType && a.overrideMimeType && a.overrideMimeType(e.mimeType), e.crossDomain || o["X-Requested-With"] || (o["X-Requested-With"] = "XMLHttpRequest");
                for (r in o) a.setRequestHeader(r, o[r]);
                n = function(t) {
                    return function() {
                        n && (n = i = a.onload = a.onerror = a.onabort = a.onreadystatechange = null, "abort" === t ? a.abort() : "error" === t ? "number" != typeof a.status ? s(0, "error") : s(a.status, a.statusText) : s(je[a.status] || a.status, a.statusText, "text" !== (a.responseType || "text") || "string" != typeof a.responseText ? {
                            binary: a.response
                        } : {
                            text: a.responseText
                        }, a.getAllResponseHeaders()))
                    }
                }, a.onload = n(), i = a.onerror = n("error"), void 0 !== a.onabort ? a.onabort = i : a.onreadystatechange = function() {
                    4 === a.readyState && t.setTimeout(function() {
                        n && i()
                    })
                }, n = n("abort");
                try {
                    a.send(e.hasContent && e.data || null)
                } catch (t) {
                    if (n) throw t
                }
            },
            abort: function() {
                n && n()
            }
        } : void 0
    }), st.ajaxSetup({
        accepts: {
            script: "text/javascript, application/javascript, application/ecmascript, application/x-ecmascript"
        },
        contents: {
            script: /\b(?:java|ecma)script\b/
        },
        converters: {
            "text script": function(t) {
                return st.globalEval(t), t
            }
        }
    }), st.ajaxPrefilter("script", function(t) {
        void 0 === t.cache && (t.cache = !1), t.crossDomain && (t.type = "GET")
    }), st.ajaxTransport("script", function(t) {
        if (t.crossDomain) {
            var e, n;
            return {
                send: function(i, o) {
                    e = st("<script>").prop({
                        charset: t.scriptCharset,
                        src: t.url
                    }).on("load error", n = function(t) {
                        e.remove(), n = null, t && o("error" === t.type ? 404 : 200, t.type)
                    }), Q.head.appendChild(e[0])
                },
                abort: function() {
                    n && n()
                }
            }
        }
    });
    var Fe = [],
        Me = /(=)\?(?=&|$)|\?\?/;
    st.ajaxSetup({
        jsonp: "callback",
        jsonpCallback: function() {
            var t = Fe.pop() || st.expando + "_" + ve++;
            return this[t] = !0, t
        }
    }), st.ajaxPrefilter("json jsonp", function(e, n, i) {
        var o, s, r, a = e.jsonp !== !1 && (Me.test(e.url) ? "url" : "string" == typeof e.data && 0 === (e.contentType || "").indexOf("application/x-www-form-urlencoded") && Me.test(e.data) && "data");
        return a || "jsonp" === e.dataTypes[0] ? (o = e.jsonpCallback = st.isFunction(e.jsonpCallback) ? e.jsonpCallback() : e.jsonpCallback, a ? e[a] = e[a].replace(Me, "$1" + o) : e.jsonp !== !1 && (e.url += (ye.test(e.url) ? "&" : "?") + e.jsonp + "=" + o), e.converters["script json"] = function() {
            return r || st.error(o + " was not called"), r[0]
        }, e.dataTypes[0] = "json", s = t[o], t[o] = function() {
            r = arguments
        }, i.always(function() {
            void 0 === s ? st(t).removeProp(o) : t[o] = s, e[o] && (e.jsonpCallback = n.jsonpCallback, Fe.push(o)), r && st.isFunction(s) && s(r[0]), r = s = void 0
        }), "script") : void 0
    }), st.parseHTML = function(t, e, n) {
        if (!t || "string" != typeof t) return null;
        "boolean" == typeof e && (n = e, e = !1), e = e || Q;
        var i = ft.exec(t),
            o = !n && [];
        return i ? [e.createElement(i[1])] : (i = d([t], e, o), o && o.length && st(o).remove(), st.merge([], i.childNodes))
    };
    var qe = st.fn.load;
    st.fn.load = function(t, e, n) {
        if ("string" != typeof t && qe) return qe.apply(this, arguments);
        var i, o, s, r = this,
            a = t.indexOf(" ");
        return a > -1 && (i = st.trim(t.slice(a)), t = t.slice(0, a)), st.isFunction(e) ? (n = e, e = void 0) : e && "object" == typeof e && (o = "POST"), r.length > 0 && st.ajax({
            url: t,
            type: o || "GET",
            dataType: "html",
            data: e
        }).done(function(t) {
            s = arguments, r.html(i ? st("<div>").append(st.parseHTML(t)).find(i) : t)
        }).always(n && function(t, e) {
            r.each(function() {
                n.apply(this, s || [t.responseText, e, t])
            })
        }), this
    }, st.each(["ajaxStart", "ajaxStop", "ajaxComplete", "ajaxError", "ajaxSuccess", "ajaxSend"], function(t, e) {
        st.fn[e] = function(t) {
            return this.on(e, t)
        }
    }), st.expr.filters.animated = function(t) {
        return st.grep(st.timers, function(e) {
            return t === e.elem
        }).length
    }, st.offset = {
        setOffset: function(t, e, n) {
            var i, o, s, r, a, l, c, u = st.css(t, "position"),
                h = st(t),
                d = {};
            "static" === u && (t.style.position = "relative"), a = h.offset(), s = st.css(t, "top"), l = st.css(t, "left"), c = ("absolute" === u || "fixed" === u) && (s + l).indexOf("auto") > -1, c ? (i = h.position(), r = i.top, o = i.left) : (r = parseFloat(s) || 0, o = parseFloat(l) || 0), st.isFunction(e) && (e = e.call(t, n, st.extend({}, a))), null != e.top && (d.top = e.top - a.top + r), null != e.left && (d.left = e.left - a.left + o), "using" in e ? e.using.call(t, d) : h.css(d)
        }
    }, st.fn.extend({
        offset: function(t) {
            if (arguments.length) return void 0 === t ? this : this.each(function(e) {
                st.offset.setOffset(this, t, e)
            });
            var e, n, i = this[0],
                o = {
                    top: 0,
                    left: 0
                },
                s = i && i.ownerDocument;
            return s ? (e = s.documentElement, st.contains(e, i) ? (o = i.getBoundingClientRect(), n = U(s), {
                top: o.top + n.pageYOffset - e.clientTop,
                left: o.left + n.pageXOffset - e.clientLeft
            }) : o) : void 0
        },
        position: function() {
            if (this[0]) {
                var t, e, n = this[0],
                    i = {
                        top: 0,
                        left: 0
                    };
                return "fixed" === st.css(n, "position") ? e = n.getBoundingClientRect() : (t = this.offsetParent(), e = this.offset(), st.nodeName(t[0], "html") || (i = t.offset()), i.top += st.css(t[0], "borderTopWidth", !0), i.left += st.css(t[0], "borderLeftWidth", !0)), {
                    top: e.top - i.top - st.css(n, "marginTop", !0),
                    left: e.left - i.left - st.css(n, "marginLeft", !0)
                }
            }
        },
        offsetParent: function() {
            return this.map(function() {
                for (var t = this.offsetParent; t && "static" === st.css(t, "position");) t = t.offsetParent;
                return t || Kt
            })
        }
    }), st.each({
        scrollLeft: "pageXOffset",
        scrollTop: "pageYOffset"
    }, function(t, e) {
        var n = "pageYOffset" === e;
        st.fn[t] = function(i) {
            return _t(this, function(t, i, o) {
                var s = U(t);
                return void 0 === o ? s ? s[e] : t[i] : void(s ? s.scrollTo(n ? s.pageXOffset : o, n ? o : s.pageYOffset) : t[i] = o)
            }, t, i, arguments.length)
        }
    }), st.each(["top", "left"], function(t, e) {
        st.cssHooks[e] = E(it.pixelPosition, function(t, n) {
            return n ? (n = $(t, e), Qt.test(n) ? st(t).position()[e] + "px" : n) : void 0
        })
    }), st.each({
        Height: "height",
        Width: "width"
    }, function(t, e) {
        st.each({
            padding: "inner" + t,
            content: e,
            "": "outer" + t
        }, function(n, i) {
            st.fn[i] = function(i, o) {
                var s = arguments.length && (n || "boolean" != typeof i),
                    r = n || (i === !0 || o === !0 ? "margin" : "border");
                return _t(this, function(e, n, i) {
                    var o;
                    return st.isWindow(e) ? e.document.documentElement["client" + t] : 9 === e.nodeType ? (o = e.documentElement, Math.max(e.body["scroll" + t], o["scroll" + t], e.body["offset" + t], o["offset" + t], o["client" + t])) : void 0 === i ? st.css(e, n, r) : st.style(e, n, i, r)
                }, e, s ? i : void 0, s, null)
            }
        })
    }), st.fn.extend({
        bind: function(t, e, n) {
            return this.on(t, null, e, n)
        },
        unbind: function(t, e) {
            return this.off(t, null, e)
        },
        delegate: function(t, e, n, i) {
            return this.on(e, t, n, i)
        },
        undelegate: function(t, e, n) {
            return 1 === arguments.length ? this.off(t, "**") : this.off(e, t || "**", n)
        },
        size: function() {
            return this.length
        }
    }), st.fn.andSelf = st.fn.addBack, "function" == typeof define && define.amd && define("jquery", [], function() {
        return st
    });
    var Ie = t.jQuery,
        Re = t.$;
    return st.noConflict = function(e) {
        return t.$ === st && (t.$ = Re), e && t.jQuery === st && (t.jQuery = Ie), st
    }, e || (t.jQuery = t.$ = st), st
}), ! function(t, e) {
    var n = function() {
        e(t.lazySizes), t.removeEventListener("lazyunveilread", n, !0)
    };
    e = e.bind(null, t, t.document), "object" == typeof module && module.exports ? e(require("lazysizes")) : t.lazySizes ? n() : t.addEventListener("lazyunveilread", n, !0)
}(window, function(t, e, n) {
    "use strict";

    function i(t) {
        var e = getComputedStyle(t, null) || {},
            n = e.fontFamily || "",
            i = n.match(l) || "",
            o = i && n.match(c) || "";
        return o && (o = o[1]), {
            fit: i && i[1] || "",
            position: d[o] || o || "center"
        }
    }

    function o(t, e) {
        var i, o = n.cfg,
            s = t.cloneNode(!1),
            r = s.style,
            a = function() {
                var e = t.currentSrc || t.src;
                e && (r.backgroundImage = "url(" + (h.test(e) ? JSON.stringify(e) : e) + ")", i || (i = !0, n.rC(s, o.loadingClass), n.aC(s, o.loadedClass)))
            };
        t._lazysizesParentFit = e.fit, t.addEventListener("load", function() {
            n.rAF(a)
        }, !0), s.addEventListener("load", function() {
            var t = s.currentSrc || s.src;
            t && t != u && (s.src = u, s.srcset = "")
        }), n.rAF(function() {
            var i = t,
                l = t.parentNode;
            "PICTURE" == l.nodeName.toUpperCase() && (i = l, l = l.parentNode), n.rC(s, o.loadedClass), n.rC(s, o.lazyClass), n.aC(s, o.loadingClass), n.aC(s, o.objectFitClass || "lazysizes-display-clone"), s.getAttribute(o.srcsetAttr) && s.setAttribute(o.srcsetAttr, ""), s.getAttribute(o.srcAttr) && s.setAttribute(o.srcAttr, ""), s.src = u, s.srcset = "", r.backgroundRepeat = "no-repeat", r.backgroundPosition = e.position, r.backgroundSize = e.fit, i.style.display = "none", t.setAttribute("data-parent-fit", e.fit), t.setAttribute("data-parent-container", "prev"), l.insertBefore(s, i), t._lazysizesParentFit && delete t._lazysizesParentFit, t.complete && a()
        })
    }
    var s = e.createElement("a").style,
        r = "objectFit" in s,
        a = r && "objectPosition" in s,
        l = /object-fit["']*\s*:\s*["']*(contain|cover)/,
        c = /object-position["']*\s*:\s*["']*(.+?)(?=($|,|'|"|;))/,
        u = "data:image/gif;base64,R0lGODlhAQABAAAAACH5BAEKAAEALAAAAAABAAEAAAICTAEAOw==",
        h = /\(|\)|'/,
        d = {
            center: "center",
            "50% 50%": "center"
        };
    r && a || t.addEventListener("lazyunveilread", function(t) {
        if (t.detail.instance == n) {
            var e = t.target,
                s = i(e);
            !s.fit || r && "center" == s.position || o(e, s)
        }
    }, !0)
}), /*! lazysizes - v4.0.0-rc2 */
! function(t, e) {
    var n = e(t, t.document);
    t.lazySizes = n, "object" == typeof module && module.exports && (module.exports = n)
}(window, function(t, e) {
    "use strict";
    if (e.getElementsByClassName) {
        var n, i, o = e.documentElement,
            s = t.Date,
            r = t.HTMLPictureElement,
            a = "addEventListener",
            l = "getAttribute",
            c = t[a],
            u = t.setTimeout,
            h = t.requestAnimationFrame || u,
            d = t.requestIdleCallback,
            p = /^picture$/i,
            f = ["load", "error", "lazyincluded", "_lazyloaded"],
            g = {},
            m = Array.prototype.forEach,
            v = function(t, e) {
                return g[e] || (g[e] = new RegExp("(\\s|^)" + e + "(\\s|$)")), g[e].test(t[l]("class") || "") && g[e]
            },
            y = function(t, e) {
                v(t, e) || t.setAttribute("class", (t[l]("class") || "").trim() + " " + e)
            },
            b = function(t, e) {
                var n;
                (n = v(t, e)) && t.setAttribute("class", (t[l]("class") || "").replace(n, " "))
            },
            x = function(t, e, n) {
                var i = n ? a : "removeEventListener";
                n && x(t, e), f.forEach(function(n) {
                    t[i](n, e)
                })
            },
            w = function(t, i, o, s, r) {
                var a = e.createEvent("CustomEvent");
                return o || (o = {}), o.instance = n, a.initCustomEvent(i, !s, !r, o), t.dispatchEvent(a), a
            },
            C = function(e, n) {
                var o;
                !r && (o = t.picturefill || i.pf) ? o({
                    reevaluate: !0,
                    elements: [e]
                }) : n && n.src && (e.src = n.src)
            },
            _ = function(t, e) {
                return (getComputedStyle(t, null) || {})[e]
            },
            T = function(t, e, n) {
                for (n = n || t.offsetWidth; n < i.minSize && e && !t._lazysizesWidth;) n = e.offsetWidth, e = e.parentNode;
                return n
            },
            S = function() {
                var t, n, i = [],
                    o = [],
                    s = i,
                    r = function() {
                        var e = s;
                        for (s = i.length ? o : i, t = !0, n = !1; e.length;) e.shift()();
                        t = !1
                    },
                    a = function(i, o) {
                        t && !o ? i.apply(this, arguments) : (s.push(i), n || (n = !0, (e.hidden ? u : h)(r)))
                    };
                return a._lsFlush = r, a
            }(),
            $ = function(t, e) {
                return e ? function() {
                    S(t)
                } : function() {
                    var e = this,
                        n = arguments;
                    S(function() {
                        t.apply(e, n)
                    })
                }
            },
            E = function(t) {
                var e, n = 0,
                    i = 125,
                    o = 666,
                    r = o,
                    a = function() {
                        e = !1, n = s.now(), t()
                    },
                    l = d ? function() {
                        d(a, {
                            timeout: r
                        }), r !== o && (r = o)
                    } : $(function() {
                        u(a)
                    }, !0);
                return function(t) {
                    var o;
                    (t = t === !0) && (r = 44), e || (e = !0, o = i - (s.now() - n), 0 > o && (o = 0), t || 9 > o && d ? l() : u(l, o))
                }
            },
            P = function(t) {
                var e, n, i = 99,
                    o = function() {
                        e = null, t()
                    },
                    r = function() {
                        var t = s.now() - n;
                        i > t ? u(r, i - t) : (d || o)(o)
                    };
                return function() {
                    n = s.now(), e || (e = u(r, i))
                }
            },
            A = function() {
                var r, h, d, f, g, T, A, z, D, L, j, N, F, M, q = /^img$/i,
                    I = /^iframe$/i,
                    R = "onscroll" in t && !/glebot/.test(navigator.userAgent),
                    O = 0,
                    H = 0,
                    W = 0,
                    B = -1,
                    X = function(t) {
                        W--, t && t.target && x(t.target, X), (!t || 0 > W || !t.target) && (W = 0)
                    },
                    Y = function(t, n) {
                        var i, s = t,
                            r = "hidden" == _(e.body, "visibility") || "hidden" != _(t, "visibility");
                        for (z -= n, j += n, D -= n, L += n; r && (s = s.offsetParent) && s != e.body && s != o;) r = (_(s, "opacity") || 1) > 0, r && "visible" != _(s, "overflow") && (i = s.getBoundingClientRect(), r = L > i.left && D < i.right && j > i.top - 1 && z < i.bottom + 1);
                        return r
                    },
                    U = function() {
                        var t, s, a, c, u, d, p, g, m, v = n.elements;
                        if ((f = i.loadMode) && 8 > W && (t = v.length)) {
                            s = 0, B++, null == F && ("expand" in i || (i.expand = o.clientHeight > 500 && o.clientWidth > 500 ? 500 : 370), N = i.expand, F = N * i.expFactor), F > H && 1 > W && B > 2 && f > 2 && !e.hidden ? (H = F, B = 0) : H = f > 1 && B > 1 && 6 > W ? N : O;
                            for (; t > s; s++)
                                if (v[s] && !v[s]._lazyRace)
                                    if (R)
                                        if ((g = v[s][l]("data-expand")) && (d = 1 * g) || (d = H), m !== d && (T = innerWidth + d * M, A = innerHeight + d, p = -1 * d, m = d), a = v[s].getBoundingClientRect(), (j = a.bottom) >= p && (z = a.top) <= A && (L = a.right) >= p * M && (D = a.left) <= T && (j || L || D || z) && (i.loadHidden || "hidden" != _(v[s], "visibility")) && (h && 3 > W && !g && (3 > f || 4 > B) || Y(v[s], d))) {
                                            if (et(v[s]), u = !0, W > 9) break
                                        } else !u && h && !c && 4 > W && 4 > B && f > 2 && (r[0] || i.preloadAfterLoad) && (r[0] || !g && (j || L || D || z || "auto" != v[s][l](i.sizesAttr))) && (c = r[0] || v[s]);
                            else et(v[s]);
                            c && !u && et(c)
                        }
                    },
                    V = E(U),
                    Q = function(t) {
                        y(t.target, i.loadedClass), b(t.target, i.loadingClass), x(t.target, G), w(t.target, "lazyloaded")
                    },
                    Z = $(Q),
                    G = function(t) {
                        Z({
                            target: t.target
                        })
                    },
                    K = function(t, e) {
                        try {
                            t.contentWindow.location.replace(e)
                        } catch (n) {
                            t.src = e
                        }
                    },
                    J = function(t) {
                        var e, n = t[l](i.srcsetAttr);
                        (e = i.customMedia[t[l]("data-media") || t[l]("media")]) && t.setAttribute("media", e), n && t.setAttribute("srcset", n)
                    },
                    tt = $(function(t, e, n, o, s) {
                        var r, a, c, h, f, g;
                        (f = w(t, "lazybeforeunveil", e)).defaultPrevented || (o && (n ? y(t, i.autosizesClass) : t.setAttribute("sizes", o)), a = t[l](i.srcsetAttr), r = t[l](i.srcAttr), s && (c = t.parentNode, h = c && p.test(c.nodeName || "")), g = e.firesLoad || "src" in t && (a || r || h), f = {
                            target: t
                        }, g && (x(t, X, !0), clearTimeout(d), d = u(X, 2500), y(t, i.loadingClass), x(t, G, !0)), h && m.call(c.getElementsByTagName("source"), J), a ? t.setAttribute("srcset", a) : r && !h && (I.test(t.nodeName) ? K(t, r) : t.src = r), s && (a || h) && C(t, {
                            src: r
                        })), t._lazyRace && delete t._lazyRace, b(t, i.lazyClass), S(function() {
                            (!g || t.complete && t.naturalWidth > 1) && (g ? X(f) : W--, Q(f))
                        }, !0)
                    }),
                    et = function(t) {
                        var e, n = q.test(t.nodeName),
                            o = n && (t[l](i.sizesAttr) || t[l]("sizes")),
                            s = "auto" == o;
                        (!s && h || !n || !t[l]("src") && !t.srcset || t.complete || v(t, i.errorClass)) && (e = w(t, "lazyunveilread").detail, s && k.updateElem(t, !0, t.offsetWidth), t._lazyRace = !0, W++, tt(t, e, s, o, n))
                    },
                    nt = function() {
                        if (!h) {
                            if (s.now() - g < 999) return void u(nt, 999);
                            var t = P(function() {
                                i.loadMode = 3, V()
                            });
                            h = !0, i.loadMode = 3, V(), c("scroll", function() {
                                3 == i.loadMode && (i.loadMode = 2), t()
                            }, !0)
                        }
                    };
                return {
                    _: function() {
                        g = s.now(), n.elements = e.getElementsByClassName(i.lazyClass), r = e.getElementsByClassName(i.lazyClass + " " + i.preloadClass), M = i.hFac, c("scroll", V, !0), c("resize", V, !0), t.MutationObserver ? new MutationObserver(V).observe(o, {
                            childList: !0,
                            subtree: !0,
                            attributes: !0
                        }) : (o[a]("DOMNodeInserted", V, !0), o[a]("DOMAttrModified", V, !0), setInterval(V, 999)), c("hashchange", V, !0), ["focus", "mouseover", "click", "load", "transitionend", "animationend", "webkitAnimationEnd"].forEach(function(t) {
                            e[a](t, V, !0)
                        }), /d$|^c/.test(e.readyState) ? nt() : (c("load", nt), e[a]("DOMContentLoaded", V), u(nt, 2e4)), n.elements.length ? (U(), S._lsFlush()) : V()
                    },
                    checkElems: V,
                    unveil: et
                }
            }(),
            k = function() {
                var t, n = $(function(t, e, n, i) {
                        var o, s, r;
                        if (t._lazysizesWidth = i, i += "px", t.setAttribute("sizes", i), p.test(e.nodeName || ""))
                            for (o = e.getElementsByTagName("source"), s = 0, r = o.length; r > s; s++) o[s].setAttribute("sizes", i);
                        n.detail.dataAttr || C(t, n.detail)
                    }),
                    o = function(t, e, i) {
                        var o, s = t.parentNode;
                        s && (i = T(t, s, i), o = w(t, "lazybeforesizes", {
                            width: i,
                            dataAttr: !!e
                        }), o.defaultPrevented || (i = o.detail.width, i && i !== t._lazysizesWidth && n(t, s, o, i)))
                    },
                    s = function() {
                        var e, n = t.length;
                        if (n)
                            for (e = 0; n > e; e++) o(t[e])
                    },
                    r = P(s);
                return {
                    _: function() {
                        t = e.getElementsByClassName(i.autosizesClass), c("resize", r)
                    },
                    checkElems: r,
                    updateElem: o
                }
            }(),
            z = function() {
                z.i || (z.i = !0, k._(), A._())
            };
        return function() {
            var e, n = {
                lazyClass: "lazyload",
                loadedClass: "lazyloaded",
                loadingClass: "lazyloading",
                preloadClass: "lazypreload",
                errorClass: "lazyerror",
                autosizesClass: "lazyautosizes",
                srcAttr: "data-src",
                srcsetAttr: "data-srcset",
                sizesAttr: "data-sizes",
                minSize: 40,
                customMedia: {},
                init: !0,
                expFactor: 1.5,
                hFac: .8,
                loadMode: 2,
                loadHidden: !0
            };
            i = t.lazySizesConfig || t.lazysizesConfig || {};
            for (e in n) e in i || (i[e] = n[e]);
            t.lazySizesConfig = i, u(function() {
                i.init && z()
            })
        }(), n = {
            cfg: i,
            autoSizer: k,
            loader: A,
            init: z,
            uP: C,
            aC: y,
            rC: b,
            hC: v,
            fire: w,
            gW: T,
            rAF: S
        }
    }
}), ! function(t, e) {
    var n = function() {
        e(t.lazySizes), t.removeEventListener("lazyunveilread", n, !0)
    };
    e = e.bind(null, t, t.document), "object" == typeof module && module.exports ? e(require("lazysizes")) : t.lazySizes ? n() : t.addEventListener("lazyunveilread", n, !0)
}(window, function(t, e, n) {
    "use strict";
    if (t.addEventListener) {
        var i = /\s+(\d+)(w|h)\s+(\d+)(w|h)/,
            o = /parent-fit["']*\s*:\s*["']*(contain|cover|width)/,
            s = /parent-container["']*\s*:\s*["']*(.+?)(?=(\s|$|,|'|"|;))/,
            r = /^picture$/i,
            a = function(t) {
                return getComputedStyle(t, null) || {}
            },
            l = {
                getParent: function(e, n) {
                    var i = e,
                        o = e.parentNode;
                    return n && "prev" != n || !o || !r.test(o.nodeName || "") || (o = o.parentNode), "self" != n && (i = "prev" == n ? e.previousElementSibling : n && (o.closest || t.jQuery) ? (o.closest ? o.closest(n) : jQuery(o).closest(n)[0]) || o : o), i
                },
                getFit: function(t) {
                    var e, n, i = a(t),
                        r = i.content || i.fontFamily,
                        c = {
                            fit: t._lazysizesParentFit || t.getAttribute("data-parent-fit")
                        };
                    return !c.fit && r && (e = r.match(o)) && (c.fit = e[1]), c.fit ? (n = t._lazysizesParentContainer || t.getAttribute("data-parent-container"), !n && r && (e = r.match(s)) && (n = e[1]), c.parent = l.getParent(t, n)) : c.fit = i.objectFit, c
                },
                getImageRatio: function(e) {
                    var n, o, s, a, l = e.parentNode,
                        c = l && r.test(l.nodeName || "") ? l.querySelectorAll("source, img") : [e];
                    for (n = 0; n < c.length; n++)
                        if (e = c[n], o = e.getAttribute(lazySizesConfig.srcsetAttr) || e.getAttribute("srcset") || e.getAttribute("data-pfsrcset") || e.getAttribute("data-risrcset") || "", s = e._lsMedia || e.getAttribute("media"), s = lazySizesConfig.customMedia[e.getAttribute("data-media") || s] || s, o && (!s || (t.matchMedia && matchMedia(s) || {}).matches)) {
                            a = parseFloat(e.getAttribute("data-aspectratio")), !a && o.match(i) && (a = "w" == RegExp.$2 ? RegExp.$1 / RegExp.$3 : RegExp.$3 / RegExp.$1);
                            break
                        }
                    return a
                },
                calculateSize: function(t, e) {
                    var n, i, o, s, r = this.getFit(t),
                        a = r.fit,
                        l = r.parent;
                    return "width" == a || ("contain" == a || "cover" == a) && (o = this.getImageRatio(t)) ? (l ? e = l.clientWidth : l = t, s = e, "width" == a ? s = e : (i = l.clientHeight, i > 40 && (n = e / i) && ("cover" == a && o > n || "contain" == a && n > o) && (s = e * (o / n))), s) : e
                }
            };
        n.parentFit = l, e.addEventListener("lazybeforesizes", function(t) {
            if (!t.defaultPrevented && t.detail.instance == n) {
                var e = t.target;
                t.detail.width = l.calculateSize(e, t.detail.width)
            }
        })
    }
}),
function(t, e) {
    "object" == typeof exports && exports && "string" != typeof exports.nodeName ? e(exports) : "function" == typeof define && define.amd ? define(["exports"], e) : (t.Mustache = {}, e(t.Mustache))
}(this, function(t) {
    function e(t) {
        return "function" == typeof t
    }

    function n(t) {
        return g(t) ? "array" : typeof t
    }

    function i(t) {
        return t.replace(/[\-\[\]{}()*+?.,\\\^$|#\s]/g, "\\$&")
    }

    function o(t, e) {
        return null != t && "object" == typeof t && e in t
    }

    function s(t, e) {
        return m.call(t, e)
    }

    function r(t) {
        return !s(v, t)
    }

    function a(t) {
        return String(t).replace(/[&<>"'`=\/]/g, function(t) {
            return y[t]
        })
    }

    function l(e, n) {
        function o() {
            if (v && !y)
                for (; m.length;) delete f[m.pop()];
            else m = [];
            v = !1, y = !1
        }

        function s(t) {
            if ("string" == typeof t && (t = t.split(x, 2)), !g(t) || 2 !== t.length) throw new Error("Invalid tags: " + t);
            a = new RegExp(i(t[0]) + "\\s*"), l = new RegExp("\\s*" + i(t[1])), d = new RegExp("\\s*" + i("}" + t[1]))
        }
        if (!e) return [];
        var a, l, d, p = [],
            f = [],
            m = [],
            v = !1,
            y = !1;
        s(n || t.tags);
        for (var T, S, $, E, P, A, k = new h(e); !k.eos();) {
            if (T = k.pos, $ = k.scanUntil(a))
                for (var z = 0, D = $.length; z < D; ++z) E = $.charAt(z), r(E) ? m.push(f.length) : y = !0, f.push(["text", E, T, T + 1]), T += 1, "\n" === E && o();
            if (!k.scan(a)) break;
            if (v = !0, S = k.scan(_) || "name", k.scan(b), "=" === S ? ($ = k.scanUntil(w), k.scan(w), k.scanUntil(l)) : "{" === S ? ($ = k.scanUntil(d), k.scan(C), k.scanUntil(l), S = "&") : $ = k.scanUntil(l), !k.scan(l)) throw new Error("Unclosed tag at " + k.pos);
            if (P = [S, $, T, k.pos], f.push(P), "#" === S || "^" === S) p.push(P);
            else if ("/" === S) {
                if (A = p.pop(), !A) throw new Error('Unopened section "' + $ + '" at ' + T);
                if (A[1] !== $) throw new Error('Unclosed section "' + A[1] + '" at ' + T)
            } else "name" === S || "{" === S || "&" === S ? y = !0 : "=" === S && s($)
        }
        if (A = p.pop()) throw new Error('Unclosed section "' + A[1] + '" at ' + k.pos);
        return u(c(f))
    }

    function c(t) {
        for (var e, n, i = [], o = 0, s = t.length; o < s; ++o) e = t[o], e && ("text" === e[0] && n && "text" === n[0] ? (n[1] += e[1], n[3] = e[3]) : (i.push(e), n = e));
        return i
    }

    function u(t) {
        for (var e, n, i = [], o = i, s = [], r = 0, a = t.length; r < a; ++r) switch (e = t[r], e[0]) {
            case "#":
            case "^":
                o.push(e), s.push(e), o = e[4] = [];
                break;
            case "/":
                n = s.pop(), n[5] = e[2], o = s.length > 0 ? s[s.length - 1][4] : i;
                break;
            default:
                o.push(e)
        }
        return i
    }

    function h(t) {
        this.string = t, this.tail = t, this.pos = 0
    }

    function d(t, e) {
        this.view = t, this.cache = {
            ".": this.view
        }, this.parent = e
    }

    function p() {
        this.cache = {}
    }
    var f = Object.prototype.toString,
        g = Array.isArray || function(t) {
            return "[object Array]" === f.call(t)
        },
        m = RegExp.prototype.test,
        v = /\S/,
        y = {
            "&": "&amp;",
            "<": "&lt;",
            ">": "&gt;",
            '"': "&quot;",
            "'": "&#39;",
            "/": "&#x2F;",
            "`": "&#x60;",
            "=": "&#x3D;"
        },
        b = /\s*/,
        x = /\s+/,
        w = /\s*=/,
        C = /\s*\}/,
        _ = /#|\^|\/|>|\{|&|=|!/;
    h.prototype.eos = function() {
        return "" === this.tail
    }, h.prototype.scan = function(t) {
        var e = this.tail.match(t);
        if (!e || 0 !== e.index) return "";
        var n = e[0];
        return this.tail = this.tail.substring(n.length), this.pos += n.length, n
    }, h.prototype.scanUntil = function(t) {
        var e, n = this.tail.search(t);
        switch (n) {
            case -1:
                e = this.tail, this.tail = "";
                break;
            case 0:
                e = "";
                break;
            default:
                e = this.tail.substring(0, n), this.tail = this.tail.substring(n)
        }
        return this.pos += e.length, e
    }, d.prototype.push = function(t) {
        return new d(t, this)
    }, d.prototype.lookup = function(t) {
        var n, i = this.cache;
        if (i.hasOwnProperty(t)) n = i[t];
        else {
            for (var s, r, a = this, l = !1; a;) {
                if (t.indexOf(".") > 0)
                    for (n = a.view, s = t.split("."), r = 0; null != n && r < s.length;) r === s.length - 1 && (l = o(n, s[r])), n = n[s[r++]];
                else n = a.view[t], l = o(a.view, t);
                if (l) break;
                a = a.parent
            }
            i[t] = n
        }
        return e(n) && (n = n.call(this.view)), n
    }, p.prototype.clearCache = function() {
        this.cache = {}
    }, p.prototype.parse = function(t, e) {
        var n = this.cache,
            i = n[t];
        return null == i && (i = n[t] = l(t, e)), i
    }, p.prototype.render = function(t, e, n) {
        var i = this.parse(t),
            o = e instanceof d ? e : new d(e);
        return this.renderTokens(i, o, n, t)
    }, p.prototype.renderTokens = function(t, e, n, i) {
        for (var o, s, r, a = "", l = 0, c = t.length; l < c; ++l) r = void 0, o = t[l], s = o[0], "#" === s ? r = this.renderSection(o, e, n, i) : "^" === s ? r = this.renderInverted(o, e, n, i) : ">" === s ? r = this.renderPartial(o, e, n, i) : "&" === s ? r = this.unescapedValue(o, e) : "name" === s ? r = this.escapedValue(o, e) : "text" === s && (r = this.rawValue(o)), void 0 !== r && (a += r);
        return a
    }, p.prototype.renderSection = function(t, n, i, o) {
        function s(t) {
            return r.render(t, n, i)
        }
        var r = this,
            a = "",
            l = n.lookup(t[1]);
        if (l) {
            if (g(l))
                for (var c = 0, u = l.length; c < u; ++c) a += this.renderTokens(t[4], n.push(l[c]), i, o);
            else if ("object" == typeof l || "string" == typeof l || "number" == typeof l) a += this.renderTokens(t[4], n.push(l), i, o);
            else if (e(l)) {
                if ("string" != typeof o) throw new Error("Cannot use higher-order sections without the original template");
                l = l.call(n.view, o.slice(t[3], t[5]), s), null != l && (a += l)
            } else a += this.renderTokens(t[4], n, i, o);
            return a
        }
    }, p.prototype.renderInverted = function(t, e, n, i) {
        var o = e.lookup(t[1]);
        if (!o || g(o) && 0 === o.length) return this.renderTokens(t[4], e, n, i)
    }, p.prototype.renderPartial = function(t, n, i) {
        if (i) {
            var o = e(i) ? i(t[1]) : i[t[1]];
            return null != o ? this.renderTokens(this.parse(o), n, i, o) : void 0
        }
    }, p.prototype.unescapedValue = function(t, e) {
        var n = e.lookup(t[1]);
        if (null != n) return n
    }, p.prototype.escapedValue = function(e, n) {
        var i = n.lookup(e[1]);
        if (null != i) return t.escape(i)
    }, p.prototype.rawValue = function(t) {
        return t[1]
    }, t.name = "mustache.js", t.version = "2.3.0", t.tags = [", "];
    var T = new p;
    return t.clearCache = function() {
        return T.clearCache()
    }, t.parse = function(t, e) {
        return T.parse(t, e)
    }, t.render = function(t, e, i) {
        if ("string" != typeof t) throw new TypeError('Invalid template! Template should be a "string" but "' + n(t) + '" was given as the first argument for mustache#render(template, view, partials)');
        return T.render(t, e, i)
    }, t.to_html = function(n, i, o, s) {
        var r = t.render(n, i, o);
        return e(s) ? void s(r) : r
    }, t.escape = a, t.Scanner = h, t.Context = d, t.Writer = p, t
}),
/**
 * Owl Carousel v2.2.1
 * Copyright 2013-2017 David Deutsch
 * Licensed under  ()
 */
! function(t, e, n, i) {
    function o(e, n) {
        this.settings = null, this.options = t.extend({}, o.Defaults, n), this.$element = t(e), this._handlers = {}, this._plugins = {}, this._supress = {}, this._current = null, this._speed = null, this._coordinates = [], this._breakpoint = null, this._width = null, this._items = [], this._clones = [], this._mergers = [], this._widths = [], this._invalidated = {}, this._pipe = [], this._drag = {
            time: null,
            target: null,
            pointer: null,
            stage: {
                start: null,
                current: null
            },
            direction: null
        }, this._states = {
            current: {},
            tags: {
                initializing: ["busy"],
                animating: ["busy"],
                dragging: ["interacting"]
            }
        }, t.each(["onResize", "onThrottledResize"], t.proxy(function(e, n) {
            this._handlers[n] = t.proxy(this[n], this)
        }, this)), t.each(o.Plugins, t.proxy(function(t, e) {
            this._plugins[t.charAt(0).toLowerCase() + t.slice(1)] = new e(this)
        }, this)), t.each(o.Workers, t.proxy(function(e, n) {
            this._pipe.push({
                filter: n.filter,
                run: t.proxy(n.run, this)
            })
        }, this)), this.setup(), this.initialize()
    }
    o.Defaults = {
        items: 3,
        loop: !1,
        center: !1,
        rewind: !1,
        mouseDrag: !0,
        touchDrag: !0,
        pullDrag: !0,
        freeDrag: !1,
        margin: 0,
        stagePadding: 0,
        merge: !1,
        mergeFit: !0,
        autoWidth: !1,
        startPosition: 0,
        rtl: !1,
        smartSpeed: 250,
        fluidSpeed: !1,
        dragEndSpeed: !1,
        responsive: {},
        responsiveRefreshRate: 200,
        responsiveBaseElement: e,
        fallbackEasing: "swing",
        info: !1,
        nestedItemSelector: !1,
        itemElement: "div",
        stageElement: "div",
        refreshClass: "owl-refresh",
        loadedClass: "owl-loaded",
        loadingClass: "owl-loading",
        rtlClass: "owl-rtl",
        responsiveClass: "owl-responsive",
        dragClass: "owl-drag",
        itemClass: "owl-item",
        stageClass: "owl-stage",
        stageOuterClass: "owl-stage-outer",
        grabClass: "owl-grab"
    }, o.Width = {
        Default: "default",
        Inner: "inner",
        Outer: "outer"
    }, o.Type = {
        Event: "event",
        State: "state"
    }, o.Plugins = {}, o.Workers = [{
        filter: ["width", "settings"],
        run: function() {
            this._width = this.$element.width()
        }
    }, {
        filter: ["width", "items", "settings"],
        run: function(t) {
            t.current = this._items && this._items[this.relative(this._current)]
        }
    }, {
        filter: ["items", "settings"],
        run: function() {
            this.$stage.children(".cloned").remove()
        }
    }, {
        filter: ["width", "items", "settings"],
        run: function(t) {
            var e = this.settings.margin || "",
                n = !this.settings.autoWidth,
                i = this.settings.rtl,
                o = {
                    width: "auto",
                    "margin-left": i ? e : "",
                    "margin-right": i ? "" : e
                };
            !n && this.$stage.children().css(o), t.css = o
        }
    }, {
        filter: ["width", "items", "settings"],
        run: function(t) {
            var e = (this.width() / this.settings.items).toFixed(3) - this.settings.margin,
                n = null,
                i = this._items.length,
                o = !this.settings.autoWidth,
                s = [];
            for (t.items = {
                    merge: !1,
                    width: e
                }; i--;) n = this._mergers[i], n = this.settings.mergeFit && Math.min(n, this.settings.items) || n, t.items.merge = n > 1 || t.items.merge, s[i] = o ? e * n : this._items[i].width();
            this._widths = s
        }
    }, {
        filter: ["items", "settings"],
        run: function() {
            var e = [],
                n = this._items,
                i = this.settings,
                o = Math.max(2 * i.items, 4),
                s = 2 * Math.ceil(n.length / 2),
                r = i.loop && n.length ? i.rewind ? o : Math.max(o, s) : 0,
                a = "",
                l = "";
            for (r /= 2; r--;) e.push(this.normalize(e.length / 2, !0)), a += n[e[e.length - 1]][0].outerHTML, e.push(this.normalize(n.length - 1 - (e.length - 1) / 2, !0)), l = n[e[e.length - 1]][0].outerHTML + l;
            this._clones = e, t(a).addClass("cloned").appendTo(this.$stage), t(l).addClass("cloned").prependTo(this.$stage)
        }
    }, {
        filter: ["width", "items", "settings"],
        run: function() {
            for (var t = this.settings.rtl ? 1 : -1, e = this._clones.length + this._items.length, n = -1, i = 0, o = 0, s = []; ++n < e;) i = s[n - 1] || 0, o = this._widths[this.relative(n)] + this.settings.margin, s.push(i + o * t);
            this._coordinates = s
        }
    }, {
        filter: ["width", "items", "settings"],
        run: function() {
            var t = this.settings.stagePadding,
                e = this._coordinates,
                n = {
                    width: Math.ceil(Math.abs(e[e.length - 1])) + 2 * t,
                    "padding-left": t || "",
                    "padding-right": t || ""
                };
            this.$stage.css(n)
        }
    }, {
        filter: ["width", "items", "settings"],
        run: function(t) {
            var e = this._coordinates.length,
                n = !this.settings.autoWidth,
                i = this.$stage.children();
            if (n && t.items.merge)
                for (; e--;) t.css.width = this._widths[this.relative(e)], i.eq(e).css(t.css);
            else n && (t.css.width = t.items.width, i.css(t.css))
        }
    }, {
        filter: ["items"],
        run: function() {
            this._coordinates.length < 1 && this.$stage.removeAttr("style")
        }
    }, {
        filter: ["width", "items", "settings"],
        run: function(t) {
            t.current = t.current ? this.$stage.children().index(t.current) : 0, t.current = Math.max(this.minimum(), Math.min(this.maximum(), t.current)), this.reset(t.current)
        }
    }, {
        filter: ["position"],
        run: function() {
            this.animate(this.coordinates(this._current))
        }
    }, {
        filter: ["width", "position", "items", "settings"],
        run: function() {
            var t, e, n, i, o = this.settings.rtl ? 1 : -1,
                s = 2 * this.settings.stagePadding,
                r = this.coordinates(this.current()) + s,
                a = r + this.width() * o,
                l = [];
            for (n = 0, i = this._coordinates.length; n < i; n++) t = this._coordinates[n - 1] || 0, e = Math.abs(this._coordinates[n]) + s * o, (this.op(t, "<=", r) && this.op(t, ">", a) || this.op(e, "<", r) && this.op(e, ">", a)) && l.push(n);
            this.$stage.children(".active").removeClass("active"), this.$stage.children(":eq(" + l.join("), :eq(") + ")").addClass("active"), this.settings.center && (this.$stage.children(".center").removeClass("center"), this.$stage.children().eq(this.current()).addClass("center"))
        }
    }], o.prototype.initialize = function() {
        if (this.enter("initializing"), this.trigger("initialize"), this.$element.toggleClass(this.settings.rtlClass, this.settings.rtl), this.settings.autoWidth && !this.is("pre-loading")) {
            var e, n, o;
            e = this.$element.find("img"), n = this.settings.nestedItemSelector ? "." + this.settings.nestedItemSelector : i, o = this.$element.children(n).width(), e.length && o <= 0 && this.preloadAutoWidthImages(e)
        }
        this.$element.addClass(this.options.loadingClass), this.$stage = t("<" + this.settings.stageElement + ' class="' + this.settings.stageClass + '"/>').wrap('<div class="' + this.settings.stageOuterClass + '"/>'), this.$element.append(this.$stage.parent()), this.replace(this.$element.children().not(this.$stage.parent())), this.$element.is(":visible") ? this.refresh() : this.invalidate("width"), this.$element.removeClass(this.options.loadingClass).addClass(this.options.loadedClass), this.registerEventHandlers(), this.leave("initializing"), this.trigger("initialized")
    }, o.prototype.setup = function() {
        var e = this.viewport(),
            n = this.options.responsive,
            i = -1,
            o = null;
        n ? (t.each(n, function(t) {
            t <= e && t > i && (i = Number(t))
        }), o = t.extend({}, this.options, n[i]), "function" == typeof o.stagePadding && (o.stagePadding = o.stagePadding()), delete o.responsive, o.responsiveClass && this.$element.attr("class", this.$element.attr("class").replace(new RegExp("(" + this.options.responsiveClass + "-)\\S+\\s", "g"), "$1" + i))) : o = t.extend({}, this.options), this.trigger("change", {
            property: {
                name: "settings",
                value: o
            }
        }), this._breakpoint = i, this.settings = o, this.invalidate("settings"), this.trigger("changed", {
            property: {
                name: "settings",
                value: this.settings
            }
        })
    }, o.prototype.optionsLogic = function() {
        this.settings.autoWidth && (this.settings.stagePadding = !1, this.settings.merge = !1)
    }, o.prototype.prepare = function(e) {
        var n = this.trigger("prepare", {
            content: e
        });
        return n.data || (n.data = t("<" + this.settings.itemElement + "/>").addClass(this.options.itemClass).append(e)), this.trigger("prepared", {
            content: n.data
        }), n.data
    }, o.prototype.update = function() {
        for (var e = 0, n = this._pipe.length, i = t.proxy(function(t) {
                return this[t]
            }, this._invalidated), o = {}; e < n;)(this._invalidated.all || t.grep(this._pipe[e].filter, i).length > 0) && this._pipe[e].run(o), e++;
        this._invalidated = {}, !this.is("valid") && this.enter("valid")
    }, o.prototype.width = function(t) {
        switch (t = t || o.Width.Default) {
            case o.Width.Inner:
            case o.Width.Outer:
                return this._width;
            default:
                return this._width - 2 * this.settings.stagePadding + this.settings.margin
        }
    }, o.prototype.refresh = function() {
        this.enter("refreshing"), this.trigger("refresh"), this.setup(), this.optionsLogic(), this.$element.addClass(this.options.refreshClass), this.update(), this.$element.removeClass(this.options.refreshClass), this.leave("refreshing"), this.trigger("refreshed")
    }, o.prototype.onThrottledResize = function() {
        e.clearTimeout(this.resizeTimer), this.resizeTimer = e.setTimeout(this._handlers.onResize, this.settings.responsiveRefreshRate)
    }, o.prototype.onResize = function() {
        return !!this._items.length && this._width !== this.$element.width() && !!this.$element.is(":visible") && (this.enter("resizing"), this.trigger("resize").isDefaultPrevented() ? (this.leave("resizing"), !1) : (this.invalidate("width"), this.refresh(), this.leave("resizing"), void this.trigger("resized")))
    }, o.prototype.registerEventHandlers = function() {
        t.support.transition && this.$stage.on(t.support.transition.end + ".owl.core", t.proxy(this.onTransitionEnd, this)), this.settings.responsive !== !1 && this.on(e, "resize", this._handlers.onThrottledResize), this.settings.mouseDrag && (this.$element.addClass(this.options.dragClass), this.$stage.on("mousedown.owl.core", t.proxy(this.onDragStart, this)), this.$stage.on("dragstart.owl.core selectstart.owl.core", function() {
            return !1
        })), this.settings.touchDrag && (this.$stage.on("touchstart.owl.core", t.proxy(this.onDragStart, this)), this.$stage.on("touchcancel.owl.core", t.proxy(this.onDragEnd, this)))
    }, o.prototype.onDragStart = function(e) {
        var i = null;
        3 !== e.which && (t.support.transform ? (i = this.$stage.css("transform").replace(/.*\(|\)| /g, "").split(","), i = {
            x: i[16 === i.length ? 12 : 4],
            y: i[16 === i.length ? 13 : 5]
        }) : (i = this.$stage.position(), i = {
            x: this.settings.rtl ? i.left + this.$stage.width() - this.width() + this.settings.margin : i.left,
            y: i.top
        }), this.is("animating") && (t.support.transform ? this.animate(i.x) : this.$stage.stop(), this.invalidate("position")), this.$element.toggleClass(this.options.grabClass, "mousedown" === e.type), this.speed(0), this._drag.time = (new Date).getTime(), this._drag.target = t(e.target), this._drag.stage.start = i, this._drag.stage.current = i, this._drag.pointer = this.pointer(e), t(n).on("mouseup.owl.core touchend.owl.core", t.proxy(this.onDragEnd, this)), t(n).one("mousemove.owl.core touchmove.owl.core", t.proxy(function(e) {
            var i = this.difference(this._drag.pointer, this.pointer(e));
            t(n).on("mousemove.owl.core touchmove.owl.core", t.proxy(this.onDragMove, this)), Math.abs(i.x) < Math.abs(i.y) && this.is("valid") || (e.preventDefault(), this.enter("dragging"), this.trigger("drag"))
        }, this)))
    }, o.prototype.onDragMove = function(t) {
        var e = null,
            n = null,
            i = null,
            o = this.difference(this._drag.pointer, this.pointer(t)),
            s = this.difference(this._drag.stage.start, o);
        this.is("dragging") && (t.preventDefault(), this.settings.loop ? (e = this.coordinates(this.minimum()), n = this.coordinates(this.maximum() + 1) - e, s.x = ((s.x - e) % n + n) % n + e) : (e = this.settings.rtl ? this.coordinates(this.maximum()) : this.coordinates(this.minimum()), n = this.settings.rtl ? this.coordinates(this.minimum()) : this.coordinates(this.maximum()), i = this.settings.pullDrag ? -1 * o.x / 5 : 0, s.x = Math.max(Math.min(s.x, e + i), n + i)), this._drag.stage.current = s, this.animate(s.x))
    }, o.prototype.onDragEnd = function(e) {
        var i = this.difference(this._drag.pointer, this.pointer(e)),
            o = this._drag.stage.current,
            s = i.x > 0 ^ this.settings.rtl ? "left" : "right";
        t(n).off(".owl.core"), this.$element.removeClass(this.options.grabClass), (0 !== i.x && this.is("dragging") || !this.is("valid")) && (this.speed(this.settings.dragEndSpeed || this.settings.smartSpeed), this.current(this.closest(o.x, 0 !== i.x ? s : this._drag.direction)), this.invalidate("position"), this.update(), this._drag.direction = s, (Math.abs(i.x) > 3 || (new Date).getTime() - this._drag.time > 300) && this._drag.target.one("click.owl.core", function() {
            return !1
        })), this.is("dragging") && (this.leave("dragging"), this.trigger("dragged"))
    }, o.prototype.closest = function(e, n) {
        var i = -1,
            o = 30,
            s = this.width(),
            r = this.coordinates();
        return this.settings.freeDrag || t.each(r, t.proxy(function(t, a) {
            return "left" === n && e > a - o && e < a + o ? i = t : "right" === n && e > a - s - o && e < a - s + o ? i = t + 1 : this.op(e, "<", a) && this.op(e, ">", r[t + 1] || a - s) && (i = "left" === n ? t + 1 : t), i === -1
        }, this)), this.settings.loop || (this.op(e, ">", r[this.minimum()]) ? i = e = this.minimum() : this.op(e, "<", r[this.maximum()]) && (i = e = this.maximum())), i
    }, o.prototype.animate = function(e) {
        var n = this.speed() > 0;
        this.is("animating") && this.onTransitionEnd(), n && (this.enter("animating"), this.trigger("translate")), t.support.transform3d && t.support.transition ? this.$stage.css({
            transform: "translate3d(" + e + "px,0px,0px)",
            transition: this.speed() / 1e3 + "s"
        }) : n ? this.$stage.animate({
            left: e + "px"
        }, this.speed(), this.settings.fallbackEasing, t.proxy(this.onTransitionEnd, this)) : this.$stage.css({
            left: e + "px"
        })
    }, o.prototype.is = function(t) {
        return this._states.current[t] && this._states.current[t] > 0
    }, o.prototype.current = function(t) {
        if (t === i) return this._current;
        if (0 === this._items.length) return i;
        if (t = this.normalize(t), this._current !== t) {
            var e = this.trigger("change", {
                property: {
                    name: "position",
                    value: t
                }
            });
            e.data !== i && (t = this.normalize(e.data)), this._current = t, this.invalidate("position"), this.trigger("changed", {
                property: {
                    name: "position",
                    value: this._current
                }
            })
        }
        return this._current
    }, o.prototype.invalidate = function(e) {
        return "string" === t.type(e) && (this._invalidated[e] = !0, this.is("valid") && this.leave("valid")), t.map(this._invalidated, function(t, e) {
            return e
        })
    }, o.prototype.reset = function(t) {
        t = this.normalize(t), t !== i && (this._speed = 0, this._current = t, this.suppress(["translate", "translated"]), this.animate(this.coordinates(t)), this.release(["translate", "translated"]))
    }, o.prototype.normalize = function(t, e) {
        var n = this._items.length,
            o = e ? 0 : this._clones.length;
        return !this.isNumeric(t) || n < 1 ? t = i : (t < 0 || t >= n + o) && (t = ((t - o / 2) % n + n) % n + o / 2), t
    }, o.prototype.relative = function(t) {
        return t -= this._clones.length / 2, this.normalize(t, !0)
    }, o.prototype.maximum = function(t) {
        var e, n, i, o = this.settings,
            s = this._coordinates.length;
        if (o.loop) s = this._clones.length / 2 + this._items.length - 1;
        else if (o.autoWidth || o.merge) {
            for (e = this._items.length, n = this._items[--e].width(), i = this.$element.width(); e-- && (n += this._items[e].width() + this.settings.margin, !(n > i)););
            s = e + 1
        } else s = o.center ? this._items.length - 1 : this._items.length - o.items;
        return t && (s -= this._clones.length / 2), Math.max(s, 0)
    }, o.prototype.minimum = function(t) {
        return t ? 0 : this._clones.length / 2
    }, o.prototype.items = function(t) {
        return t === i ? this._items.slice() : (t = this.normalize(t, !0), this._items[t])
    }, o.prototype.mergers = function(t) {
        return t === i ? this._mergers.slice() : (t = this.normalize(t, !0), this._mergers[t])
    }, o.prototype.clones = function(e) {
        var n = this._clones.length / 2,
            o = n + this._items.length,
            s = function(t) {
                return t % 2 === 0 ? o + t / 2 : n - (t + 1) / 2
            };
        return e === i ? t.map(this._clones, function(t, e) {
            return s(e)
        }) : t.map(this._clones, function(t, n) {
            return t === e ? s(n) : null
        })
    }, o.prototype.speed = function(t) {
        return t !== i && (this._speed = t), this._speed
    }, o.prototype.coordinates = function(e) {
        var n, o = 1,
            s = e - 1;
        return e === i ? t.map(this._coordinates, t.proxy(function(t, e) {
            return this.coordinates(e)
        }, this)) : (this.settings.center ? (this.settings.rtl && (o = -1, s = e + 1), n = this._coordinates[e], n += (this.width() - n + (this._coordinates[s] || 0)) / 2 * o) : n = this._coordinates[s] || 0, n = Math.ceil(n))
    }, o.prototype.duration = function(t, e, n) {
        return 0 === n ? 0 : Math.min(Math.max(Math.abs(e - t), 1), 6) * Math.abs(n || this.settings.smartSpeed)
    }, o.prototype.to = function(t, e) {
        var n = this.current(),
            i = null,
            o = t - this.relative(n),
            s = (o > 0) - (o < 0),
            r = this._items.length,
            a = this.minimum(),
            l = this.maximum();
        this.settings.loop ? (!this.settings.rewind && Math.abs(o) > r / 2 && (o += s * -1 * r), t = n + o, i = ((t - a) % r + r) % r + a, i !== t && i - o <= l && i - o > 0 && (n = i - o, t = i, this.reset(n))) : this.settings.rewind ? (l += 1, t = (t % l + l) % l) : t = Math.max(a, Math.min(l, t)), this.speed(this.duration(n, t, e)), this.current(t), this.$element.is(":visible") && this.update()
    }, o.prototype.next = function(t) {
        t = t || !1, this.to(this.relative(this.current()) + 1, t)
    }, o.prototype.prev = function(t) {
        t = t || !1, this.to(this.relative(this.current()) - 1, t)
    }, o.prototype.onTransitionEnd = function(t) {
        return (t === i || (t.stopPropagation(), (t.target || t.srcElement || t.originalTarget) === this.$stage.get(0))) && (this.leave("animating"), void this.trigger("translated"))
    }, o.prototype.viewport = function() {
        var i;
        return this.options.responsiveBaseElement !== e ? i = t(this.options.responsiveBaseElement).width() : e.innerWidth ? i = e.innerWidth : n.documentElement && n.documentElement.clientWidth ? i = n.documentElement.clientWidth : console.warn("Can not detect viewport width."), i
    }, o.prototype.replace = function(e) {
        this.$stage.empty(), this._items = [], e && (e = e instanceof jQuery ? e : t(e)), this.settings.nestedItemSelector && (e = e.find("." + this.settings.nestedItemSelector)), e.filter(function() {
            return 1 === this.nodeType
        }).each(t.proxy(function(t, e) {
            e = this.prepare(e), this.$stage.append(e), this._items.push(e), this._mergers.push(1 * e.find("[data-merge]").addBack("[data-merge]").attr("data-merge") || 1)
        }, this)), this.reset(this.isNumeric(this.settings.startPosition) ? this.settings.startPosition : 0), this.invalidate("items")
    }, o.prototype.add = function(e, n) {
        var o = this.relative(this._current);
        n = n === i ? this._items.length : this.normalize(n, !0), e = e instanceof jQuery ? e : t(e), this.trigger("add", {
            content: e,
            position: n
        }), e = this.prepare(e), 0 === this._items.length || n === this._items.length ? (0 === this._items.length && this.$stage.append(e), 0 !== this._items.length && this._items[n - 1].after(e), this._items.push(e), this._mergers.push(1 * e.find("[data-merge]").addBack("[data-merge]").attr("data-merge") || 1)) : (this._items[n].before(e), this._items.splice(n, 0, e), this._mergers.splice(n, 0, 1 * e.find("[data-merge]").addBack("[data-merge]").attr("data-merge") || 1)), this._items[o] && this.reset(this._items[o].index()), this.invalidate("items"), this.trigger("added", {
            content: e,
            position: n
        })
    }, o.prototype.remove = function(t) {
        t = this.normalize(t, !0), t !== i && (this.trigger("remove", {
            content: this._items[t],
            position: t
        }), this._items[t].remove(), this._items.splice(t, 1), this._mergers.splice(t, 1), this.invalidate("items"), this.trigger("removed", {
            content: null,
            position: t
        }))
    }, o.prototype.preloadAutoWidthImages = function(e) {
        e.each(t.proxy(function(e, n) {
            this.enter("pre-loading"), n = t(n), t(new Image).one("load", t.proxy(function(t) {
                n.attr("src", t.target.src), n.css("opacity", 1), this.leave("pre-loading"), !this.is("pre-loading") && !this.is("initializing") && this.refresh()
            }, this)).attr("src", n.attr("src") || n.attr("data-src") || n.attr("data-src-retina"))
        }, this))
    }, o.prototype.destroy = function() {
        this.$element.off(".owl.core"), this.$stage.off(".owl.core"), t(n).off(".owl.core"), this.settings.responsive !== !1 && (e.clearTimeout(this.resizeTimer), this.off(e, "resize", this._handlers.onThrottledResize));
        for (var i in this._plugins) this._plugins[i].destroy();
        this.$stage.children(".cloned").remove(), this.$stage.unwrap(), this.$stage.children().contents().unwrap(), this.$stage.children().unwrap(), this.$element.removeClass(this.options.refreshClass).removeClass(this.options.loadingClass).removeClass(this.options.loadedClass).removeClass(this.options.rtlClass).removeClass(this.options.dragClass).removeClass(this.options.grabClass).attr("class", this.$element.attr("class").replace(new RegExp(this.options.responsiveClass + "-\\S+\\s", "g"), "")).removeData("owl.carousel")
    }, o.prototype.op = function(t, e, n) {
        var i = this.settings.rtl;
        switch (e) {
            case "<":
                return i ? t > n : t < n;
            case ">":
                return i ? t < n : t > n;
            case ">=":
                return i ? t <= n : t >= n;
            case "<=":
                return i ? t >= n : t <= n
        }
    }, o.prototype.on = function(t, e, n, i) {
        t.addEventListener ? t.addEventListener(e, n, i) : t.attachEvent && t.attachEvent("on" + e, n)
    }, o.prototype.off = function(t, e, n, i) {
        t.removeEventListener ? t.removeEventListener(e, n, i) : t.detachEvent && t.detachEvent("on" + e, n)
    }, o.prototype.trigger = function(e, n, i, s, r) {
        var a = {
                item: {
                    count: this._items.length,
                    index: this.current()
                }
            },
            l = t.camelCase(t.grep(["on", e, i], function(t) {
                return t
            }).join("-").toLowerCase()),
            c = t.Event([e, "owl", i || "carousel"].join(".").toLowerCase(), t.extend({
                relatedTarget: this
            }, a, n));
        return this._supress[e] || (t.each(this._plugins, function(t, e) {
            e.onTrigger && e.onTrigger(c)
        }), this.register({
            type: o.Type.Event,
            name: e
        }), this.$element.trigger(c), this.settings && "function" == typeof this.settings[l] && this.settings[l].call(this, c)), c
    }, o.prototype.enter = function(e) {
        t.each([e].concat(this._states.tags[e] || []), t.proxy(function(t, e) {
            this._states.current[e] === i && (this._states.current[e] = 0), this._states.current[e]++
        }, this))
    }, o.prototype.leave = function(e) {
        t.each([e].concat(this._states.tags[e] || []), t.proxy(function(t, e) {
            this._states.current[e]--
        }, this))
    }, o.prototype.register = function(e) {
        if (e.type === o.Type.Event) {
            if (t.event.special[e.name] || (t.event.special[e.name] = {}), !t.event.special[e.name].owl) {
                var n = t.event.special[e.name]._default;
                t.event.special[e.name]._default = function(t) {
                    return !n || !n.apply || t.namespace && t.namespace.indexOf("owl") !== -1 ? t.namespace && t.namespace.indexOf("owl") > -1 : n.apply(this, arguments)
                }, t.event.special[e.name].owl = !0
            }
        } else e.type === o.Type.State && (this._states.tags[e.name] ? this._states.tags[e.name] = this._states.tags[e.name].concat(e.tags) : this._states.tags[e.name] = e.tags, this._states.tags[e.name] = t.grep(this._states.tags[e.name], t.proxy(function(n, i) {
            return t.inArray(n, this._states.tags[e.name]) === i
        }, this)))
    }, o.prototype.suppress = function(e) {
        t.each(e, t.proxy(function(t, e) {
            this._supress[e] = !0
        }, this))
    }, o.prototype.release = function(e) {
        t.each(e, t.proxy(function(t, e) {
            delete this._supress[e]
        }, this))
    }, o.prototype.pointer = function(t) {
        var n = {
            x: null,
            y: null
        };
        return t = t.originalEvent || t || e.event, t = t.touches && t.touches.length ? t.touches[0] : t.changedTouches && t.changedTouches.length ? t.changedTouches[0] : t, t.pageX ? (n.x = t.pageX, n.y = t.pageY) : (n.x = t.clientX, n.y = t.clientY), n
    }, o.prototype.isNumeric = function(t) {
        return !isNaN(parseFloat(t))
    }, o.prototype.difference = function(t, e) {
        return {
            x: t.x - e.x,
            y: t.y - e.y
        }
    }, t.fn.owlCarousel = function(e) {
        var n = Array.prototype.slice.call(arguments, 1);
        return this.each(function() {
            var i = t(this),
                s = i.data("owl.carousel");
            s || (s = new o(this, "object" == typeof e && e), i.data("owl.carousel", s), t.each(["next", "prev", "to", "destroy", "refresh", "replace", "add", "remove"], function(e, n) {
                s.register({
                    type: o.Type.Event,
                    name: n
                }), s.$element.on(n + ".owl.carousel.core", t.proxy(function(t) {
                    t.namespace && t.relatedTarget !== this && (this.suppress([n]), s[n].apply(this, [].slice.call(arguments, 1)), this.release([n]))
                }, s))
            })), "string" == typeof e && "_" !== e.charAt(0) && s[e].apply(s, n)
        })
    }, t.fn.owlCarousel.Constructor = o
}(window.Zepto || window.jQuery, window, document),
function(t, e, n, i) {
    var o = function(e) {
        this._core = e, this._interval = null, this._visible = null, this._handlers = {
            "initialized.owl.carousel": t.proxy(function(t) {
                t.namespace && this._core.settings.autoRefresh && this.watch()
            }, this)
        }, this._core.options = t.extend({}, o.Defaults, this._core.options), this._core.$element.on(this._handlers)
    };
    o.Defaults = {
        autoRefresh: !0,
        autoRefreshInterval: 500
    }, o.prototype.watch = function() {
        this._interval || (this._visible = this._core.$element.is(":visible"), this._interval = e.setInterval(t.proxy(this.refresh, this), this._core.settings.autoRefreshInterval))
    }, o.prototype.refresh = function() {
        this._core.$element.is(":visible") !== this._visible && (this._visible = !this._visible, this._core.$element.toggleClass("owl-hidden", !this._visible), this._visible && this._core.invalidate("width") && this._core.refresh())
    }, o.prototype.destroy = function() {
        var t, n;
        e.clearInterval(this._interval);
        for (t in this._handlers) this._core.$element.off(t, this._handlers[t]);
        for (n in Object.getOwnPropertyNames(this)) "function" != typeof this[n] && (this[n] = null)
    }, t.fn.owlCarousel.Constructor.Plugins.AutoRefresh = o
}(window.Zepto || window.jQuery, window, document),
function(t, e, n, i) {
    var o = function(e) {
        this._core = e, this._loaded = [], this._handlers = {
            "initialized.owl.carousel change.owl.carousel resized.owl.carousel": t.proxy(function(e) {
                if (e.namespace && this._core.settings && this._core.settings.lazyLoad && (e.property && "position" == e.property.name || "initialized" == e.type))
                    for (var n = this._core.settings, o = n.center && Math.ceil(n.items / 2) || n.items, s = n.center && o * -1 || 0, r = (e.property && e.property.value !== i ? e.property.value : this._core.current()) + s, a = this._core.clones().length, l = t.proxy(function(t, e) {
                            this.load(e)
                        }, this); s++ < o;) this.load(a / 2 + this._core.relative(r)), a && t.each(this._core.clones(this._core.relative(r)), l), r++
            }, this)
        }, this._core.options = t.extend({}, o.Defaults, this._core.options), this._core.$element.on(this._handlers)
    };
    o.Defaults = {
        lazyLoad: !1
    }, o.prototype.load = function(n) {
        var i = this._core.$stage.children().eq(n),
            o = i && i.find(".owl-lazy");
        !o || t.inArray(i.get(0), this._loaded) > -1 || (o.each(t.proxy(function(n, i) {
            var o, s = t(i),
                r = e.devicePixelRatio > 1 && s.attr("data-src-retina") || s.attr("data-src");
            this._core.trigger("load", {
                element: s,
                url: r
            }, "lazy"), s.is("img") ? s.one("load.owl.lazy", t.proxy(function() {
                s.css("opacity", 1), this._core.trigger("loaded", {
                    element: s,
                    url: r
                }, "lazy")
            }, this)).attr("src", r) : (o = new Image, o.onload = t.proxy(function() {
                s.css({
                    "background-image": 'url("' + r + '")',
                    opacity: "1"
                }), this._core.trigger("loaded", {
                    element: s,
                    url: r
                }, "lazy")
            }, this), o.src = r)
        }, this)), this._loaded.push(i.get(0)))
    }, o.prototype.destroy = function() {
        var t, e;
        for (t in this.handlers) this._core.$element.off(t, this.handlers[t]);
        for (e in Object.getOwnPropertyNames(this)) "function" != typeof this[e] && (this[e] = null)
    }, t.fn.owlCarousel.Constructor.Plugins.Lazy = o
}(window.Zepto || window.jQuery, window, document),
function(t, e, n, i) {
    var o = function(e) {
        this._core = e, this._handlers = {
            "initialized.owl.carousel refreshed.owl.carousel": t.proxy(function(t) {
                t.namespace && this._core.settings.autoHeight && this.update()
            }, this),
            "changed.owl.carousel": t.proxy(function(t) {
                t.namespace && this._core.settings.autoHeight && "position" == t.property.name && this.update()
            }, this),
            "loaded.owl.lazy": t.proxy(function(t) {
                t.namespace && this._core.settings.autoHeight && t.element.closest("." + this._core.settings.itemClass).index() === this._core.current() && this.update()
            }, this)
        }, this._core.options = t.extend({}, o.Defaults, this._core.options), this._core.$element.on(this._handlers)
    };
    o.Defaults = {
        autoHeight: !1,
        autoHeightClass: "owl-height"
    }, o.prototype.update = function() {
        var e = this._core._current,
            n = e + this._core.settings.items,
            i = this._core.$stage.children().toArray().slice(e, n),
            o = [],
            s = 0;
        t.each(i, function(e, n) {
            o.push(t(n).height())
        }), s = Math.max.apply(null, o), this._core.$stage.parent().height(s).addClass(this._core.settings.autoHeightClass)
    }, o.prototype.destroy = function() {
        var t, e;
        for (t in this._handlers) this._core.$element.off(t, this._handlers[t]);
        for (e in Object.getOwnPropertyNames(this)) "function" != typeof this[e] && (this[e] = null)
    }, t.fn.owlCarousel.Constructor.Plugins.AutoHeight = o
}(window.Zepto || window.jQuery, window, document),
function(t, e, n, i) {
    var o = function(e) {
        this._core = e, this._videos = {}, this._playing = null, this._handlers = {
            "initialized.owl.carousel": t.proxy(function(t) {
                t.namespace && this._core.register({
                    type: "state",
                    name: "playing",
                    tags: ["interacting"]
                })
            }, this),
            "resize.owl.carousel": t.proxy(function(t) {
                t.namespace && this._core.settings.video && this.isInFullScreen() && t.preventDefault()
            }, this),
            "refreshed.owl.carousel": t.proxy(function(t) {
                t.namespace && this._core.is("resizing") && this._core.$stage.find(".cloned .owl-video-frame").remove()
            }, this),
            "changed.owl.carousel": t.proxy(function(t) {
                t.namespace && "position" === t.property.name && this._playing && this.stop()
            }, this),
            "prepared.owl.carousel": t.proxy(function(e) {
                if (e.namespace) {
                    var n = t(e.content).find(".owl-video");
                    n.length && (n.css("display", "none"), this.fetch(n, t(e.content)))
                }
            }, this)
        }, this._core.options = t.extend({}, o.Defaults, this._core.options), this._core.$element.on(this._handlers), this._core.$element.on("click.owl.video", ".owl-video-play-icon", t.proxy(function(t) {
            this.play(t)
        }, this))
    };
    o.Defaults = {
        video: !1,
        videoHeight: !1,
        videoWidth: !1
    }, o.prototype.fetch = function(t, e) {
        var n = function() {
                return t.attr("data-vimeo-id") ? "vimeo" : t.attr("data-vzaar-id") ? "vzaar" : "youtube"
            }(),
            i = t.attr("data-vimeo-id") || t.attr("data-youtube-id") || t.attr("data-vzaar-id"),
            o = t.attr("data-width") || this._core.settings.videoWidth,
            s = t.attr("data-height") || this._core.settings.videoHeight,
            r = t.attr("href");
        if (!r) throw new Error("Missing video URL.");
        if (i = r.match(/(http:|https:|)\/\/(player.|www.|app.)?(vimeo\.com|youtu(be\.com|\.be|be\.googleapis\.com)|vzaar\.com)\/(video\/|videos\/|embed\/|channels\/.+\/|groups\/.+\/|watch\?v=|v\/)?([A-Za-z0-9._%-]*)(\&\S+)?/), i[3].indexOf("youtu") > -1) n = "youtube";
        else if (i[3].indexOf("vimeo") > -1) n = "vimeo";
        else {
            if (!(i[3].indexOf("vzaar") > -1)) throw new Error("Video URL not supported.");
            n = "vzaar"
        }
        i = i[6], this._videos[r] = {
            type: n,
            id: i,
            width: o,
            height: s
        }, e.attr("data-video", r), this.thumbnail(t, this._videos[r])
    }, o.prototype.thumbnail = function(e, n) {
        var i, o, s, r = n.width && n.height ? 'style="width:' + n.width + "px;height:" + n.height + 'px;"' : "",
            a = e.find("img"),
            l = "src",
            c = "",
            u = this._core.settings,
            h = function(t) {
                o = '<div class="owl-video-play-icon"></div>', i = u.lazyLoad ? '<div class="owl-video-tn ' + c + '" ' + l + '="' + t + '"></div>' : '<div class="owl-video-tn" style="opacity:1;background-image:url(' + t + ')"></div>', e.after(i), e.after(o)
            };
        return e.wrap('<div class="owl-video-wrapper"' + r + "></div>"), this._core.settings.lazyLoad && (l = "data-src", c = "owl-lazy"), a.length ? (h(a.attr(l)), a.remove(), !1) : void("youtube" === n.type ? (s = "//img.youtube.com/vi/" + n.id + "/hqdefault.jpg", h(s)) : "vimeo" === n.type ? t.ajax({
            type: "GET",
            url: "//vimeo.com/api/v2/video/" + n.id + ".json",
            jsonp: "callback",
            dataType: "jsonp",
            success: function(t) {
                s = t[0].thumbnail_large, h(s)
            }
        }) : "vzaar" === n.type && t.ajax({
            type: "GET",
            url: "//vzaar.com/api/videos/" + n.id + ".json",
            jsonp: "callback",
            dataType: "jsonp",
            success: function(t) {
                s = t.framegrab_url, h(s)
            }
        }))
    }, o.prototype.stop = function() {
        this._core.trigger("stop", null, "video"), this._playing.find(".owl-video-frame").remove(), this._playing.removeClass("owl-video-playing"), this._playing = null, this._core.leave("playing"), this._core.trigger("stopped", null, "video")
    }, o.prototype.play = function(e) {
        var n, i = t(e.target),
            o = i.closest("." + this._core.settings.itemClass),
            s = this._videos[o.attr("data-video")],
            r = s.width || "100%",
            a = s.height || this._core.$stage.height();
        this._playing || (this._core.enter("playing"), this._core.trigger("play", null, "video"), o = this._core.items(this._core.relative(o.index())), this._core.reset(o.index()), "youtube" === s.type ? n = '<iframe width="' + r + '" height="' + a + '" src="//www.youtube.com/embed/' + s.id + "?autoplay=1&rel=0&v=" + s.id + '" frameborder="0" allowfullscreen></iframe>' : "vimeo" === s.type ? n = '<iframe src="//player.vimeo.com/video/' + s.id + '?autoplay=1" width="' + r + '" height="' + a + '" frameborder="0" webkitallowfullscreen mozallowfullscreen allowfullscreen></iframe>' : "vzaar" === s.type && (n = '<iframe frameborder="0"height="' + a + '"width="' + r + '" allowfullscreen mozallowfullscreen webkitAllowFullScreen src="//view.vzaar.com/' + s.id + '/player?autoplay=true"></iframe>'), t('<div class="owl-video-frame">' + n + "</div>").insertAfter(o.find(".owl-video")), this._playing = o.addClass("owl-video-playing"))
    }, o.prototype.isInFullScreen = function() {
        var e = n.fullscreenElement || n.mozFullScreenElement || n.webkitFullscreenElement;
        return e && t(e).parent().hasClass("owl-video-frame")
    }, o.prototype.destroy = function() {
        var t, e;
        this._core.$element.off("click.owl.video");
        for (t in this._handlers) this._core.$element.off(t, this._handlers[t]);
        for (e in Object.getOwnPropertyNames(this)) "function" != typeof this[e] && (this[e] = null)
    }, t.fn.owlCarousel.Constructor.Plugins.Video = o
}(window.Zepto || window.jQuery, window, document),
function(t, e, n, i) {
    var o = function(e) {
        this.core = e, this.core.options = t.extend({}, o.Defaults, this.core.options), this.swapping = !0, this.previous = i, this.next = i, this.handlers = {
            "change.owl.carousel": t.proxy(function(t) {
                t.namespace && "position" == t.property.name && (this.previous = this.core.current(), this.next = t.property.value)
            }, this),
            "drag.owl.carousel dragged.owl.carousel translated.owl.carousel": t.proxy(function(t) {
                t.namespace && (this.swapping = "translated" == t.type)
            }, this),
            "translate.owl.carousel": t.proxy(function(t) {
                t.namespace && this.swapping && (this.core.options.animateOut || this.core.options.animateIn) && this.swap()
            }, this)
        }, this.core.$element.on(this.handlers)
    };
    o.Defaults = {
        animateOut: !1,
        animateIn: !1
    }, o.prototype.swap = function() {
        if (1 === this.core.settings.items && t.support.animation && t.support.transition) {
            this.core.speed(0);
            var e, n = t.proxy(this.clear, this),
                i = this.core.$stage.children().eq(this.previous),
                o = this.core.$stage.children().eq(this.next),
                s = this.core.settings.animateIn,
                r = this.core.settings.animateOut;
            this.core.current() !== this.previous && (r && (e = this.core.coordinates(this.previous) - this.core.coordinates(this.next), i.one(t.support.animation.end, n).css({
                left: e + "px"
            }).addClass("animated owl-animated-out").addClass(r)), s && o.one(t.support.animation.end, n).addClass("animated owl-animated-in").addClass(s))
        }
    }, o.prototype.clear = function(e) {
        t(e.target).css({
            left: ""
        }).removeClass("animated owl-animated-out owl-animated-in").removeClass(this.core.settings.animateIn).removeClass(this.core.settings.animateOut), this.core.onTransitionEnd()
    }, o.prototype.destroy = function() {
        var t, e;
        for (t in this.handlers) this.core.$element.off(t, this.handlers[t]);
        for (e in Object.getOwnPropertyNames(this)) "function" != typeof this[e] && (this[e] = null);
    }, t.fn.owlCarousel.Constructor.Plugins.Animate = o
}(window.Zepto || window.jQuery, window, document),
function(t, e, n, i) {
    var o = function(e) {
        this._core = e, this._timeout = null, this._paused = !1, this._handlers = {
            "changed.owl.carousel": t.proxy(function(t) {
                t.namespace && "settings" === t.property.name ? this._core.settings.autoplay ? this.play() : this.stop() : t.namespace && "position" === t.property.name && this._core.settings.autoplay && this._setAutoPlayInterval()
            }, this),
            "initialized.owl.carousel": t.proxy(function(t) {
                t.namespace && this._core.settings.autoplay && this.play()
            }, this),
            "play.owl.autoplay": t.proxy(function(t, e, n) {
                t.namespace && this.play(e, n)
            }, this),
            "stop.owl.autoplay": t.proxy(function(t) {
                t.namespace && this.stop()
            }, this),
            "mouseover.owl.autoplay": t.proxy(function() {
                this._core.settings.autoplayHoverPause && this._core.is("rotating") && this.pause()
            }, this),
            "mouseleave.owl.autoplay": t.proxy(function() {
                this._core.settings.autoplayHoverPause && this._core.is("rotating") && this.play()
            }, this),
            "touchstart.owl.core": t.proxy(function() {
                this._core.settings.autoplayHoverPause && this._core.is("rotating") && this.pause()
            }, this),
            "touchend.owl.core": t.proxy(function() {
                this._core.settings.autoplayHoverPause && this.play()
            }, this)
        }, this._core.$element.on(this._handlers), this._core.options = t.extend({}, o.Defaults, this._core.options)
    };
    o.Defaults = {
        autoplay: !1,
        autoplayTimeout: 5e3,
        autoplayHoverPause: !1,
        autoplaySpeed: !1
    }, o.prototype.play = function(t, e) {
        this._paused = !1, this._core.is("rotating") || (this._core.enter("rotating"), this._setAutoPlayInterval())
    }, o.prototype._getNextTimeout = function(i, o) {
        return this._timeout && e.clearTimeout(this._timeout), e.setTimeout(t.proxy(function() {
            this._paused || this._core.is("busy") || this._core.is("interacting") || n.hidden || this._core.next(o || this._core.settings.autoplaySpeed)
        }, this), i || this._core.settings.autoplayTimeout)
    }, o.prototype._setAutoPlayInterval = function() {
        this._timeout = this._getNextTimeout()
    }, o.prototype.stop = function() {
        this._core.is("rotating") && (e.clearTimeout(this._timeout), this._core.leave("rotating"))
    }, o.prototype.pause = function() {
        this._core.is("rotating") && (this._paused = !0)
    }, o.prototype.destroy = function() {
        var t, e;
        this.stop();
        for (t in this._handlers) this._core.$element.off(t, this._handlers[t]);
        for (e in Object.getOwnPropertyNames(this)) "function" != typeof this[e] && (this[e] = null)
    }, t.fn.owlCarousel.Constructor.Plugins.autoplay = o
}(window.Zepto || window.jQuery, window, document),
function(t, e, n, i) {
    "use strict";
    var o = function(e) {
        this._core = e, this._initialized = !1, this._pages = [], this._controls = {}, this._templates = [], this.$element = this._core.$element, this._overrides = {
            next: this._core.next,
            prev: this._core.prev,
            to: this._core.to
        }, this._handlers = {
            "prepared.owl.carousel": t.proxy(function(e) {
                e.namespace && this._core.settings.dotsData && this._templates.push('<div class="' + this._core.settings.dotClass + '">' + t(e.content).find("[data-dot]").addBack("[data-dot]").attr("data-dot") + "</div>")
            }, this),
            "added.owl.carousel": t.proxy(function(t) {
                t.namespace && this._core.settings.dotsData && this._templates.splice(t.position, 0, this._templates.pop())
            }, this),
            "remove.owl.carousel": t.proxy(function(t) {
                t.namespace && this._core.settings.dotsData && this._templates.splice(t.position, 1)
            }, this),
            "changed.owl.carousel": t.proxy(function(t) {
                t.namespace && "position" == t.property.name && this.draw()
            }, this),
            "initialized.owl.carousel": t.proxy(function(t) {
                t.namespace && !this._initialized && (this._core.trigger("initialize", null, "navigation"), this.initialize(), this.update(), this.draw(), this._initialized = !0, this._core.trigger("initialized", null, "navigation"))
            }, this),
            "refreshed.owl.carousel": t.proxy(function(t) {
                t.namespace && this._initialized && (this._core.trigger("refresh", null, "navigation"), this.update(), this.draw(), this._core.trigger("refreshed", null, "navigation"))
            }, this)
        }, this._core.options = t.extend({}, o.Defaults, this._core.options), this.$element.on(this._handlers)
    };
    o.Defaults = {
        nav: !1,
        navText: ["prev", "next"],
        navSpeed: !1,
        navElement: "div",
        navContainer: !1,
        navContainerClass: "owl-nav",
        navClass: ["owl-prev", "owl-next"],
        slideBy: 1,
        dotClass: "owl-dot",
        dotsClass: "owl-dots",
        dots: !0,
        dotsEach: !1,
        dotsData: !1,
        dotsSpeed: !1,
        dotsContainer: !1
    }, o.prototype.initialize = function() {
        var e, n = this._core.settings;
        this._controls.$relative = (n.navContainer ? t(n.navContainer) : t("<div>").addClass(n.navContainerClass).appendTo(this.$element)).addClass("disabled"), this._controls.$previous = t("<" + n.navElement + ">").addClass(n.navClass[0]).html(n.navText[0]).prependTo(this._controls.$relative).on("click", t.proxy(function(t) {
            this.prev(n.navSpeed)
        }, this)), this._controls.$next = t("<" + n.navElement + ">").addClass(n.navClass[1]).html(n.navText[1]).appendTo(this._controls.$relative).on("click", t.proxy(function(t) {
            this.next(n.navSpeed)
        }, this)), n.dotsData || (this._templates = [t("<div>").addClass(n.dotClass).append(t("<span>")).prop("outerHTML")]), this._controls.$absolute = (n.dotsContainer ? t(n.dotsContainer) : t("<div>").addClass(n.dotsClass).appendTo(this.$element)).addClass("disabled"), this._controls.$absolute.on("click", "div", t.proxy(function(e) {
            var i = t(e.target).parent().is(this._controls.$absolute) ? t(e.target).index() : t(e.target).parent().index();
            e.preventDefault(), this.to(i, n.dotsSpeed)
        }, this));
        for (e in this._overrides) this._core[e] = t.proxy(this[e], this)
    }, o.prototype.destroy = function() {
        var t, e, n, i;
        for (t in this._handlers) this.$element.off(t, this._handlers[t]);
        for (e in this._controls) this._controls[e].remove();
        for (i in this.overides) this._core[i] = this._overrides[i];
        for (n in Object.getOwnPropertyNames(this)) "function" != typeof this[n] && (this[n] = null)
    }, o.prototype.update = function() {
        var t, e, n, i = this._core.clones().length / 2,
            o = i + this._core.items().length,
            s = this._core.maximum(!0),
            r = this._core.settings,
            a = r.center || r.autoWidth || r.dotsData ? 1 : r.dotsEach || r.items;
        if ("page" !== r.slideBy && (r.slideBy = Math.min(r.slideBy, r.items)), r.dots || "page" == r.slideBy)
            for (this._pages = [], t = i, e = 0, n = 0; t < o; t++) {
                if (e >= a || 0 === e) {
                    if (this._pages.push({
                            start: Math.min(s, t - i),
                            end: t - i + a - 1
                        }), Math.min(s, t - i) === s) break;
                    e = 0, ++n
                }
                e += this._core.mergers(this._core.relative(t))
            }
    }, o.prototype.draw = function() {
        var e, n = this._core.settings,
            i = this._core.items().length <= n.items,
            o = this._core.relative(this._core.current()),
            s = n.loop || n.rewind;
        this._controls.$relative.toggleClass("disabled", !n.nav || i), n.nav && (this._controls.$previous.toggleClass("disabled", !s && o <= this._core.minimum(!0)), this._controls.$next.toggleClass("disabled", !s && o >= this._core.maximum(!0))), this._controls.$absolute.toggleClass("disabled", !n.dots || i), n.dots && (e = this._pages.length - this._controls.$absolute.children().length, n.dotsData && 0 !== e ? this._controls.$absolute.html(this._templates.join("")) : e > 0 ? this._controls.$absolute.append(new Array(e + 1).join(this._templates[0])) : e < 0 && this._controls.$absolute.children().slice(e).remove(), this._controls.$absolute.find(".active").removeClass("active"), this._controls.$absolute.children().eq(t.inArray(this.current(), this._pages)).addClass("active"))
    }, o.prototype.onTrigger = function(e) {
        var n = this._core.settings;
        e.page = {
            index: t.inArray(this.current(), this._pages),
            count: this._pages.length,
            size: n && (n.center || n.autoWidth || n.dotsData ? 1 : n.dotsEach || n.items)
        }
    }, o.prototype.current = function() {
        var e = this._core.relative(this._core.current());
        return t.grep(this._pages, t.proxy(function(t, n) {
            return t.start <= e && t.end >= e
        }, this)).pop()
    }, o.prototype.getPosition = function(e) {
        var n, i, o = this._core.settings;
        return "page" == o.slideBy ? (n = t.inArray(this.current(), this._pages), i = this._pages.length, e ? ++n : --n, n = this._pages[(n % i + i) % i].start) : (n = this._core.relative(this._core.current()), i = this._core.items().length, e ? n += o.slideBy : n -= o.slideBy), n
    }, o.prototype.next = function(e) {
        t.proxy(this._overrides.to, this._core)(this.getPosition(!0), e)
    }, o.prototype.prev = function(e) {
        t.proxy(this._overrides.to, this._core)(this.getPosition(!1), e)
    }, o.prototype.to = function(e, n, i) {
        var o;
        !i && this._pages.length ? (o = this._pages.length, t.proxy(this._overrides.to, this._core)(this._pages[(e % o + o) % o].start, n)) : t.proxy(this._overrides.to, this._core)(e, n)
    }, t.fn.owlCarousel.Constructor.Plugins.Navigation = o
}(window.Zepto || window.jQuery, window, document),
function(t, e, n, i) {
    "use strict";
    var o = function(n) {
        this._core = n, this._hashes = {}, this.$element = this._core.$element, this._handlers = {
            "initialized.owl.carousel": t.proxy(function(n) {
                n.namespace && "URLHash" === this._core.settings.startPosition && t(e).trigger("hashchange.owl.navigation")
            }, this),
            "prepared.owl.carousel": t.proxy(function(e) {
                if (e.namespace) {
                    var n = t(e.content).find("[data-hash]").addBack("[data-hash]").attr("data-hash");
                    if (!n) return;
                    this._hashes[n] = e.content
                }
            }, this),
            "changed.owl.carousel": t.proxy(function(n) {
                if (n.namespace && "position" === n.property.name) {
                    var i = this._core.items(this._core.relative(this._core.current())),
                        o = t.map(this._hashes, function(t, e) {
                            return t === i ? e : null
                        }).join();
                    if (!o || e.location.hash.slice(1) === o) return;
                    e.location.hash = o
                }
            }, this)
        }, this._core.options = t.extend({}, o.Defaults, this._core.options), this.$element.on(this._handlers), t(e).on("hashchange.owl.navigation", t.proxy(function(t) {
            var n = e.location.hash.substring(1),
                o = this._core.$stage.children(),
                s = this._hashes[n] && o.index(this._hashes[n]);
            s !== i && s !== this._core.current() && this._core.to(this._core.relative(s), !1, !0)
        }, this))
    };
    o.Defaults = {
        URLhashListener: !1
    }, o.prototype.destroy = function() {
        var n, i;
        t(e).off("hashchange.owl.navigation");
        for (n in this._handlers) this._core.$element.off(n, this._handlers[n]);
        for (i in Object.getOwnPropertyNames(this)) "function" != typeof this[i] && (this[i] = null)
    }, t.fn.owlCarousel.Constructor.Plugins.Hash = o
}(window.Zepto || window.jQuery, window, document),
function(t, e, n, i) {
    function o(e, n) {
        var o = !1,
            s = e.charAt(0).toUpperCase() + e.slice(1);
        return t.each((e + " " + a.join(s + " ") + s).split(" "), function(t, e) {
            if (r[e] !== i) return o = !n || e, !1
        }), o
    }

    function s(t) {
        return o(t, !0)
    }
    var r = t("<support>").get(0).style,
        a = "Webkit Moz O ms".split(" "),
        l = {
            transition: {
                end: {
                    WebkitTransition: "webkitTransitionEnd",
                    MozTransition: "transitionend",
                    OTransition: "oTransitionEnd",
                    transition: "transitionend"
                }
            },
            animation: {
                end: {
                    WebkitAnimation: "webkitAnimationEnd",
                    MozAnimation: "animationend",
                    OAnimation: "oAnimationEnd",
                    animation: "animationend"
                }
            }
        },
        c = {
            csstransforms: function() {
                return !!o("transform")
            },
            csstransforms3d: function() {
                return !!o("perspective")
            },
            csstransitions: function() {
                return !!o("transition")
            },
            cssanimations: function() {
                return !!o("animation")
            }
        };
    c.csstransitions() && (t.support.transition = new String(s("transition")), t.support.transition.end = l.transition.end[t.support.transition]), c.cssanimations() && (t.support.animation = new String(s("animation")), t.support.animation.end = l.animation.end[t.support.animation]), c.csstransforms() && (t.support.transform = new String(s("transform")), t.support.transform3d = c.csstransforms3d())
}(window.Zepto || window.jQuery, window, document),
function() {
    for (var t = 0, e = ["ms", "moz", "webkit", "o"], n = 0; n < e.length && !window.requestAnimationFrame; ++n) window.requestAnimationFrame = window[e[n] + "RequestAnimationFrame"], window.cancelAnimationFrame = window[e[n] + "CancelAnimationFrame"] || window[e[n] + "CancelRequestAnimationFrame"];
    window.requestAnimationFrame || (window.requestAnimationFrame = function(e, n) {
        var i = (new Date).getTime(),
            o = Math.max(0, 16 - (i - t)),
            s = window.setTimeout(function() {
                e(i + o)
            }, o);
        return t = i + o, s
    }), window.cancelAnimationFrame || (window.cancelAnimationFrame = function(t) {
        clearTimeout(t)
    })
}(),
// Licensed GPLv3 for open source use
// or fancyBox Commercial License for commercial use
//
// http://fancyapps.com/fancybox/
// Copyright 2017 fancyApps
//
// ==================================================
! function(t, e, n, i) {
    "use strict";

    function o(t) {
        var e = t.currentTarget,
            i = t.data ? t.data.options : {},
            o = i.selector ? n(i.selector) : t.data ? t.data.items : [],
            s = n(e).attr("data-fancybox") || "",
            r = 0,
            a = n.fancybox.getInstance();
        t.preventDefault(), a && a.current.opts.$orig.is(e) || (s ? (o = o.length ? o.filter('[data-fancybox="' + s + '"]') : n('[data-fancybox="' + s + '"]'), r = o.index(e), r < 0 && (r = 0)) : o = [e], n.fancybox.open(o, i, r))
    }
    if (n) {
        if (n.fn.fancybox) return void n.error("fancyBox already initialized");
        var s = {
                loop: !1,
                margin: [44, 0],
                gutter: 50,
                keyboard: !0,
                arrows: !0,
                infobar: !1,
                toolbar: !0,
                buttons: ["slideShow", "fullScreen", "thumbs", "close"],
                idleTime: 4,
                smallBtn: "auto",
                protect: !1,
                modal: !1,
                image: {
                    preload: "auto"
                },
                ajax: {
                    settings: {
                        data: {
                            fancybox: !0
                        }
                    }
                },
                iframe: {
                    tpl: '<iframe id="fancybox-frame{rnd}" name="fancybox-frame{rnd}" class="fancybox-iframe" frameborder="0" vspace="0" hspace="0" webkitAllowFullScreen mozallowfullscreen allowFullScreen allowtransparency="true" src=""></iframe>',
                    preload: !0,
                    css: {},
                    attr: {
                        scrolling: "auto"
                    }
                },
                animationEffect: "zoom",
                animationDuration: 366,
                zoomOpacity: "auto",
                transitionEffect: "fade",
                transitionDuration: 366,
                slideClass: "",
                baseClass: "",
                baseTpl: '<div class="fancybox-container" role="dialog" tabindex="-1"><div class="fancybox-bg"></div><div class="fancybox-inner"><div class="fancybox-infobar"><button data-fancybox-prev title="" class="fancybox-button fancybox-button--left"></button><div class="fancybox-infobar__body"><span data-fancybox-index></span>&nbsp;/&nbsp;<span data-fancybox-count></span></div><button data-fancybox-next title="" class="fancybox-button fancybox-button--right"></button></div><div class="fancybox-toolbar"></div><div class="fancybox-navigation"><button data-fancybox-prev title="" class="fancybox-arrow fancybox-arrow--left" /><button data-fancybox-next title="" class="fancybox-arrow fancybox-arrow--right" /></div><div class="fancybox-stage"></div><div class="fancybox-caption-wrap"><div class="fancybox-caption"></div></div></div></div>',
                spinnerTpl: '<div class="fancybox-loading"></div>',
                errorTpl: '<div class="fancybox-error"><p><p></div>',
                btnTpl: {
                    slideShow: '<button data-fancybox-play class="fancybox-button fancybox-button--play" title=""></button>',
                    fullScreen: '<button data-fancybox-fullscreen class="fancybox-button fancybox-button--fullscreen" title=""></button>',
                    thumbs: '<button data-fancybox-thumbs class="fancybox-button fancybox-button--thumbs" title=""></button>',
                    close: '<button data-fancybox-close class="fancybox-button fancybox-button--close" title=""></button>',
                    smallBtn: '<button data-fancybox-close class="fancybox-close-small" title=""></button>'
                },
                parentEl: "body",
                autoFocus: !0,
                backFocus: !0,
                trapFocus: !0,
                fullScreen: {
                    autoStart: !1
                },
                touch: {
                    vertical: !0,
                    momentum: !0
                },
                hash: null,
                media: {},
                slideShow: {
                    autoStart: !1,
                    speed: 4e3
                },
                thumbs: {
                    autoStart: !1,
                    hideOnClose: !0
                },
                onInit: n.noop,
                beforeLoad: n.noop,
                afterLoad: n.noop,
                beforeShow: n.noop,
                afterShow: n.noop,
                beforeClose: n.noop,
                afterClose: n.noop,
                onActivate: n.noop,
                onDeactivate: n.noop,
                clickContent: function(t, e) {
                    return "image" === t.type && "zoom"
                },
                clickSlide: "close",
                clickOutside: "close",
                dblclickContent: !1,
                dblclickSlide: !1,
                dblclickOutside: !1,
                mobile: {
                    clickContent: function(t, e) {
                        return "image" === t.type && "toggleControls"
                    },
                    clickSlide: function(t, e) {
                        return "image" === t.type ? "toggleControls" : "close"
                    },
                    dblclickContent: function(t, e) {
                        return "image" === t.type && "zoom"
                    },
                    dblclickSlide: function(t, e) {
                        return "image" === t.type && "zoom"
                    }
                },
                lang: "en",
                i18n: {
                    en: {
                        CLOSE: "Close",
                        NEXT: "Next",
                        PREV: "Previous",
                        ERROR: "The requested content cannot be loaded. <br/> Please try again later.",
                        PLAY_START: "Start slideshow",
                        PLAY_STOP: "Pause slideshow",
                        FULL_SCREEN: "Full screen",
                        THUMBS: "Thumbnails"
                    },
                    de: {
                        CLOSE: "Schliessen",
                        NEXT: "Weiter",
                        PREV: "Zurück",
                        ERROR: "Die angeforderten Daten konnten nicht geladen werden. <br/> Bitte versuchen Sie es später nochmal.",
                        PLAY_START: "Diaschau starten",
                        PLAY_STOP: "Diaschau beenden",
                        FULL_SCREEN: "Vollbild",
                        THUMBS: "Vorschaubilder"
                    }
                }
            },
            r = n(t),
            a = n(e),
            l = 0,
            c = function(t) {
                return t && t.hasOwnProperty && t instanceof n
            },
            u = function() {
                return t.requestAnimationFrame || t.webkitRequestAnimationFrame || t.mozRequestAnimationFrame || t.oRequestAnimationFrame || function(e) {
                    return t.setTimeout(e, 1e3 / 60)
                }
            }(),
            h = function() {
                var t, n = e.createElement("fakeelement"),
                    o = {
                        transition: "transitionend",
                        OTransition: "oTransitionEnd",
                        MozTransition: "transitionend",
                        WebkitTransition: "webkitTransitionEnd"
                    };
                for (t in o)
                    if (n.style[t] !== i) return o[t]
            }(),
            d = function(t) {
                return t && t.length && t[0].offsetHeight
            },
            p = function(t, i, o) {
                var r = this;
                r.opts = n.extend(!0, {
                    index: o
                }, s, i || {}), i && n.isArray(i.buttons) && (r.opts.buttons = i.buttons), r.id = r.opts.id || ++l, r.group = [], r.currIndex = parseInt(r.opts.index, 10) || 0, r.prevIndex = null, r.prevPos = null, r.currPos = 0, r.firstRun = null, r.createGroup(t), r.group.length && (r.$lastFocus = n(e.activeElement).blur(), r.slides = {}, r.init(t))
            };
        n.extend(p.prototype, {
            init: function() {
                var t, e, i, o = this,
                    s = o.group[o.currIndex].opts;
                o.scrollTop = a.scrollTop(), o.scrollLeft = a.scrollLeft(), n.fancybox.getInstance() || n.fancybox.isMobile || "hidden" === n("body").css("overflow") || (t = n("body").width(), n("html").addClass("fancybox-enabled"), t = n("body").width() - t, t > 1 && n("head").append('<style id="fancybox-style-noscroll" type="text/css">.compensate-for-scrollbar, .fancybox-enabled body { margin-right: ' + t + "px; }</style>")), i = "", n.each(s.buttons, function(t, e) {
                    i += s.btnTpl[e] || ""
                }), e = n(o.translate(o, s.baseTpl.replace("", i))).addClass("fancybox-is-hidden").attr("id", "fancybox-container-" + o.id).addClass(s.baseClass).data("FancyBox", o).prependTo(s.parentEl), o.$refs = {
                    container: e
                }, ["bg", "inner", "infobar", "toolbar", "stage", "caption"].forEach(function(t) {
                    o.$refs[t] = e.find(".fancybox-" + t)
                }), (!s.arrows || o.group.length < 2) && e.find(".fancybox-navigation").remove(), s.infobar || o.$refs.infobar.remove(), s.toolbar || o.$refs.toolbar.remove(), o.trigger("onInit"), o.activate(), o.jumpTo(o.currIndex)
            },
            translate: function(t, e) {
                var n = t.opts.i18n[t.opts.lang];
                return e.replace(/\{\{(\w+)\}\}/g, function(t, e) {
                    var o = n[e];
                    return o === i ? t : o
                })
            },
            createGroup: function(t) {
                var e = this,
                    o = n.makeArray(t);
                n.each(o, function(t, o) {
                    var s, r, a, l, c = {},
                        u = {},
                        h = [];
                    n.isPlainObject(o) ? (c = o, u = o.opts || o) : "object" === n.type(o) && n(o).length ? (s = n(o), h = s.data(), u = "options" in h ? h.options : {}, u = "object" === n.type(u) ? u : {}, c.src = "src" in h ? h.src : u.src || s.attr("href"), ["width", "height", "thumb", "type", "filter"].forEach(function(t) {
                        t in h && (u[t] = h[t])
                    }), "srcset" in h && (u.image = {
                        srcset: h.srcset
                    }), u.$orig = s, c.type || c.src || (c.type = "inline", c.src = o)) : c = {
                        type: "html",
                        src: o + ""
                    }, c.opts = n.extend(!0, {}, e.opts, u), n.fancybox.isMobile && (c.opts = n.extend(!0, {}, c.opts, c.opts.mobile)), r = c.type || c.opts.type, a = c.src || "", !r && a && (a.match(/(^data:image\/[a-z0-9+\/=]*,)|(\.(jp(e|g|eg)|gif|png|bmp|webp|svg|ico)((\?|#).*)?$)/i) ? r = "image" : a.match(/\.(pdf)((\?|#).*)?$/i) ? r = "pdf" : "#" === a.charAt(0) && (r = "inline")), c.type = r, c.index = e.group.length, c.opts.$orig && !c.opts.$orig.length && delete c.opts.$orig, !c.opts.$thumb && c.opts.$orig && (c.opts.$thumb = c.opts.$orig.find("img:first")), c.opts.$thumb && !c.opts.$thumb.length && delete c.opts.$thumb, "function" === n.type(c.opts.caption) ? c.opts.caption = c.opts.caption.apply(o, [e, c]) : "caption" in h && (c.opts.caption = h.caption), c.opts.caption = c.opts.caption === i ? "" : c.opts.caption + "", "ajax" === r && (l = a.split(/\s+/, 2), l.length > 1 && (c.src = l.shift(), c.opts.filter = l.shift())), "auto" == c.opts.smallBtn && (n.inArray(r, ["html", "inline", "ajax"]) > -1 ? (c.opts.toolbar = !1, c.opts.smallBtn = !0) : c.opts.smallBtn = !1), "pdf" === r && (c.type = "iframe", c.opts.iframe.preload = !1), c.opts.modal && (c.opts = n.extend(!0, c.opts, {
                        infobar: 0,
                        toolbar: 0,
                        smallBtn: 0,
                        keyboard: 0,
                        slideShow: 0,
                        fullScreen: 0,
                        thumbs: 0,
                        touch: 0,
                        clickContent: !1,
                        clickSlide: !1,
                        clickOutside: !1,
                        dblclickContent: !1,
                        dblclickSlide: !1,
                        dblclickOutside: !1
                    })), e.group.push(c)
                })
            },
            addEvents: function() {
                var i = this;
                i.removeEvents(), i.$refs.container.on("click.fb-close", "[data-fancybox-close]", function(t) {
                    t.stopPropagation(), t.preventDefault(), i.close(t)
                }).on("click.fb-prev touchend.fb-prev", "[data-fancybox-prev]", function(t) {
                    t.stopPropagation(), t.preventDefault(), i.previous()
                }).on("click.fb-next touchend.fb-next", "[data-fancybox-next]", function(t) {
                    t.stopPropagation(), t.preventDefault(), i.next()
                }), r.on("orientationchange.fb resize.fb", function(t) {
                    t && t.originalEvent && "resize" === t.originalEvent.type ? u(function() {
                        i.update()
                    }) : (i.$refs.stage.hide(), setTimeout(function() {
                        i.$refs.stage.show(), i.update()
                    }, 500))
                }), a.on("focusin.fb", function(t) {
                    var o = n.fancybox ? n.fancybox.getInstance() : null;
                    o.isClosing || !o.current || !o.current.opts.trapFocus || n(t.target).hasClass("fancybox-container") || n(t.target).is(e) || o && "fixed" !== n(t.target).css("position") && !o.$refs.container.has(t.target).length && (t.stopPropagation(), o.focus(), r.scrollTop(i.scrollTop).scrollLeft(i.scrollLeft))
                }), a.on("keydown.fb", function(t) {
                    var e = i.current,
                        o = t.keyCode || t.which;
                    if (e && e.opts.keyboard && !n(t.target).is("input") && !n(t.target).is("textarea")) return 8 === o || 27 === o ? (t.preventDefault(), void i.close(t)) : 37 === o || 38 === o ? (t.preventDefault(), void i.previous()) : 39 === o || 40 === o ? (t.preventDefault(), void i.next()) : void i.trigger("afterKeydown", t, o)
                }), i.group[i.currIndex].opts.idleTime && (i.idleSecondsCounter = 0, a.on("mousemove.fb-idle mouseenter.fb-idle mouseleave.fb-idle mousedown.fb-idle touchstart.fb-idle touchmove.fb-idle scroll.fb-idle keydown.fb-idle", function() {
                    i.idleSecondsCounter = 0, i.isIdle && i.showControls(), i.isIdle = !1
                }), i.idleInterval = t.setInterval(function() {
                    i.idleSecondsCounter++, i.idleSecondsCounter >= i.group[i.currIndex].opts.idleTime && (i.isIdle = !0, i.idleSecondsCounter = 0, i.hideControls())
                }, 1e3))
            },
            removeEvents: function() {
                var e = this;
                r.off("orientationchange.fb resize.fb"), a.off("focusin.fb keydown.fb .fb-idle"), this.$refs.container.off(".fb-close .fb-prev .fb-next"), e.idleInterval && (t.clearInterval(e.idleInterval), e.idleInterval = null)
            },
            previous: function(t) {
                return this.jumpTo(this.currPos - 1, t)
            },
            next: function(t) {
                return this.jumpTo(this.currPos + 1, t)
            },
            jumpTo: function(t, e, o) {
                var s, r, a, l, c, u, h, p = this,
                    f = p.group.length;
                if (!(p.isSliding || p.isClosing || p.isAnimating && p.firstRun)) {
                    if (t = parseInt(t, 10), r = p.current ? p.current.opts.loop : p.opts.loop, !r && (t < 0 || t >= f)) return !1;
                    if (s = p.firstRun = null === p.firstRun, !(f < 2 && !s && p.isSliding)) {
                        if (l = p.current, p.prevIndex = p.currIndex, p.prevPos = p.currPos, a = p.createSlide(t), f > 1 && ((r || a.index > 0) && p.createSlide(t - 1), (r || a.index < f - 1) && p.createSlide(t + 1)), p.current = a, p.currIndex = a.index, p.currPos = a.pos, p.trigger("beforeShow", s), p.updateControls(), u = n.fancybox.getTranslate(a.$slide), a.isMoved = (0 !== u.left || 0 !== u.top) && !a.$slide.hasClass("fancybox-animated"), a.forcedDuration = i, n.isNumeric(e) ? a.forcedDuration = e : e = a.opts[s ? "animationDuration" : "transitionDuration"], e = parseInt(e, 10), s) return a.opts.animationEffect && e && p.$refs.container.css("transition-duration", e + "ms"), p.$refs.container.removeClass("fancybox-is-hidden"), d(p.$refs.container), p.$refs.container.addClass("fancybox-is-open"), a.$slide.addClass("fancybox-slide--current"), p.loadSlide(a), void p.preload();
                        n.each(p.slides, function(t, e) {
                            n.fancybox.stop(e.$slide)
                        }), a.$slide.removeClass("fancybox-slide--next fancybox-slide--previous").addClass("fancybox-slide--current"), a.isMoved ? (c = Math.round(a.$slide.width()), n.each(p.slides, function(t, i) {
                            var o = i.pos - a.pos;
                            n.fancybox.animate(i.$slide, {
                                top: 0,
                                left: o * c + o * i.opts.gutter
                            }, e, function() {
                                i.$slide.removeAttr("style").removeClass("fancybox-slide--next fancybox-slide--previous"), i.pos === p.currPos && (a.isMoved = !1, p.complete())
                            })
                        })) : p.$refs.stage.children().removeAttr("style"), a.isLoaded ? p.revealContent(a) : p.loadSlide(a), p.preload(), l.pos !== a.pos && (h = "fancybox-slide--" + (l.pos > a.pos ? "next" : "previous"), l.$slide.removeClass("fancybox-slide--complete fancybox-slide--current fancybox-slide--next fancybox-slide--previous"), l.isComplete = !1, e && (a.isMoved || a.opts.transitionEffect) && (a.isMoved ? l.$slide.addClass(h) : (h = "fancybox-animated " + h + " fancybox-fx-" + a.opts.transitionEffect, n.fancybox.animate(l.$slide, h, e, function() {
                            l.$slide.removeClass(h).removeAttr("style")
                        }))))
                    }
                }
            },
            createSlide: function(t) {
                var e, i, o = this;
                return i = t % o.group.length, i = i < 0 ? o.group.length + i : i, !o.slides[t] && o.group[i] && (e = n('<div class="fancybox-slide"></div>').appendTo(o.$refs.stage), o.slides[t] = n.extend(!0, {}, o.group[i], {
                    pos: t,
                    $slide: e,
                    isLoaded: !1
                }), o.updateSlide(o.slides[t])), o.slides[t]
            },
            scaleToActual: function(t, e, o) {
                var s, r, a, l, c, u = this,
                    h = u.current,
                    d = h.$content,
                    p = parseInt(h.$slide.width(), 10),
                    f = parseInt(h.$slide.height(), 10),
                    g = h.width,
                    m = h.height;
                "image" != h.type || h.hasError || !d || u.isAnimating || (n.fancybox.stop(d), u.isAnimating = !0, t = t === i ? .5 * p : t, e = e === i ? .5 * f : e, s = n.fancybox.getTranslate(d), l = g / s.width, c = m / s.height, r = .5 * p - .5 * g, a = .5 * f - .5 * m, g > p && (r = s.left * l - (t * l - t), r > 0 && (r = 0), r < p - g && (r = p - g)), m > f && (a = s.top * c - (e * c - e), a > 0 && (a = 0), a < f - m && (a = f - m)), u.updateCursor(g, m), n.fancybox.animate(d, {
                    top: a,
                    left: r,
                    scaleX: l,
                    scaleY: c
                }, o || 330, function() {
                    u.isAnimating = !1
                }), u.SlideShow && u.SlideShow.isActive && u.SlideShow.stop())
            },
            scaleToFit: function(t) {
                var e, i = this,
                    o = i.current,
                    s = o.$content;
                "image" != o.type || o.hasError || !s || i.isAnimating || (n.fancybox.stop(s), i.isAnimating = !0, e = i.getFitPos(o), i.updateCursor(e.width, e.height), n.fancybox.animate(s, {
                    top: e.top,
                    left: e.left,
                    scaleX: e.width / s.width(),
                    scaleY: e.height / s.height()
                }, t || 330, function() {
                    i.isAnimating = !1
                }))
            },
            getFitPos: function(t) {
                var e, i, o, s, a, l = this,
                    c = t.$content,
                    u = t.width,
                    h = t.height,
                    d = t.opts.margin;
                return !(!c || !c.length || !u && !h) && ("number" === n.type(d) && (d = [d, d]), 2 == d.length && (d = [d[0], d[1], d[0], d[1]]), r.width() < 800 && (d = [0, 0, 0, 0]), e = parseInt(l.$refs.stage.width(), 10) - (d[1] + d[3]), i = parseInt(l.$refs.stage.height(), 10) - (d[0] + d[2]), o = Math.min(1, e / u, i / h), s = Math.floor(o * u), a = Math.floor(o * h), {
                    top: Math.floor(.5 * (i - a)) + d[0],
                    left: Math.floor(.5 * (e - s)) + d[3],
                    width: s,
                    height: a
                })
            },
            update: function() {
                var t = this;
                n.each(t.slides, function(e, n) {
                    t.updateSlide(n)
                })
            },
            updateSlide: function(t) {
                var e = this,
                    i = t.$content;
                i && (t.width || t.height) && (n.fancybox.stop(i), n.fancybox.setTranslate(i, e.getFitPos(t)), t.pos === e.currPos && e.updateCursor()), t.$slide.trigger("refresh"), e.trigger("onUpdate", t)
            },
            updateCursor: function(t, e) {
                var n, o = this,
                    s = o.$refs.container.removeClass("fancybox-is-zoomable fancybox-can-zoomIn fancybox-can-drag fancybox-can-zoomOut");
                o.current && !o.isClosing && (o.isZoomable() ? (s.addClass("fancybox-is-zoomable"), n = t !== i && e !== i ? t < o.current.width && e < o.current.height : o.isScaledDown(), n ? s.addClass("fancybox-can-zoomIn") : o.current.opts.touch ? s.addClass("fancybox-can-drag") : s.addClass("fancybox-can-zoomOut")) : o.current.opts.touch && s.addClass("fancybox-can-drag"))
            },
            isZoomable: function() {
                var t, e = this,
                    i = e.current;
                if (i && !e.isClosing) return !!("image" === i.type && i.isLoaded && !i.hasError && ("zoom" === i.opts.clickContent || n.isFunction(i.opts.clickContent) && "zoom" === i.opts.clickContent(i)) && (t = e.getFitPos(i), i.width > t.width || i.height > t.height))
            },
            isScaledDown: function() {
                var t = this,
                    e = t.current,
                    i = e.$content,
                    o = !1;
                return i && (o = n.fancybox.getTranslate(i), o = o.width < e.width || o.height < e.height), o
            },
            canPan: function() {
                var t = this,
                    e = t.current,
                    n = e.$content,
                    i = !1;
                return n && (i = t.getFitPos(e), i = Math.abs(n.width() - i.width) > 1 || Math.abs(n.height() - i.height) > 1), i
            },
            loadSlide: function(t) {
                var e, i, o, s = this;
                if (!t.isLoading && !t.isLoaded) {
                    switch (t.isLoading = !0, s.trigger("beforeLoad", t), e = t.type, i = t.$slide, i.off("refresh").trigger("onReset").addClass("fancybox-slide--" + (e || "unknown")).addClass(t.opts.slideClass), e) {
                        case "image":
                            s.setImage(t);
                            break;
                        case "iframe":
                            s.setIframe(t);
                            break;
                        case "html":
                            s.setContent(t, t.src || t.content);
                            break;
                        case "inline":
                            n(t.src).length ? s.setContent(t, n(t.src)) : s.setError(t);
                            break;
                        case "ajax":
                            s.showLoading(t), o = n.ajax(n.extend({}, t.opts.ajax.settings, {
                                url: t.src,
                                success: function(e, n) {
                                    "success" === n && s.setContent(t, e)
                                },
                                error: function(e, n) {
                                    e && "abort" !== n && s.setError(t)
                                }
                            })), i.one("onReset", function() {
                                o.abort()
                            });
                            break;
                        default:
                            s.setError(t)
                    }
                    return !0
                }
            },
            setImage: function(e) {
                var i, o, s, r, a = this,
                    l = e.opts.image.srcset;
                if (l) {
                    s = t.devicePixelRatio || 1, r = t.innerWidth * s, o = l.split(",").map(function(t) {
                        var e = {};
                        return t.trim().split(/\s+/).forEach(function(t, n) {
                            var i = parseInt(t.substring(0, t.length - 1), 10);
                            return 0 === n ? e.url = t : void(i && (e.value = i, e.postfix = t[t.length - 1]))
                        }), e
                    }), o.sort(function(t, e) {
                        return t.value - e.value
                    });
                    for (var c = 0; c < o.length; c++) {
                        var u = o[c];
                        if ("w" === u.postfix && u.value >= r || "x" === u.postfix && u.value >= s) {
                            i = u;
                            break
                        }
                    }!i && o.length && (i = o[o.length - 1]), i && (e.src = i.url, e.width && e.height && "w" == i.postfix && (e.height = e.width / e.height * i.value, e.width = i.value))
                }
                e.$content = n('<div class="fancybox-image-wrap"></div>').addClass("fancybox-is-hidden").appendTo(e.$slide), e.opts.preload !== !1 && e.opts.width && e.opts.height && (e.opts.thumb || e.opts.$thumb) ? (e.width = e.opts.width, e.height = e.opts.height, e.$ghost = n("<img />").one("error", function() {
                    n(this).remove(), e.$ghost = null, a.setBigImage(e)
                }).one("load", function() {
                    a.afterLoad(e), a.setBigImage(e)
                }).addClass("fancybox-image").appendTo(e.$content).attr("src", e.opts.thumb || e.opts.$thumb.attr("src"))) : a.setBigImage(e)
            },
            setBigImage: function(t) {
                var e = this,
                    i = n("<img />");
                t.$image = i.one("error", function() {
                    e.setError(t)
                }).one("load", function() {
                    clearTimeout(t.timouts), t.timouts = null, e.isClosing || (t.width = this.naturalWidth, t.height = this.naturalHeight, t.opts.image.srcset && i.attr("sizes", "100vw").attr("srcset", t.opts.image.srcset), e.hideLoading(t), t.$ghost ? t.timouts = setTimeout(function() {
                        t.timouts = null, t.$ghost.hide()
                    }, Math.min(300, Math.max(1e3, t.height / 1600))) : e.afterLoad(t))
                }).addClass("fancybox-image").attr("src", t.src).appendTo(t.$content), (i[0].complete || "complete" == i[0].readyState) && i[0].naturalWidth && i[0].naturalHeight ? i.trigger("load") : i[0].error ? i.trigger("error") : t.timouts = setTimeout(function() {
                    i[0].complete || t.hasError || e.showLoading(t)
                }, 100)
            },
            setIframe: function(t) {
                var e, o = this,
                    s = t.opts.iframe,
                    r = t.$slide;
                t.$content = n('<div class="fancybox-content' + (s.preload ? " fancybox-is-hidden" : "") + '"></div>').css(s.css).appendTo(r), e = n(s.tpl.replace(/\{rnd\}/g, (new Date).getTime())).attr(s.attr).appendTo(t.$content), s.preload ? (o.showLoading(t), e.on("load.fb error.fb", function(e) {
                    this.isReady = 1, t.$slide.trigger("refresh"), o.afterLoad(t)
                }), r.on("refresh.fb", function() {
                    var n, o, r, a = t.$content,
                        l = s.css.width,
                        c = s.css.height;
                    if (1 === e[0].isReady) {
                        try {
                            o = e.contents(), r = o.find("body")
                        } catch (t) {}
                        r && r.length && (l === i && (n = e[0].contentWindow.document.documentElement.scrollWidth, l = Math.ceil(r.outerWidth(!0) + (a.width() - n)), l += a.outerWidth() - a.innerWidth()), c === i && (c = Math.ceil(r.outerHeight(!0)), c += a.outerHeight() - a.innerHeight()), l && a.width(l), c && a.height(c)), a.removeClass("fancybox-is-hidden")
                    }
                })) : this.afterLoad(t), e.attr("src", t.src), t.opts.smallBtn === !0 && t.$content.prepend(o.translate(t, t.opts.btnTpl.smallBtn)), r.one("onReset", function() {
                    try {
                        n(this).find("iframe").hide().attr("src", "//about:blank")
                    } catch (t) {}
                    n(this).empty(), t.isLoaded = !1
                })
            },
            setContent: function(t, e) {
                var i = this;
                i.isClosing || (i.hideLoading(t), t.$slide.empty(), c(e) && e.parent().length ? (e.parent(".fancybox-slide--inline").trigger("onReset"), t.$placeholder = n("<div></div>").hide().insertAfter(e), e.css("display", "inline-block")) : t.hasError || ("string" === n.type(e) && (e = n("<div>").append(n.trim(e)).contents(), 3 === e[0].nodeType && (e = n("<div>").html(e))), t.opts.filter && (e = n("<div>").html(e).find(t.opts.filter))), t.$slide.one("onReset", function() {
                    t.$placeholder && (t.$placeholder.after(e.hide()).remove(), t.$placeholder = null), t.$smallBtn && (t.$smallBtn.remove(), t.$smallBtn = null), t.hasError || (n(this).empty(), t.isLoaded = !1)
                }), t.$content = n(e).appendTo(t.$slide), t.opts.smallBtn && !t.$smallBtn && (t.$smallBtn = n(i.translate(t, t.opts.btnTpl.smallBtn)).appendTo(t.$content.filter("div").first())), this.afterLoad(t))
            },
            setError: function(t) {
                t.hasError = !0, t.$slide.removeClass("fancybox-slide--" + t.type), this.setContent(t, this.translate(t, t.opts.errorTpl))
            },
            showLoading: function(t) {
                var e = this;
                t = t || e.current, t && !t.$spinner && (t.$spinner = n(e.opts.spinnerTpl).appendTo(t.$slide))
            },
            hideLoading: function(t) {
                var e = this;
                t = t || e.current, t && t.$spinner && (t.$spinner.remove(), delete t.$spinner)
            },
            afterLoad: function(t) {
                var e = this;
                e.isClosing || (t.isLoading = !1, t.isLoaded = !0, e.trigger("afterLoad", t), e.hideLoading(t), t.opts.protect && t.$content && !t.hasError && (t.$content.on("contextmenu.fb", function(t) {
                    return 2 == t.button && t.preventDefault(), !0
                }), "image" === t.type && n('<div class="fancybox-spaceball"></div>').appendTo(t.$content)), e.revealContent(t))
            },
            revealContent: function(t) {
                var e, o, s, r, a, l = this,
                    c = t.$slide,
                    u = !1;
                return e = t.opts[l.firstRun ? "animationEffect" : "transitionEffect"], s = t.opts[l.firstRun ? "animationDuration" : "transitionDuration"], s = parseInt(t.forcedDuration === i ? s : t.forcedDuration, 10), !t.isMoved && t.pos === l.currPos && s || (e = !1), "zoom" !== e || t.pos === l.currPos && s && "image" === t.type && !t.hasError && (u = l.getThumbPos(t)) || (e = "fade"), "zoom" === e ? (a = l.getFitPos(t), a.scaleX = a.width / u.width, a.scaleY = a.height / u.height, delete a.width, delete a.height, r = t.opts.zoomOpacity, "auto" == r && (r = Math.abs(t.width / t.height - u.width / u.height) > .1), r && (u.opacity = .1, a.opacity = 1), n.fancybox.setTranslate(t.$content.removeClass("fancybox-is-hidden"), u), d(t.$content), void n.fancybox.animate(t.$content, a, s, function() {
                    l.complete()
                })) : (l.updateSlide(t), e ? (n.fancybox.stop(c), o = "fancybox-animated fancybox-slide--" + (t.pos > l.prevPos ? "next" : "previous") + " fancybox-fx-" + e, c.removeAttr("style").removeClass("fancybox-slide--current fancybox-slide--next fancybox-slide--previous").addClass(o), t.$content.removeClass("fancybox-is-hidden"), d(c), void n.fancybox.animate(c, "fancybox-slide--current", s, function(e) {
                    c.removeClass(o).removeAttr("style"), t.pos === l.currPos && l.complete()
                }, !0)) : (d(c), t.$content.removeClass("fancybox-is-hidden"), void(t.pos === l.currPos && l.complete())))
            },
            getThumbPos: function(i) {
                var o, s = this,
                    r = !1,
                    a = function(e) {
                        for (var i, o = e[0], s = o.getBoundingClientRect(), r = []; null !== o.parentElement;) "hidden" !== n(o.parentElement).css("overflow") && "auto" !== n(o.parentElement).css("overflow") || r.push(o.parentElement.getBoundingClientRect()), o = o.parentElement;
                        return i = r.every(function(t) {
                            var e = Math.min(s.right, t.right) - Math.max(s.left, t.left),
                                n = Math.min(s.bottom, t.bottom) - Math.max(s.top, t.top);
                            return e > 0 && n > 0
                        }), i && s.bottom > 0 && s.right > 0 && s.left < n(t).width() && s.top < n(t).height()
                    },
                    l = i.opts.$thumb,
                    c = l ? l.offset() : 0;
                return c && l[0].ownerDocument === e && a(l) && (o = s.$refs.stage.offset(), r = {
                    top: c.top - o.top + parseFloat(l.css("border-top-width") || 0),
                    left: c.left - o.left + parseFloat(l.css("border-left-width") || 0),
                    width: l.width(),
                    height: l.height(),
                    scaleX: 1,
                    scaleY: 1
                }), r
            },
            complete: function() {
                var t = this,
                    i = t.current,
                    o = {};
                i.isMoved || !i.isLoaded || i.isComplete || (i.isComplete = !0, i.$slide.siblings().trigger("onReset"), d(i.$slide), i.$slide.addClass("fancybox-slide--complete"), n.each(t.slides, function(e, i) {
                    i.pos >= t.currPos - 1 && i.pos <= t.currPos + 1 ? o[i.pos] = i : i && (n.fancybox.stop(i.$slide), i.$slide.off().remove())
                }), t.slides = o, t.updateCursor(), t.trigger("afterShow"), (n(e.activeElement).is("[disabled]") || i.opts.autoFocus && "image" != i.type && "iframe" !== i.type) && t.focus())
            },
            preload: function() {
                var t, e, n = this;
                n.group.length < 2 || (t = n.slides[n.currPos + 1], e = n.slides[n.currPos - 1], t && "image" === t.type && n.loadSlide(t), e && "image" === e.type && n.loadSlide(e))
            },
            focus: function() {
                var t, e = this.current;
                this.isClosing || (e && e.isComplete && (t = e.$slide.find("input[autofocus]:enabled:visible:first"), t.length || (t = e.$slide.find("button,:input,[tabindex],a").filter(":enabled:visible:first"))), t = t && t.length ? t : this.$refs.container, t.focus())
            },
            activate: function() {
                var t = this;
                n(".fancybox-container").each(function() {
                    var e = n(this).data("FancyBox");
                    e && e.uid !== t.uid && !e.isClosing && e.trigger("onDeactivate")
                }), t.current && (t.$refs.container.index() > 0 && t.$refs.container.prependTo(e.body), t.updateControls()), t.trigger("onActivate"), t.addEvents()
            },
            close: function(t, e) {
                var i, o, s, r, a, l, c = this,
                    d = c.current,
                    p = function() {
                        c.cleanUp(t)
                    };
                return !(c.isClosing || (c.isClosing = !0, c.trigger("beforeClose", t) === !1 ? (c.isClosing = !1, u(function() {
                    c.update()
                }), 1) : (c.removeEvents(), d.timouts && clearTimeout(d.timouts), s = d.$content, i = d.opts.animationEffect, o = n.isNumeric(e) ? e : i ? d.opts.animationDuration : 0, d.$slide.off(h).removeClass("fancybox-slide--complete fancybox-slide--next fancybox-slide--previous fancybox-animated"), d.$slide.siblings().trigger("onReset").remove(), o && c.$refs.container.removeClass("fancybox-is-open").addClass("fancybox-is-closing"), c.hideLoading(d), c.hideControls(), c.updateCursor(), "zoom" !== i || t !== !0 && s && o && "image" === d.type && !d.hasError && (l = c.getThumbPos(d)) || (i = "fade"), "zoom" === i ? (n.fancybox.stop(s), a = n.fancybox.getTranslate(s), a.width = a.width * a.scaleX, a.height = a.height * a.scaleY, r = d.opts.zoomOpacity, "auto" == r && (r = Math.abs(d.width / d.height - l.width / l.height) > .1), r && (l.opacity = 0), a.scaleX = a.width / l.width, a.scaleY = a.height / l.height, a.width = l.width, a.height = l.height, n.fancybox.setTranslate(d.$content, a), n.fancybox.animate(d.$content, l, o, p), 0) : (i && o ? t === !0 ? setTimeout(p, o) : n.fancybox.animate(d.$slide.removeClass("fancybox-slide--current"), "fancybox-animated fancybox-slide--previous fancybox-fx-" + i, o, p) : p(), 0))))
            },
            cleanUp: function(t) {
                var e, i = this;
                i.current.$slide.trigger("onReset"), i.$refs.container.empty().remove(), i.trigger("afterClose", t), i.$lastFocus && i.current.opts.backFocus && i.$lastFocus.focus(), i.current = null, e = n.fancybox.getInstance(), e ? e.activate() : (r.scrollTop(i.scrollTop).scrollLeft(i.scrollLeft), n("html").removeClass("fancybox-enabled"), n("#fancybox-style-noscroll").remove())
            },
            trigger: function(t, e) {
                var i, o = Array.prototype.slice.call(arguments, 1),
                    s = this,
                    r = e && e.opts ? e : s.current;
                return r ? o.unshift(r) : r = s, o.unshift(s), n.isFunction(r.opts[t]) && (i = r.opts[t].apply(r, o)), i === !1 ? i : void("afterClose" === t ? a.trigger(t + ".fb", o) : s.$refs.container.trigger(t + ".fb", o))
            },
            updateControls: function(t) {
                var e = this,
                    i = e.current,
                    o = i.index,
                    s = i.opts,
                    r = s.caption,
                    a = e.$refs.caption;
                i.$slide.trigger("refresh"), e.$caption = r && r.length ? a.html(r) : null, e.isHiddenControls || e.showControls(), n("[data-fancybox-count]").html(e.group.length), n("[data-fancybox-index]").html(o + 1), n("[data-fancybox-prev]").prop("disabled", !s.loop && o <= 0), n("[data-fancybox-next]").prop("disabled", !s.loop && o >= e.group.length - 1)
            },
            hideControls: function() {
                this.isHiddenControls = !0, this.$refs.container.removeClass("fancybox-show-infobar fancybox-show-toolbar fancybox-show-caption fancybox-show-nav")
            },
            showControls: function() {
                var t = this,
                    e = t.current ? t.current.opts : t.opts,
                    n = t.$refs.container;
                t.isHiddenControls = !1, t.idleSecondsCounter = 0, n.toggleClass("fancybox-show-toolbar", !(!e.toolbar || !e.buttons)).toggleClass("fancybox-show-infobar", !!(e.infobar && t.group.length > 1)).toggleClass("fancybox-show-nav", !!(e.arrows && t.group.length > 1)).toggleClass("fancybox-is-modal", !!e.modal), t.$caption ? n.addClass("fancybox-show-caption ") : n.removeClass("fancybox-show-caption")
            },
            toggleControls: function() {
                this.isHiddenControls ? this.showControls() : this.hideControls()
            }
        }), n.fancybox = {
            version: "3.1.28",
            defaults: s,
            getInstance: function(t) {
                var e = n('.fancybox-container:not(".fancybox-is-closing"):first').data("FancyBox"),
                    i = Array.prototype.slice.call(arguments, 1);
                return e instanceof p && ("string" === n.type(t) ? e[t].apply(e, i) : "function" === n.type(t) && t.apply(e, i), e)
            },
            open: function(t, e, n) {
                return new p(t, e, n)
            },
            close: function(t) {
                var e = this.getInstance();
                e && (e.close(), t === !0 && this.close())
            },
            destroy: function() {
                this.close(!0), a.off("click.fb-start")
            },
            isMobile: e.createTouch !== i && /Android|webOS|iPhone|iPad|iPod|BlackBerry/i.test(navigator.userAgent),
            use3d: function() {
                var n = e.createElement("div");
                return t.getComputedStyle && t.getComputedStyle(n).getPropertyValue("transform") && !(e.documentMode && e.documentMode < 11)
            }(),
            getTranslate: function(t) {
                var e;
                if (!t || !t.length) return !1;
                if (e = t.eq(0).css("transform"), e && e.indexOf("matrix") !== -1 ? (e = e.split("(")[1], e = e.split(")")[0], e = e.split(",")) : e = [], e.length) e = e.length > 10 ? [e[13], e[12], e[0], e[5]] : [e[5], e[4], e[0], e[3]], e = e.map(parseFloat);
                else {
                    e = [0, 0, 1, 1];
                    var n = /\.*translate\((.*)px,(.*)px\)/i,
                        i = n.exec(t.eq(0).attr("style"));
                    i && (e[0] = parseFloat(i[2]), e[1] = parseFloat(i[1]))
                }
                return {
                    top: e[0],
                    left: e[1],
                    scaleX: e[2],
                    scaleY: e[3],
                    opacity: parseFloat(t.css("opacity")),
                    width: t.width(),
                    height: t.height()
                }
            },
            setTranslate: function(t, e) {
                var n = "",
                    o = {};
                if (t && e) return e.left === i && e.top === i || (n = (e.left === i ? t.position().left : e.left) + "px, " + (e.top === i ? t.position().top : e.top) + "px", n = this.use3d ? "translate3d(" + n + ", 0px)" : "translate(" + n + ")"), e.scaleX !== i && e.scaleY !== i && (n = (n.length ? n + " " : "") + "scale(" + e.scaleX + ", " + e.scaleY + ")"), n.length && (o.transform = n), e.opacity !== i && (o.opacity = e.opacity), e.width !== i && (o.width = e.width), e.height !== i && (o.height = e.height), t.css(o)
            },
            animate: function(t, e, o, s, r) {
                var a = h || "transitionend";
                n.isFunction(o) && (s = o, o = null), n.isPlainObject(e) || t.removeAttr("style"), t.on(a, function(o) {
                    (!o || !o.originalEvent || t.is(o.originalEvent.target) && "z-index" != o.originalEvent.propertyName) && (t.off(a), n.isPlainObject(e) ? e.scaleX !== i && e.scaleY !== i && (t.css("transition-duration", "0ms"), e.width = Math.round(t.width() * e.scaleX), e.height = Math.round(t.height() * e.scaleY), e.scaleX = 1, e.scaleY = 1, n.fancybox.setTranslate(t, e)) : r !== !0 && t.removeClass(e), n.isFunction(s) && s(o))
                }), n.isNumeric(o) && t.css("transition-duration", o + "ms"), n.isPlainObject(e) ? n.fancybox.setTranslate(t, e) : t.addClass(e), t.data("timer", setTimeout(function() {
                    t.trigger("transitionend")
                }, o + 16))
            },
            stop: function(t) {
                clearTimeout(t.data("timer")), t.off(h)
            }
        }, n.fn.fancybox = function(t) {
            var e;
            return t = t || {}, e = t.selector || !1, e ? n("body").off("click.fb-start", e).on("click.fb-start", e, {
                options: t
            }, o) : this.off("click.fb-start").on("click.fb-start", {
                items: this,
                options: t
            }, o), this
        }, a.on("click.fb-start", "[data-fancybox]", o)
    }
}(window, document, window.jQuery || jQuery),
function(t) {
    "use strict";
    var e = function(e, n, i) {
            if (e) return i = i || "", "object" === t.type(i) && (i = t.param(i, !0)), t.each(n, function(t, n) {
                e = e.replace("$" + t, n || "")
            }), i.length && (e += (e.indexOf("?") > 0 ? "&" : "?") + i), e
        },
        n = {
            youtube: {
                matcher: /(youtube\.com|youtu\.be|youtube\-nocookie\.com)\/(watch\?(.*&)?v=|v\/|u\/|embed\/?)?(videoseries\?list=(.*)|[\w-]{11}|\?listType=(.*)&list=(.*))(.*)/i,
                params: {
                    autoplay: 1,
                    autohide: 1,
                    fs: 1,
                    rel: 0,
                    hd: 1,
                    wmode: "transparent",
                    enablejsapi: 1,
                    html5: 1
                },
                paramPlace: 8,
                type: "iframe",
                url: "//www.youtube.com/embed/$4",
                thumb: "//img.youtube.com/vi/$4/hqdefault.jpg"
            },
            vimeo: {
                matcher: /^.+vimeo.com\/(.*\/)?([\d]+)(.*)?/,
                params: {
                    autoplay: 1,
                    hd: 1,
                    show_title: 1,
                    show_byline: 1,
                    show_portrait: 0,
                    fullscreen: 1,
                    api: 1
                },
                paramPlace: 3,
                type: "iframe",
                url: "//player.vimeo.com/video/$2"
            },
            metacafe: {
                matcher: /metacafe.com\/watch\/(\d+)\/(.*)?/,
                type: "iframe",
                url: "//www.metacafe.com/embed/$1/?ap=1"
            },
            dailymotion: {
                matcher: /dailymotion.com\/video\/(.*)\/?(.*)/,
                params: {
                    additionalInfos: 0,
                    autoStart: 1
                },
                type: "iframe",
                url: "//www.dailymotion.com/embed/video/$1"
            },
            vine: {
                matcher: /vine.co\/v\/([a-zA-Z0-9\?\=\-]+)/,
                type: "iframe",
                url: "//vine.co/v/$1/embed/simple"
            },
            instagram: {
                matcher: /(instagr\.am|instagram\.com)\/p\/([a-zA-Z0-9_\-]+)\/?/i,
                type: "image",
                url: "//$1/p/$2/media/?size=l"
            },
            gmap_place: {
                matcher: /(maps\.)?google\.([a-z]{2,3}(\.[a-z]{2})?)\/(((maps\/(place\/(.*)\/)?\@(.*),(\d+.?\d+?)z))|(\?ll=))(.*)?/i,
                type: "iframe",
                url: function(t) {
                    return "//maps.google." + t[2] + "/?ll=" + (t[9] ? t[9] + "&z=" + Math.floor(t[10]) + (t[12] ? t[12].replace(/^\//, "&") : "") : t[12]) + "&output=" + (t[12] && t[12].indexOf("layer=c") > 0 ? "svembed" : "embed")
                }
            },
            gmap_search: {
                matcher: /(maps\.)?google\.([a-z]{2,3}(\.[a-z]{2})?)\/(maps\/search\/)(.*)/i,
                type: "iframe",
                url: function(t) {
                    return "//maps.google." + t[2] + "/maps?q=" + t[5].replace("query=", "q=").replace("api=1", "") + "&output=embed"
                }
            }
        };
    t(document).on("onInit.fb", function(i, o) {
        t.each(o.group, function(i, o) {
            var s, r, a, l, c, u, h, d = o.src || "",
                p = !1;
            o.type || (s = t.extend(!0, {}, n, o.opts.media), t.each(s, function(n, i) {
                if (a = d.match(i.matcher), u = {}, h = n, a) {
                    if (p = i.type, i.paramPlace && a[i.paramPlace]) {
                        c = a[i.paramPlace], "?" == c[0] && (c = c.substring(1)), c = c.split("&");
                        for (var s = 0; s < c.length; ++s) {
                            var f = c[s].split("=", 2);
                            2 == f.length && (u[f[0]] = decodeURIComponent(f[1].replace(/\+/g, " ")))
                        }
                    }
                    return l = t.extend(!0, {}, i.params, o.opts[n], u), d = "function" === t.type(i.url) ? i.url.call(this, a, l, o) : e(i.url, a, l), r = "function" === t.type(i.thumb) ? i.thumb.call(this, a, l, o) : e(i.thumb, a), "vimeo" === h && (d = d.replace("&%23", "#")), !1
                }
            }), p ? (o.src = d, o.type = p, o.opts.thumb || o.opts.$thumb && o.opts.$thumb.length || (o.opts.thumb = r), "iframe" === p && (t.extend(!0, o.opts, {
                iframe: {
                    preload: !1,
                    attr: {
                        scrolling: "no"
                    }
                }
            }), o.contentProvider = h, o.opts.slideClass += " fancybox-slide--" + ("gmap_place" == h || "gmap_search" == h ? "map" : "video"))) : o.type = "image")
        })
    })
}(window.jQuery),
function(t, e, n) {
    "use strict";
    var i = function() {
            return t.requestAnimationFrame || t.webkitRequestAnimationFrame || t.mozRequestAnimationFrame || t.oRequestAnimationFrame || function(e) {
                return t.setTimeout(e, 1e3 / 60)
            }
        }(),
        o = function() {
            return t.cancelAnimationFrame || t.webkitCancelAnimationFrame || t.mozCancelAnimationFrame || t.oCancelAnimationFrame || function(e) {
                t.clearTimeout(e)
            }
        }(),
        s = function(e) {
            var n = [];
            e = e.originalEvent || e || t.e, e = e.touches && e.touches.length ? e.touches : e.changedTouches && e.changedTouches.length ? e.changedTouches : [e];
            for (var i in e) e[i].pageX ? n.push({
                x: e[i].pageX,
                y: e[i].pageY
            }) : e[i].clientX && n.push({
                x: e[i].clientX,
                y: e[i].clientY
            });
            return n
        },
        r = function(t, e, n) {
            return e && t ? "x" === n ? t.x - e.x : "y" === n ? t.y - e.y : Math.sqrt(Math.pow(t.x - e.x, 2) + Math.pow(t.y - e.y, 2)) : 0
        },
        a = function(t) {
            if (t.is("a,button,input,select,textarea,label") || n.isFunction(t.get(0).onclick) || t.data("selectable")) return !0;
            for (var e = 0, i = t[0].attributes, o = i.length; e < o; e++)
                if ("data-fancybox-" === i[e].nodeName.substr(0, 14)) return !0;
            return !1
        },
        l = function(e) {
            var n = t.getComputedStyle(e)["overflow-y"],
                i = t.getComputedStyle(e)["overflow-x"],
                o = ("scroll" === n || "auto" === n) && e.scrollHeight > e.clientHeight,
                s = ("scroll" === i || "auto" === i) && e.scrollWidth > e.clientWidth;
            return o || s
        },
        c = function(t) {
            for (var e = !1; !(e = l(t.get(0))) && (t = t.parent(), t.length && !t.hasClass("fancybox-stage") && !t.is("body")););
            return e
        },
        u = function(t) {
            var e = this;
            e.instance = t, e.$bg = t.$refs.bg, e.$stage = t.$refs.stage, e.$container = t.$refs.container, e.destroy(), e.$container.on("touchstart.fb.touch mousedown.fb.touch", n.proxy(e, "ontouchstart"))
        };
    u.prototype.destroy = function() {
        this.$container.off(".fb.touch")
    }, u.prototype.ontouchstart = function(i) {
        var o = this,
            l = n(i.target),
            u = o.instance,
            h = u.current,
            d = h.$content,
            p = "touchstart" == i.type;
        if (p && o.$container.off("mousedown.fb.touch"), !h || o.instance.isAnimating || o.instance.isClosing) return i.stopPropagation(), void i.preventDefault();
        if ((!i.originalEvent || 2 != i.originalEvent.button) && l.length && !a(l) && !a(l.parent()) && !(i.originalEvent.clientX > l[0].clientWidth + l.offset().left) && (o.startPoints = s(i), o.startPoints && !(o.startPoints.length > 1 && u.isSliding))) {
            if (o.$target = l, o.$content = d, o.canTap = !0, n(e).off(".fb.touch"), n(e).on(p ? "touchend.fb.touch touchcancel.fb.touch" : "mouseup.fb.touch mouseleave.fb.touch", n.proxy(o, "ontouchend")), n(e).on(p ? "touchmove.fb.touch" : "mousemove.fb.touch", n.proxy(o, "ontouchmove")), !u.current.opts.touch && !u.canPan() || !l.is(o.$stage) && !o.$stage.find(l).length) return void(l.is("img") && i.preventDefault());
            i.stopPropagation(), n.fancybox.isMobile && (c(o.$target) || c(o.$target.parent())) || i.preventDefault(), o.canvasWidth = Math.round(h.$slide[0].clientWidth), o.canvasHeight = Math.round(h.$slide[0].clientHeight), o.startTime = (new Date).getTime(), o.distanceX = o.distanceY = o.distance = 0, o.isPanning = !1, o.isSwiping = !1, o.isZooming = !1, o.sliderStartPos = o.sliderLastPos || {
                top: 0,
                left: 0
            }, o.contentStartPos = n.fancybox.getTranslate(o.$content), o.contentLastPos = null, 1 !== o.startPoints.length || o.isZooming || (o.canTap = !u.isSliding, "image" === h.type && (o.contentStartPos.width > o.canvasWidth + 1 || o.contentStartPos.height > o.canvasHeight + 1) ? (n.fancybox.stop(o.$content), o.$content.css("transition-duration", "0ms"), o.isPanning = !0) : o.isSwiping = !0, o.$container.addClass("fancybox-controls--isGrabbing")), 2 !== o.startPoints.length || u.isAnimating || h.hasError || "image" !== h.type || !h.isLoaded && !h.$ghost || (o.isZooming = !0, o.isSwiping = !1, o.isPanning = !1, n.fancybox.stop(o.$content), o.$content.css("transition-duration", "0ms"), o.centerPointStartX = .5 * (o.startPoints[0].x + o.startPoints[1].x) - n(t).scrollLeft(), o.centerPointStartY = .5 * (o.startPoints[0].y + o.startPoints[1].y) - n(t).scrollTop(), o.percentageOfImageAtPinchPointX = (o.centerPointStartX - o.contentStartPos.left) / o.contentStartPos.width, o.percentageOfImageAtPinchPointY = (o.centerPointStartY - o.contentStartPos.top) / o.contentStartPos.height, o.startDistanceBetweenFingers = r(o.startPoints[0], o.startPoints[1]))
        }
    }, u.prototype.ontouchmove = function(t) {
        var e = this;
        if (e.newPoints = s(t), n.fancybox.isMobile && (c(e.$target) || c(e.$target.parent()))) return t.stopPropagation(), void(e.canTap = !1);
        if ((e.instance.current.opts.touch || e.instance.canPan()) && e.newPoints && e.newPoints.length && (e.distanceX = r(e.newPoints[0], e.startPoints[0], "x"), e.distanceY = r(e.newPoints[0], e.startPoints[0], "y"), e.distance = r(e.newPoints[0], e.startPoints[0]), e.distance > 0)) {
            if (!e.$target.is(e.$stage) && !e.$stage.find(e.$target).length) return;
            t.stopPropagation(), t.preventDefault(), e.isSwiping ? e.onSwipe() : e.isPanning ? e.onPan() : e.isZooming && e.onZoom()
        }
    }, u.prototype.onSwipe = function() {
        var e, s = this,
            r = s.isSwiping,
            a = s.sliderStartPos.left || 0;
        r === !0 ? Math.abs(s.distance) > 10 && (s.canTap = !1, s.instance.group.length < 2 && s.instance.opts.touch.vertical ? s.isSwiping = "y" : s.instance.isSliding || s.instance.opts.touch.vertical === !1 || "auto" === s.instance.opts.touch.vertical && n(t).width() > 800 ? s.isSwiping = "x" : (e = Math.abs(180 * Math.atan2(s.distanceY, s.distanceX) / Math.PI), s.isSwiping = e > 45 && e < 135 ? "y" : "x"), s.instance.isSliding = s.isSwiping, s.startPoints = s.newPoints, n.each(s.instance.slides, function(t, e) {
            n.fancybox.stop(e.$slide), e.$slide.css("transition-duration", "0ms"), e.inTransition = !1, e.pos === s.instance.current.pos && (s.sliderStartPos.left = n.fancybox.getTranslate(e.$slide).left)
        }), s.instance.SlideShow && s.instance.SlideShow.isActive && s.instance.SlideShow.stop()) : ("x" == r && (s.distanceX > 0 && (s.instance.group.length < 2 || 0 === s.instance.current.index && !s.instance.current.opts.loop) ? a += Math.pow(s.distanceX, .8) : s.distanceX < 0 && (s.instance.group.length < 2 || s.instance.current.index === s.instance.group.length - 1 && !s.instance.current.opts.loop) ? a -= Math.pow(-s.distanceX, .8) : a += s.distanceX), s.sliderLastPos = {
            top: "x" == r ? 0 : s.sliderStartPos.top + s.distanceY,
            left: a
        }, s.requestId && (o(s.requestId), s.requestId = null), s.requestId = i(function() {
            s.sliderLastPos && (n.each(s.instance.slides, function(t, e) {
                var i = e.pos - s.instance.currPos;
                n.fancybox.setTranslate(e.$slide, {
                    top: s.sliderLastPos.top,
                    left: s.sliderLastPos.left + i * s.canvasWidth + i * e.opts.gutter
                })
            }), s.$container.addClass("fancybox-is-sliding"))
        }))
    }, u.prototype.onPan = function() {
        var t, e, s, r = this;
        r.canTap = !1, t = r.contentStartPos.width > r.canvasWidth ? r.contentStartPos.left + r.distanceX : r.contentStartPos.left, e = r.contentStartPos.top + r.distanceY, s = r.limitMovement(t, e, r.contentStartPos.width, r.contentStartPos.height), s.scaleX = r.contentStartPos.scaleX, s.scaleY = r.contentStartPos.scaleY, r.contentLastPos = s, r.requestId && (o(r.requestId), r.requestId = null), r.requestId = i(function() {
            n.fancybox.setTranslate(r.$content, r.contentLastPos)
        })
    }, u.prototype.limitMovement = function(t, e, n, i) {
        var o, s, r, a, l = this,
            c = l.canvasWidth,
            u = l.canvasHeight,
            h = l.contentStartPos.left,
            d = l.contentStartPos.top,
            p = l.distanceX,
            f = l.distanceY;
        return o = Math.max(0, .5 * c - .5 * n), s = Math.max(0, .5 * u - .5 * i), r = Math.min(c - n, .5 * c - .5 * n), a = Math.min(u - i, .5 * u - .5 * i), n > c && (p > 0 && t > o && (t = o - 1 + Math.pow(-o + h + p, .8) || 0), p < 0 && t < r && (t = r + 1 - Math.pow(r - h - p, .8) || 0)), i > u && (f > 0 && e > s && (e = s - 1 + Math.pow(-s + d + f, .8) || 0), f < 0 && e < a && (e = a + 1 - Math.pow(a - d - f, .8) || 0)), {
            top: e,
            left: t
        }
    }, u.prototype.limitPosition = function(t, e, n, i) {
        var o = this,
            s = o.canvasWidth,
            r = o.canvasHeight;
        return n > s ? (t = t > 0 ? 0 : t, t = t < s - n ? s - n : t) : t = Math.max(0, s / 2 - n / 2), i > r ? (e = e > 0 ? 0 : e, e = e < r - i ? r - i : e) : e = Math.max(0, r / 2 - i / 2), {
            top: e,
            left: t
        }
    }, u.prototype.onZoom = function() {
        var e = this,
            s = e.contentStartPos.width,
            a = e.contentStartPos.height,
            l = e.contentStartPos.left,
            c = e.contentStartPos.top,
            u = r(e.newPoints[0], e.newPoints[1]),
            h = u / e.startDistanceBetweenFingers,
            d = Math.floor(s * h),
            p = Math.floor(a * h),
            f = (s - d) * e.percentageOfImageAtPinchPointX,
            g = (a - p) * e.percentageOfImageAtPinchPointY,
            m = (e.newPoints[0].x + e.newPoints[1].x) / 2 - n(t).scrollLeft(),
            v = (e.newPoints[0].y + e.newPoints[1].y) / 2 - n(t).scrollTop(),
            y = m - e.centerPointStartX,
            b = v - e.centerPointStartY,
            x = l + (f + y),
            w = c + (g + b),
            C = {
                top: w,
                left: x,
                scaleX: e.contentStartPos.scaleX * h,
                scaleY: e.contentStartPos.scaleY * h
            };
        e.canTap = !1, e.newWidth = d, e.newHeight = p, e.contentLastPos = C, e.requestId && (o(e.requestId), e.requestId = null), e.requestId = i(function() {
            n.fancybox.setTranslate(e.$content, e.contentLastPos)
        })
    }, u.prototype.ontouchend = function(t) {
        var i = this,
            r = Math.max((new Date).getTime() - i.startTime, 1),
            a = i.isSwiping,
            l = i.isPanning,
            c = i.isZooming;
        return i.endPoints = s(t), i.$container.removeClass("fancybox-controls--isGrabbing"), n(e).off(".fb.touch"), i.requestId && (o(i.requestId), i.requestId = null), i.isSwiping = !1, i.isPanning = !1, i.isZooming = !1, i.canTap ? i.onTap(t) : (i.speed = 366, i.velocityX = i.distanceX / r * .5, i.velocityY = i.distanceY / r * .5, i.speedX = Math.max(.5 * i.speed, Math.min(1.5 * i.speed, 1 / Math.abs(i.velocityX) * i.speed)), void(l ? i.endPanning() : c ? i.endZooming() : i.endSwiping(a)))
    }, u.prototype.endSwiping = function(t) {
        var e = this,
            i = !1;
        e.instance.isSliding = !1, e.sliderLastPos = null, "y" == t && Math.abs(e.distanceY) > 50 ? (n.fancybox.animate(e.instance.current.$slide, {
            top: e.sliderStartPos.top + e.distanceY + 150 * e.velocityY,
            opacity: 0
        }, 150), i = e.instance.close(!0, 300)) : "x" == t && e.distanceX > 50 && e.instance.group.length > 1 ? i = e.instance.previous(e.speedX) : "x" == t && e.distanceX < -50 && e.instance.group.length > 1 && (i = e.instance.next(e.speedX)), i !== !1 || "x" != t && "y" != t || e.instance.jumpTo(e.instance.current.index, 150), e.$container.removeClass("fancybox-is-sliding")
    }, u.prototype.endPanning = function() {
        var t, e, i, o = this;
        o.contentLastPos && (o.instance.current.opts.touch.momentum === !1 ? (t = o.contentLastPos.left, e = o.contentLastPos.top) : (t = o.contentLastPos.left + o.velocityX * o.speed, e = o.contentLastPos.top + o.velocityY * o.speed), i = o.limitPosition(t, e, o.contentStartPos.width, o.contentStartPos.height), i.width = o.contentStartPos.width, i.height = o.contentStartPos.height, n.fancybox.animate(o.$content, i, 330))
    }, u.prototype.endZooming = function() {
        var t, e, i, o, s = this,
            r = s.instance.current,
            a = s.newWidth,
            l = s.newHeight;
        s.contentLastPos && (t = s.contentLastPos.left, e = s.contentLastPos.top, o = {
            top: e,
            left: t,
            width: a,
            height: l,
            scaleX: 1,
            scaleY: 1
        }, n.fancybox.setTranslate(s.$content, o), a < s.canvasWidth && l < s.canvasHeight ? s.instance.scaleToFit(150) : a > r.width || l > r.height ? s.instance.scaleToActual(s.centerPointStartX, s.centerPointStartY, 150) : (i = s.limitPosition(t, e, a, l), n.fancybox.setTranslate(s.content, n.fancybox.getTranslate(s.$content)), n.fancybox.animate(s.$content, i, 150)))
    }, u.prototype.onTap = function(t) {
        var e, i = this,
            o = n(t.target),
            r = i.instance,
            a = r.current,
            l = t && s(t) || i.startPoints,
            c = l[0] ? l[0].x - i.$stage.offset().left : 0,
            u = l[0] ? l[0].y - i.$stage.offset().top : 0,
            h = function(e) {
                var o = a.opts[e];
                if (n.isFunction(o) && (o = o.apply(r, [a, t])), o) switch (o) {
                    case "close":
                        r.close(i.startEvent);
                        break;
                    case "toggleControls":
                        r.toggleControls(!0);
                        break;
                    case "next":
                        r.next();
                        break;
                    case "nextOrClose":
                        r.group.length > 1 ? r.next() : r.close(i.startEvent);
                        break;
                    case "zoom":
                        "image" == a.type && (a.isLoaded || a.$ghost) && (r.canPan() ? r.scaleToFit() : r.isScaledDown() ? r.scaleToActual(c, u) : r.group.length < 2 && r.close(i.startEvent))
                }
            };
        if (!(t.originalEvent && 2 == t.originalEvent.button || r.isSliding || c > o[0].clientWidth + o.offset().left)) {
            if (o.is(".fancybox-bg,.fancybox-inner,.fancybox-outer,.fancybox-container")) e = "Outside";
            else if (o.is(".fancybox-slide")) e = "Slide";
            else {
                if (!r.current.$content || !r.current.$content.has(t.target).length) return;
                e = "Content"
            }
            if (i.tapped) {
                if (clearTimeout(i.tapped), i.tapped = null, Math.abs(c - i.tapX) > 50 || Math.abs(u - i.tapY) > 50 || r.isSliding) return this;
                h("dblclick" + e)
            } else i.tapX = c, i.tapY = u, a.opts["dblclick" + e] && a.opts["dblclick" + e] !== a.opts["click" + e] ? i.tapped = setTimeout(function() {
                i.tapped = null, h("click" + e)
            }, 300) : h("click" + e);
            return this
        }
    }, n(e).on("onActivate.fb", function(t, e) {
        e && !e.Guestures && (e.Guestures = new u(e))
    }), n(e).on("beforeClose.fb", function(t, e) {
        e && e.Guestures && e.Guestures.destroy()
    })
}(window, document, window.jQuery),
function(t, e) {
    "use strict";
    var n = function(t) {
        this.instance = t, this.init()
    };
    e.extend(n.prototype, {
        timer: null,
        isActive: !1,
        $button: null,
        speed: 3e3,
        init: function() {
            var t = this;
            t.$button = t.instance.$refs.toolbar.find("[data-fancybox-play]").on("click", function() {
                t.toggle()
            }), (t.instance.group.length < 2 || !t.instance.group[t.instance.currIndex].opts.slideShow) && t.$button.hide()
        },
        set: function() {
            var t = this;
            t.instance && t.instance.current && (t.instance.current.opts.loop || t.instance.currIndex < t.instance.group.length - 1) ? t.timer = setTimeout(function() {
                t.instance.next()
            }, t.instance.current.opts.slideShow.speed || t.speed) : (t.stop(), t.instance.idleSecondsCounter = 0, t.instance.showControls())
        },
        clear: function() {
            var t = this;
            clearTimeout(t.timer), t.timer = null
        },
        start: function() {
            var t = this,
                e = t.instance.current;
            t.instance && e && (e.opts.loop || e.index < t.instance.group.length - 1) && (t.isActive = !0, t.$button.attr("title", e.opts.i18n[e.opts.lang].PLAY_STOP).addClass("fancybox-button--pause"), e.isComplete && t.set())
        },
        stop: function() {
            var t = this,
                e = t.instance.current;
            t.clear(), t.$button.attr("title", e.opts.i18n[e.opts.lang].PLAY_START).removeClass("fancybox-button--pause"), t.isActive = !1
        },
        toggle: function() {
            var t = this;
            t.isActive ? t.stop() : t.start()
        }
    }), e(t).on({
        "onInit.fb": function(t, e) {
            e && !e.SlideShow && (e.SlideShow = new n(e))
        },
        "beforeShow.fb": function(t, e, n, i) {
            var o = e && e.SlideShow;
            i ? o && n.opts.slideShow.autoStart && o.start() : o && o.isActive && o.clear()
        },
        "afterShow.fb": function(t, e, n) {
            var i = e && e.SlideShow;
            i && i.isActive && i.set()
        },
        "afterKeydown.fb": function(n, i, o, s, r) {
            var a = i && i.SlideShow;
            !a || !o.opts.slideShow || 80 !== r && 32 !== r || e(t.activeElement).is("button,a,input") || (s.preventDefault(), a.toggle())
        },
        "beforeClose.fb onDeactivate.fb": function(t, e) {
            var n = e && e.SlideShow;
            n && n.stop()
        }
    }), e(t).on("visibilitychange", function() {
        var n = e.fancybox.getInstance(),
            i = n && n.SlideShow;
        i && i.isActive && (t.hidden ? i.clear() : i.set())
    })
}(document, window.jQuery),
function(t, e) {
    "use strict";
    var n = function() {
        var e, n, i, o = [
                ["requestFullscreen", "exitFullscreen", "fullscreenElement", "fullscreenEnabled", "fullscreenchange", "fullscreenerror"],
                ["webkitRequestFullscreen", "webkitExitFullscreen", "webkitFullscreenElement", "webkitFullscreenEnabled", "webkitfullscreenchange", "webkitfullscreenerror"],
                ["webkitRequestFullScreen", "webkitCancelFullScreen", "webkitCurrentFullScreenElement", "webkitCancelFullScreen", "webkitfullscreenchange", "webkitfullscreenerror"],
                ["mozRequestFullScreen", "mozCancelFullScreen", "mozFullScreenElement", "mozFullScreenEnabled", "mozfullscreenchange", "mozfullscreenerror"],
                ["msRequestFullscreen", "msExitFullscreen", "msFullscreenElement", "msFullscreenEnabled", "MSFullscreenChange", "MSFullscreenError"]
            ],
            s = {};
        for (n = 0; n < o.length; n++)
            if (e = o[n], e && e[1] in t) {
                for (i = 0; i < e.length; i++) s[o[0][i]] = e[i];
                return s
            }
        return !1
    }();
    if (!n) return void(e && e.fancybox && (e.fancybox.defaults.btnTpl.fullScreen = !1));
    var i = {
        request: function(e) {
            e = e || t.documentElement, e[n.requestFullscreen](e.ALLOW_KEYBOARD_INPUT)
        },
        exit: function() {
            t[n.exitFullscreen]()
        },
        toggle: function(e) {
            e = e || t.documentElement, this.isFullscreen() ? this.exit() : this.request(e)
        },
        isFullscreen: function() {
            return Boolean(t[n.fullscreenElement])
        },
        enabled: function() {
            return Boolean(t[n.fullscreenEnabled])
        }
    };
    e(t).on({
        "onInit.fb": function(t, e) {
            var n, o = e.$refs.toolbar.find("[data-fancybox-fullscreen]");
            e && !e.FullScreen && e.group[e.currIndex].opts.fullScreen ? (n = e.$refs.container, n.on("click.fb-fullscreen", "[data-fancybox-fullscreen]", function(t) {
                t.stopPropagation(), t.preventDefault(), i.toggle(n[0])
            }), e.opts.fullScreen && e.opts.fullScreen.autoStart === !0 && i.request(n[0]), e.FullScreen = i) : o.hide()
        },
        "afterKeydown.fb": function(t, e, n, i, o) {
            e && e.FullScreen && 70 === o && (i.preventDefault(), e.FullScreen.toggle(e.$refs.container[0]))
        },
        "beforeClose.fb": function(t) {
            t && t.FullScreen && i.exit()
        }
    }), e(t).on(n.fullscreenchange, function() {
        var t = e.fancybox.getInstance();
        t.current && "image" === t.current.type && t.isAnimating && (t.current.$content.css("transition", "none"), t.isAnimating = !1, t.update(!0, !0, 0)), t.trigger("onFullscreenChange", i.isFullscreen())
    })
}(document, window.jQuery),
function(t, e) {
    "use strict";
    var n = function(t) {
        this.instance = t, this.init()
    };
    e.extend(n.prototype, {
        $button: null,
        $grid: null,
        $list: null,
        isVisible: !1,
        init: function() {
            var t = this,
                e = t.instance.group[0],
                n = t.instance.group[1];
            t.$button = t.instance.$refs.toolbar.find("[data-fancybox-thumbs]"), t.instance.group.length > 1 && t.instance.group[t.instance.currIndex].opts.thumbs && ("image" == e.type || e.opts.thumb || e.opts.$thumb) && ("image" == n.type || n.opts.thumb || n.opts.$thumb) ? (t.$button.on("click", function() {
                t.toggle()
            }), t.isActive = !0) : (t.$button.hide(), t.isActive = !1)
        },
        create: function() {
            var t, n, i = this.instance;
            this.$grid = e('<div class="fancybox-thumbs"></div>').appendTo(i.$refs.container), t = "<ul>", e.each(i.group, function(e, i) {
                n = i.opts.thumb || (i.opts.$thumb ? i.opts.$thumb.attr("src") : null), n || "image" !== i.type || (n = i.src), n && n.length && (t += '<li data-index="' + e + '"  tabindex="0" class="fancybox-thumbs-loading"><img data-src="' + n + '" /></li>')
            }), t += "</ul>", this.$list = e(t).appendTo(this.$grid).on("click", "li", function() {
                i.jumpTo(e(this).data("index"))
            }), this.$list.find("img").hide().one("load", function() {
                var t, n, i, o, s = e(this).parent().removeClass("fancybox-thumbs-loading"),
                    r = s.outerWidth(),
                    a = s.outerHeight();
                t = this.naturalWidth || this.width, n = this.naturalHeight || this.height, i = t / r, o = n / a, i >= 1 && o >= 1 && (i > o ? (t /= o, n = a) : (t = r, n /= i)), e(this).css({
                    width: Math.floor(t),
                    height: Math.floor(n),
                    "margin-top": Math.min(0, Math.floor(.3 * a - .3 * n)),
                    "margin-left": Math.min(0, Math.floor(.5 * r - .5 * t))
                }).show()
            }).each(function() {
                this.src = e(this).data("src")
            })
        },
        focus: function() {
            this.instance.current && this.$list.children().removeClass("fancybox-thumbs-active").filter('[data-index="' + this.instance.current.index + '"]').addClass("fancybox-thumbs-active").focus()
        },
        close: function() {
            this.$grid.hide()
        },
        update: function() {
            this.instance.$refs.container.toggleClass("fancybox-show-thumbs", this.isVisible), this.isVisible ? (this.$grid || this.create(), this.instance.trigger("onThumbsShow"), this.focus()) : this.$grid && this.instance.trigger("onThumbsHide"), this.instance.update()
        },
        hide: function() {
            this.isVisible = !1, this.update()
        },
        show: function() {
            this.isVisible = !0, this.update()
        },
        toggle: function() {
            this.isVisible = !this.isVisible, this.update()
        }
    }), e(t).on({
        "onInit.fb": function(t, e) {
            e && !e.Thumbs && (e.Thumbs = new n(e))
        },
        "beforeShow.fb": function(t, e, n, i) {
            var o = e && e.Thumbs;
            if (o && o.isActive) {
                if (n.modal) return o.$button.hide(), void o.hide();
                i && n.opts.thumbs.autoStart === !0 && o.show(), o.isVisible && o.focus()
            }
        },
        "afterKeydown.fb": function(t, e, n, i, o) {
            var s = e && e.Thumbs;
            s && s.isActive && 71 === o && (i.preventDefault(), s.toggle())
        },
        "beforeClose.fb": function(t, e) {
            var n = e && e.Thumbs;
            n && n.isVisible && e.opts.thumbs.hideOnClose !== !1 && n.close()
        }
    })
}(document, window.jQuery),
function(t, e, n) {
    "use strict";

    function i() {
        var t = e.location.hash.substr(1),
            n = t.split("-"),
            i = n.length > 1 && /^\+?\d+$/.test(n[n.length - 1]) ? parseInt(n.pop(-1), 10) || 1 : 1,
            o = n.join("-");
        return i < 1 && (i = 1), {
            hash: t,
            index: i,
            gallery: o
        }
    }

    function o(t) {
        var e;
        "" !== t.gallery && (e = n("[data-fancybox='" + n.escapeSelector(t.gallery) + "']").eq(t.index - 1), e.length || (e = n("#" + n.escapeSelector(t.gallery))), e.length && (r = !1, e.trigger("click")))
    }

    function s(t) {
        var e;
        return !!t && (e = t.current ? t.current.opts : t.opts, e.hash || (e.$orig ? e.$orig.data("fancybox") : ""))
    }
    n.escapeSelector || (n.escapeSelector = function(t) {
        var e = /([\0-\x1f\x7f]|^-?\d)|^-$|[^\x80-\uFFFF\w-]/g,
            n = function(t, e) {
                return e ? "\0" === t ? "�" : t.slice(0, -1) + "\\" + t.charCodeAt(t.length - 1).toString(16) + " " : "\\" + t
            };
        return (t + "").replace(e, n)
    });
    var r = !0,
        a = null,
        l = null;
    n(function() {
        setTimeout(function() {
            n.fancybox.defaults.hash !== !1 && (n(t).on({
                "onInit.fb": function(t, e) {
                    var n, o;
                    e.group[e.currIndex].opts.hash !== !1 && (n = i(), o = s(e), o && n.gallery && o == n.gallery && (e.currIndex = n.index - 1))
                },
                "beforeShow.fb": function(n, i, o) {
                    var c;
                    o && o.opts.hash !== !1 && (c = s(i), c && "" !== c && (e.location.hash.indexOf(c) < 0 && (i.opts.origHash = e.location.hash), a = c + (i.group.length > 1 ? "-" + (o.index + 1) : ""), "replaceState" in e.history ? (l && clearTimeout(l), l = setTimeout(function() {
                        e.history[r ? "pushState" : "replaceState"]({}, t.title, e.location.pathname + e.location.search + "#" + a), l = null, r = !1
                    }, 300)) : e.location.hash = a))
                },
                "beforeClose.fb": function(i, o, r) {
                    var c, u;
                    l && clearTimeout(l), r.opts.hash !== !1 && (c = s(o), u = o && o.opts.origHash ? o.opts.origHash : "", c && "" !== c && ("replaceState" in history ? e.history.replaceState({}, t.title, e.location.pathname + e.location.search + u) : (e.location.hash = u, n(e).scrollTop(o.scrollTop).scrollLeft(o.scrollLeft))), a = null)
                }
            }), n(e).on("hashchange.fb", function() {
                var t = i();
                n.fancybox.getInstance() ? !a || a === t.gallery + "-" + t.index || 1 === t.index && a == t.gallery || (a = null, n.fancybox.close()) : "" !== t.gallery && o(t)
            }), o(i()))
        }, 50)
    })
}(document, window, window.jQuery);